import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { CustomerSite } from 'src/app/Models/CustomerSite';
import { CustomerSiteAddress } from 'src/app/Models/CustomersiteAddress';
import { CustomerSiteContact } from 'src/app/Models/Customersitecontact';
'src/app/Models/Customersitecontact';
import { CustomerSiteSpecialDelivery } from 'src/app/Models/CustomerSiteSpecialDelivery';
import { CustomerSiteTAT } from 'src/app/Models/CustomerSiteTAT';
import { CustomerSiteOperation } from 'src/app/Models/ServiceLocationAndOperation';
import { CustomerinformationService } from 'src/app/Services/customerinformation.service';
import { ServiceLocationAndOperationService } from 'src/app/Services/service-location-and-operation.service';
import { vContract, vContract2D, vContractArticle, vContractRegion, vContractSlab, vcusEmailID, vCustomersite, vServiceLocations, vSUK } from 'src/app/Validators/validation';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { ExportUtility } from 'src/assets/js/export-utility';
import * as XLSX from 'xlsx';
import { FileUpload } from 'primeng/fileupload';
import { ExistingvendorService } from 'src/app/Services/existingvendor.service';
import { CustomerSiteVendor } from 'src/app/Models/CustomerSiteVendor';
import { CustomerSiteTradeReference } from 'src/app/Models/CustomerSiteTradeReference';
import { TradereferenceService } from 'src/app/Services/tradereference.service';
import { KeyPress } from 'src/assets/js/KeyPress';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CustomerSUKService } from 'src/app/Services/customer-suk.service';
import { CustomerSiteSKUList } from 'src/app/Models/CustomerSiteSKUList';
import { APIService } from 'src/app/Services/api.service';
import { MapsAPILoader } from '@agm/core';
import { parse } from 'querystring';
import { CustomerSiteContractAddOnCharge } from 'src/app/Models/CustomerSiteContractAddOnCharge';
import { CustomerSiteContract } from 'src/app/Models/CustomerSiteContract';
import { CustomerSiteCostAndContractService } from 'src/app/Services/customer-site-cost-and-contract.service';
import { CustomerSiteContractRegion } from 'src/app/Models/CustomerSiteContractRegion';
import { CustomerSiteContractArticle } from 'src/app/Models/CustomerSiteContractArticle';
import { CustomerSiteContractSlab } from 'src/app/Models/CustomerSiteContractSlab';
import { CustomerSiteContractTwoD } from 'src/app/Models/CustomerSiteContractTwoD';

// import * as ace from "ace-builds";
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { Logs } from 'selenium-webdriver';
import { Approval } from 'src/app/Models/Approval';
import { Customer } from 'src/app/Models/Customer';
import { CustomerContractService } from 'src/app/Services/customer-contract.service';
import { Console } from 'console';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-v-customer-contract',
  templateUrl: './v-customer-contract.component.html',
  styleUrls: ['./v-customer-contract.component.css']
})
export class VCustomerContractComponent implements OnInit {

  //Customer Informations
  _Customer: Customer;
  listCustomername: any[];
  customersitecode: string;
  contractcode: string;
  customercode: any[];
  selectedtabContract: number = 5;
  _selectedDocumentsContract: File[] = [];
  _ContractOBJ: any
  public _Url = environment.Url;

  _IsProgressSpinner: boolean = false;
  _CustomerSiteform: FormGroup;
  _CustomerAddressPickupform: FormGroup;
  _CustomerAddressBillingform: FormGroup;
  _CustomerContactPickform: FormGroup;
  _State: any[]
  _Region: any[]
  pincodelocation: any[]
  CustomerCode: string
  CustomersiteCode: string
  _CustomerSiteCode: string
  _submitted: boolean = false;
  GstValidationStatusCode: string
  validationStatusCode: string
  selectedtabquote: number = 0
  id: any
  _TempServiceLocationsCode: any
  SpecialDeliveryList: any[] = [];
  tatBasedDetail: string
  TATDetails: any[] = [];
  VolumeList: any[]
  _OdaList: any
  _FlatOdaList: any
  outsideCompanyList: CustomerSiteTradeReference[] = [];
  WithinCompanyList: CustomerSiteTradeReference[] = [];
  TempWithinCompanyList: CustomerSiteTradeReference[] = []
  TempoutsideCompanyList: CustomerSiteTradeReference[] = []
  CompanyList: any[] = []
  _ContractType: any
  _ServiceLocationAndOperation_Form: FormGroup
  currentFile: File;
  arrayBuffer: any
  VolumeReferList: any[]
  ExistingVendorList: CustomerSiteVendor[] = []
  _TempTierCode: any
  _TempPODCode: any
  SUKList: any[] = [];
  SUKVolumeDistrubutionList: any[] = [];
  _SLsubmitted: boolean = false
  latitude: number = 0;
  longitude: number = 0;
  QuantityPer: any = 0
  volumeQuantity: any = 0
  _VolBasedOn: any = [
    { volumetricid: '1', volumetricname: 'CFT' },
    { volumetricid: '2', volumetricname: 'Actual Weight' }
  ]
  ApprovalCommentsList: any[] = [];
  /////////////////////---------------Cost and Contract --------------////////////////////////////
  //---------------- Region Level -------------------//
  _BillingBranch: any[];
  _InclusiveExclusive: any[];
  _ToBranch: any[];
  _ArticleName: any[];
  _RatePerQuintal: any[];
  _Distance: any[];
  _RateType: any[];
  _DCRateType: any[];
  _DDRateType: any[];
  _ArticleChargeCode: any[];
  _AddonCharges: any[];
  displayACRateType: boolean;
  displayDCRate: boolean;
  displayDCRateKG: boolean;
  displayDDRate: boolean;
  displayDDRateKG: boolean;
  displayACRate: boolean;
  displayACRateKG: boolean;
  _RegionLevelForm: FormGroup
  _CostingContract: FormGroup
  _FromDCPiece: string;
  _ToDCPiece: string;
  _RateDCPiece: string;
  _FromDCKG: string;
  _ToDCKG: string;
  _RateDCKG: string;
  _FromDDPiece: string;
  _ToDDPiece: string;
  _RateDDPiece: string;
  _FromDDKG: string;
  _ToDDKG: string;
  _RateDDKG: string;
  _FromACPiece: string;
  _ToACPiece: string;
  _RateACPiece: string;
  _FromACKG: string;
  _ToACKG: string;
  _RateACKG: string;
  _DCPiece: any[] = [];
  _DCKG: any[] = [];
  _DDPiece: any[] = [];
  _DDKG: any[] = [];
  _ACPiece: any[] = [];
  _ACKG: any[] = [];
  _RegionList: any[] = [];
  _updateRowRegion: boolean = true;
  _addRowRegion: boolean = false;
  _RegionIndex: any = null;
  _RegionLevelFormsubmitted: boolean = false
  _SlabType: any[];
  _Quote: any
  _SkuTypeList: any[]

  //---------------- Article Based -------------------//

  displayACRateTypeAB: boolean;
  displayDCRateAB: boolean;
  displayDCRateKGAB: boolean;
  displayDDRateAB: boolean;
  displayDDRateKGAB: boolean;
  displayACRateAB: boolean;
  displayACRateKGAB: boolean;
  _ArticleBasedForm: FormGroup
  _FromDCPieceAB: string;
  _ToDCPieceAB: string;
  _RateDCPieceAB: string;
  _FromDCKGAB: string;
  _ToDCKGAB: string;
  _RateDCKGAB: string;
  _FromDDPieceAB: string;
  _ToDDPieceAB: string;
  _RateDDPieceAB: string;
  _FromDDKGAB: string;
  _ToDDKGAB: string;
  _RateDDKGAB: string;
  _FromACPieceAB: string;
  _ToACPieceAB: string;
  _RateACPieceAB: string;
  _FromACKGAB: string;
  _ToACKGAB: string;
  _RateACKGAB: string;
  _DCPieceAB: any[] = [];
  _DCKGAB: any[] = [];
  _DDPieceAB: any[] = [];
  _DDKGAB: any[] = [];
  _ACPieceAB: any[] = [];
  _ACKGAB: any[] = [];
  _ArticleBasedList: any[] = [];
  _updateRowArticleBased: boolean = true;
  _addRowArticleBased: boolean = false;
  _ArticleBasedIndex: any = null;
  _ArticleBasedFormsubmitted: boolean = false
  _Articleselectedrows: any[] = []
  _TEMPArticleBasedList: any[] = []


  //---------------- Slab -------------------//
  displaySlab: boolean;
  displayKGSlab: boolean;
  displayACRateTypeSlab: boolean;
  displayDCRateSlab: boolean;
  displayDCRateKGSlab: boolean;
  displayDDRateSlab: boolean;
  displayDDRateKGSlab: boolean;
  displayACRateSlab: boolean;
  displayACRateKGSlab: boolean;
  _SlabForm: FormGroup
  _FromPieceSlab: string;
  _ToPieceSlab: string;
  _RatePieceSlab: string;
  _FromKGSlab: string;
  _ToKGSlab: string;
  _RateKGSlab: string;
  _FromDCPieceSlab: string;
  _ToDCPieceSlab: string;
  _RateDCPieceSlab: string;
  _FromDCKGSlab: string;
  _ToDCKGSlab: string;
  _RateDCKGSlab: string;
  _FromDDPieceSlab: string;
  _ToDDPieceSlab: string;
  _RateDDPieceSlab: string;
  _FromDDKGSlab: string;
  _ToDDKGSlab: string;
  _RateDDKGSlab: string;
  _FromACPieceSlab: string;
  _ToACPieceSlab: string;
  _RateACPieceSlab: string;
  _FromACKGSlab: string;
  _ToACKGSlab: string;
  _RateACKGSlab: string;
  _PieceSlab: any[] = [];
  _KGSlab: any[] = [];
  _DCPieceSlab: any[] = [];
  _DCKGSlab: any[] = [];
  _DDPieceSlab: any[] = [];
  _DDKGSlab: any[] = [];
  _ACPieceSlab: any[] = [];
  _ACKGSlab: any[] = [];
  _SlabFormList: any[] = [];
  _updateRowSlab: boolean = true;
  _addRowSlab: boolean = false;
  _SlabIndex: any = null;
  _SlabFormsubmitted: boolean = false



  //---------------- 2D -------------------//
  display2D: boolean;
  displayKG2D: boolean;
  displayACRateType2D: boolean;
  displayDCRate2D: boolean;
  displayDCRateKG2D: boolean;
  displayDDRate2D: boolean;
  displayDDRateKG2D: boolean;
  displayACRate2D: boolean;
  displayACRateKG2D: boolean;
  _2DForm: FormGroup
  _FromPiece2D: string;
  _ToPiece2D: string;
  _RatePiece2D: string;
  _FromKG2D: string;
  _ToKG2D: string;
  _RateKG2D: string;
  _FromDCPiece2D: string;
  _ToDCPiece2D: string;
  _RateDCPiece2D: string;
  _FromDCKG2D: string;
  _ToDCKG2D: string;
  _RateDCKG2D: string;
  _FromDDPiece2D: string;
  _ToDDPiece2D: string;
  _RateDDPiece2D: string;
  _FromDDKG2D: string;
  _ToDDKG2D: string;
  _RateDDKG2D: string;
  _FromACPiece2D: string;
  _ToACPiece2D: string;
  _RateACPiece2D: string;
  _FromACKG2D: string;
  _ToACKG2D: string;
  _RateACKG2D: string;
  _Piece2D: any[] = [];
  _KG2D: any[] = [];
  _DCPiece2D: any[] = [];
  _DCKG2D: any[] = [];
  _DDPiece2D: any[] = [];
  _DDKG2D: any[] = [];
  _ACPiece2D: any[] = [];
  _ACKG2D: any[] = [];
  _2DList: any[] = [];
  _updateRow2D: boolean = true;
  _addRow2D: boolean = false;
  _2DIndex: any = null;
  _2DFormsubmitted: boolean = false

  ///////--------------Way Bill-------------//////////////

  displayRateTypeWayBill: boolean;
  displayPieceWayBill: boolean;
  displayKGWayBill: boolean;
  displayPieceKGWayBill: boolean;
  _WaybillForm: FormGroup
  _FromPieceWayBill: string;
  _ToPieceWayBill: string;
  _RatePieceWayBill: string;
  _FromKGWayBill: string;
  _ToKGWayBill: string;
  _RateKGWayBill: string;
  _FromPieceKGWayBill: string;
  _ToPieceKGWayBill: string;
  _RatePieceKGWayBill: string;
  WayBillList: CustomerSiteContractAddOnCharge[] = [];
  _PieceWayBill: any[] = [];
  _KGWayBill: any[] = [];
  _PieceKGWayBill: any[] = [];
  _AddOnChargeType: any[];
  _updateRowWayBill: boolean = true;
  _addRowWayBill: boolean = false;
  _WayBillIndex: any = null;
  _WaybillFormsubmitted: boolean = false

  _TempPieceKG: string;
  HideDCPieceAdditionalRate: boolean = true
  HideDCPieceAdditionalRateMsg: boolean = true
  _DCPieceAdditionalRate: string;
  HideDCKGAdditionalRate: boolean = true
  _DCKGAdditionalRate: string;
  HideDCKGAdditionalRateMsg: boolean = true

  HideDDPieceAdditionalRate: boolean = true
  HideDDPieceAdditionalRateMsg: boolean = true
  _DDPieceAdditionalRate: string;
  HideDDKGAdditionalRate: boolean = true
  _DDKGAdditionalRate: string;
  HideDDKGAdditionalRateMsg: boolean = true

  HideACPieceAdditionalRate: boolean = true
  HideACPieceAdditionalRateMsg: boolean = true
  _ACPieceAdditionalRate: string;
  HideACKGAdditionalRate: boolean = true
  _ACKGAdditionalRate: string;
  HideACKGAdditionalRateMsg: boolean = true

  HideDCPieceAdditionalRateAB: boolean = true
  HideDCPieceAdditionalRateMsgAB: boolean = true
  _DCPieceAdditionalRateAB: string;
  HideDCKGAdditionalRateAB: boolean = true
  _DCKGAdditionalRateAB: string;
  HideDCKGAdditionalRateMsgAB: boolean = true

  HideDDPieceAdditionalRateAB: boolean = true
  HideDDPieceAdditionalRateMsgAB: boolean = true
  _DDPieceAdditionalRateAB: string;
  HideDDKGAdditionalRateAB: boolean = true
  _DDKGAdditionalRateAB: string;
  HideDDKGAdditionalRateMsgAB: boolean = true

  HideACPieceAdditionalRateAB: boolean = true
  HideACPieceAdditionalRateMsgAB: boolean = true
  _ACPieceAdditionalRateAB: string;
  HideACKGAdditionalRateAB: boolean = true
  _ACKGAdditionalRateAB: string;
  HideACKGAdditionalRateMsgAB: boolean = true

  HideDCPieceAdditionalRateSP: boolean = true
  HideDCPieceAdditionalRateMsgSP: boolean = true
  _DCPieceAdditionalRateSP: string;
  HideDCKGAdditionalRateSP: boolean = true
  _DCKGAdditionalRateSP: string;
  HideDCKGAdditionalRateMsgSP: boolean = true

  HideDDPieceAdditionalRateSP: boolean = true
  HideDDPieceAdditionalRateMsgSP: boolean = true
  _DDPieceAdditionalRateSP: string;
  HideDDKGAdditionalRateSP: boolean = true
  _DDKGAdditionalRateSP: string;
  HideDDKGAdditionalRateMsgSP: boolean = true

  HideACPieceAdditionalRateSP: boolean = true
  HideACPieceAdditionalRateMsgSP: boolean = true
  _ACPieceAdditionalRateSP: string;
  HideACKGAdditionalRateSP: boolean = true
  _ACKGAdditionalRateSP: string;
  HideACKGAdditionalRateMsgSP: boolean = true


  HideDCPieceAdditionalRate2D: boolean = true
  HideDCPieceAdditionalRateMsg2D: boolean = true
  _DCPieceAdditionalRate2D: string;
  HideDCKGAdditionalRate2D: boolean = true
  _DCKGAdditionalRate2D: string;
  HideDCKGAdditionalRateMsg2D: boolean = true

  HideDDPieceAdditionalRate2D: boolean = true
  HideDDPieceAdditionalRateMsg2D: boolean = true
  _DDPieceAdditionalRate2D: string;
  HideDDKGAdditionalRate2D: boolean = true
  _DDKGAdditionalRate2D: string;
  HideDDKGAdditionalRateMsg2D: boolean = true

  HideACPieceAdditionalRate2D: boolean = true
  HideACPieceAdditionalRateMsg2D: boolean = true
  _ACPieceAdditionalRate2D: string;
  HideACKGAdditionalRate2D: boolean = true
  _ACKGAdditionalRate2D: string;
  HideACKGAdditionalRateMsg2D: boolean = true
  displaySuccessMSG: boolean = false;

  _ArticleFrom: string;
  _ArticleTo: string;
  _ArticleCharges: string;
  _KGFrom: string;
  _KGTo: string;
  _KGCharges: string;
  _KGList: any[] = [];
  _ArticleList: any[] = [];
  currentFileContract: File;
  _TempcurrentFileContract: File;

  CustomerSiteContractList: CustomerSiteContract;
  _CustomerSiteContractGeneralForm: FormGroup;
  _contracttypescode: string;
  _contracttypes_: string;
  _StateCode: string;
  ExistCustomerContract: any[];
  _ContractTypes: string[] = [];
  _StateNG: string[] = [];
  _TempWaybillList: any[];
  _CostingContractsubmitted: boolean = false
  _ODAChargesAgree: any[]
  _ODACalculationMode: any[]

  HideGeneralRate: boolean = false
  HideArticleBased: boolean = false
  HideRegionLevel: boolean = false
  HideSlab: boolean = false
  Hide2DRate: boolean = false

  TempExistCustomerContract: any
  minDate: Date;
  hideAgent: boolean = true

  uploadedFiles: any[] = [];

  _submittedimage: boolean = false
  ValidateTAT: boolean = true

  TempRegionlevelList_: any[]
  TempArticlelList_: any[]
  TempSlabList_: any[]
  TempDDList_: any[]


  RegionLevelselectedFiles: FileList;
  ArticleselectedFiles: FileList
  SlabselectedFiles: FileList
  DDselectedFiles: FileList

  ValidateRegion: boolean = true
  ValidateArticle: boolean = true
  ValidateSlab: boolean = true
  ValidateDD: boolean = true

  _RegionRateType: any
  _SlabType2D: any

  _approval: Approval;
  _approvalform: FormGroup;
  _Comments: string;

  _listDistance: any[] = []
  datepipe = new DatePipe("en-US");


  @ViewChild("search")
  public searchElementRef: ElementRef
  @ViewChild("editor", { static: true }) private editor: ElementRef<HTMLElement>;
  @ViewChild('takeInput', { static: false })
  InputVar: ElementRef;
  @ViewChild('takeInputTAT', { static: false })
  InputVarTAT: ElementRef;
  @ViewChild('takeRegionLevelInput', { static: false })
  InputVarRegion: ElementRef;
  @ViewChild('takeArticleBasedInput', { static: false })
  InputVarArticle: ElementRef;
  @ViewChild('takeSlabInput', { static: false })
  InputVarSlab: ElementRef;
  @ViewChild('take2drateInput', { static: false })
  InputVarDDRate: ElementRef;

  takeRegionLevelInput: ElementRef
  constructor(private fb: FormBuilder, private router: Router, private _ServiceLocationAndOperationService: ServiceLocationAndOperationService,
    public exportUtility: ExportUtility,
    private utility: CommonUtilities, private _CustomerInformationService: CustomerinformationService, private _CustomExceptionService: CustomExceptionService,
    private _ExistingvendorService: ExistingvendorService, private _TradereferenceService: TradereferenceService, public keypress: KeyPress,
    private _CustomerSUKService: CustomerSUKService, private _APIdService: APIService,
    private _DomSanitizationService: DomSanitizer, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private messageService: MessageService
    , private _CustomerContractService: CustomerContractService
  ) { }

  ngOnInit(): void {
    this.PageInitalize();
  }

  PageInitalize() {
    this.HideGeneralRate = true
    this.HideArticleBased = true
    this.HideRegionLevel = true
    this.HideSlab = true
    this.Hide2DRate = true
    this.ApprovalCommentsList = []

    this._CostingContract = this.fb.group({
      billingbranchcode: ['', vContract],
      billingbranch: [],
      // communicationmaildocumentURL: [],
      // communicationmaildocumentDOC: [],
      odachargetype: [],
      odachargetypecode: ['', vContract],
      //pertransactionfixedodacharges: [],
      //opentypeodastates: [],
      flatodabasedon: [],
      fuelpriceperltr: ['', vContract],
      quotedrateperqtlperkm: ['', vContract],
      minimumfreight: ['', vContract],
      minimumchargeableweight: ['', vContract],
      minimumvsc: ['', vContract],
      //quotestatus: ['', vContract],
      //expectedsales: ['', vContract],
      //creditlimit: ['', vContract],
      //invoicecreditdays: ['', vContract],
      minimumdc: ['', vContract],
      costtocompanydc: ['', vContract],
      costtoagentdc: ['', vContract],
      minimumdd: ['', vContract],
      minarticledd: ['', vContract],
      costtocompanydd: ['', vContract],
      costtoagentdd: ['', vContract],
      minimumac: ['', vContract],
      costtocompanyac: ['', vContract],
      costtoagentac: ['', vContract],
      contracttypescode: ['', vContract],
      //odainclusiveorexclusivecode: ['', vContract],
      //opentypeodastatescode: [],
      flatodabasedoncode: [],
      //odachargesagreed: [],
      //odachargesagreedcode: ['', vContract],
      costtocompanyoda: ['', vContract],
      costtoagentoda: [],
      odainclusiveorexclusive: [],
      minimumoda: [],
      contracttypes: [],
      _customername: [],
      contractdate: [],
      customersitecode: [],
      contractcode: [],
      contractfromdate: [],
      contracttodate: [],
      businessstartdate:[],
      presentfuelrate: ['', vContract],
    })

    this._CostingContract.controls['costtoagentdc'].setValue(100);
    this._CostingContract.controls['costtoagentdd'].setValue(100);
    this._CostingContract.controls['costtoagentac'].setValue(100);
    this._CostingContract.controls['costtoagentoda'].setValue(100);

    this._CustomerSiteContractGeneralForm = this.fb.group({
      rateperqtlperkm: ['', vContract],
      odacalculationmodecode: ['', vContract],
    })

    this._RegionLevelForm = this.fb.group({
      frombranchcode: ['', vContractRegion],
      toregioncode: ['', vContractRegion],
      articlecode: ['', vContractRegion],
      ratetypecode: ['', vContractRegion],
      rate: [],
      dcratetypecode: ['', vContractRegion],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContractRegion],
      ddratetypecode: ['', vContractRegion],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContractRegion],
      acratetypecode: ['', vContractRegion],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContractRegion],
      isneedreversebooking: [],
      acratetype: [],
    })

    this._ArticleBasedForm = this.fb.group({
      frombranchcode: ['', vContractArticle],
      tobranchcode: ['', vContractArticle],
      articlecode: ['', vContractArticle],
      ratetypecode: ['', vContractArticle],
      rate: [],
      //kg: ['', vContractArticle],
      rateperkm: [1.44, vContractArticle],
      dcratetypecode: ['', vContractArticle],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContractArticle],
      ddratetypecode: ['', vContractArticle],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContractArticle],
      acratetypecode: ['', vContractArticle],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContractArticle],
      isneedreversebooking: [],
      acratetype: [],
      distance: [],
      quintalRateperKM: [],
    })

    this._SlabForm = this.fb.group({
      frombranchcode: ['', vContractSlab],
      tobranchcode: ['', vContractSlab],
      articlecode: ['', vContractSlab],
      ratetypecode: ['', vContractSlab],
      rate: [],
      dcratetypecode: ['', vContractSlab],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContractSlab],
      ddratetypecode: ['', vContractSlab],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContractSlab],
      acratetypecode: ['', vContractSlab],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContractSlab],
      isneedreversebooking: [],
      acratetype: [],
    })

    this._2DForm = this.fb.group({
      frombranchcode: ['', vContract2D],
      toKM: ['', vContract2D],
      articlecode: ['', vContract2D],
      ratetypecode: ['', vContract2D],
      rate: [],
      dcratetypecode: ['', vContract2D],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContract2D],
      ddratetypecode: ['', vContract2D],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContract2D],
      acratetypecode: ['', vContract2D],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract2D],
      isneedreversebooking: [],
      acratetype: [],
      quintalRateperKM: [],
    })

    this._WaybillForm = this.fb.group({
      chargecodeid: [],
      chargetypecode: ['', vContract2D],
      chargeratetypecode: ['', vContract2D],
      rate: [],
      inclusiveorexclusivecode: ['', vContract2D],
      printinothercharge: [],
    })

    this._approvalform = this.fb.group({
      APPROVALID: [],
      WORKFLOWID: [],
      LEVELAPPROVALSTATE: [],
      Remarks: [],
      lstCustomerSiteTradeReference: []
    });
  }


  
  selectCustomerName() {
    this.customersitecode = this._CostingContract.get("_customername").value.customersitecode;

    if (this.customersitecode != null) {
      this.CustomerBasedContractLoad();
    }
  }

  CustomerBasedContractLoad() {
    this._IsProgressSpinner = true;
    var CustCode = this.customersitecode;

    if (this.customersitecode != null) {

      this._CustomerContractService.GetById_Search(CustCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        this.TempExistCustomerContract = resultJSON.customerContractDetail;
        if (this.TempExistCustomerContract != null) {
          this.ExistCustomerContract = resultJSON.customerContractDetail;



          var contracttypescode = "'MSC00081','MSC00082','MSC00083','MSC00084',MSC00104";
          var splitContractTypes = contracttypescode.split(',');
          var ContractTypesCode: string[] = [];
          Object.keys(splitContractTypes).map((Index) => {
            ContractTypesCode.push(splitContractTypes[Index]);
          });
          this._ContractTypes = ContractTypesCode;
          this.ApprovalCommentsList = resultJSON.lstApprovalCommentsRateIncrease;

          this._contracttypescode = resultJSON.customerContractDetail.contracttypescode;
          this._contracttypes_ = resultJSON.customerContractDetail.contracttypescode;
          this._StateCode = resultJSON.customerContractDetail.opentypeodastatescode;
          this._CostingContract.controls['contractdate'].setValue(new Date());
          this._CostingContract.controls['billingbranchcode'].setValue(resultJSON.customerContractDetail.billingbranchcode);
          this._CostingContract.controls['fuelpriceperltr'].setValue(resultJSON.customerContractDetail.fuelpriceperltr);
          this._CostingContract.controls['quotedrateperqtlperkm'].setValue(resultJSON.customerContractDetail.quotedrateperqtlperkm);
          this._CostingContract.controls['minimumfreight'].setValue(resultJSON.customerContractDetail.minimumfreight);
          this._CostingContract.controls['minimumchargeableweight'].setValue(resultJSON.customerContractDetail.minimumchargeableweight);
          this._CostingContract.controls['minimumvsc'].setValue(resultJSON.customerContractDetail.minimumvsc);
          this._CostingContract.controls['minimumdc'].setValue(resultJSON.customerContractDetail.minimumdc);
          this._CostingContract.controls['minimumdd'].setValue(resultJSON.customerContractDetail.minimumdd);
          this._CostingContract.controls['minarticledd'].setValue(resultJSON.customerContractDetail.minarticledd);
          this._CostingContract.controls['costtocompanydd'].setValue(resultJSON.customerContractDetail.costtocompanydd);
          this._CostingContract.controls['minimumac'].setValue(resultJSON.customerContractDetail.minimumac);
          this._CostingContract.controls['costtocompanyac'].setValue(resultJSON.customerContractDetail.costtocompanyac);
          this._CostingContract.controls['costtoagentac'].setValue(resultJSON.customerContractDetail.costtoagentac);
          this._CostingContract.controls['customersitecode'].setValue(resultJSON.customerContractDetail.customersitecode);
          this._CostingContract.controls['contractcode'].setValue(resultJSON.customerContractDetail.contractcode);
          this._CostingContract.controls['contractfromdate'].setValue(
            resultJSON.customerContractDetail.contractfromdate == null ? null : new Date(resultJSON.customerContractDetail.contractfromdate));
          this._CostingContract.controls['contracttodate'].setValue(
            resultJSON.customerContractDetail.contracttodate == null ? null : new Date(resultJSON.customerContractDetail.contracttodate));
          this._CostingContract.controls['businessstartdate'].setValue(resultJSON.customerContractDetail.businessstartdate);
          this._CostingContract.controls['presentfuelrate'].setValue(resultJSON.customerContractDetail.presentfuelrate ?? 0);
            
          this._CustomerSiteCode = resultJSON.customerContractDetail.customersitecode;

          if (resultJSON.lstGeneralContract.length > 0) {
            this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
            this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
          }
          this._CostingContract.controls['odachargetypecode'].setValue(resultJSON.customerContractDetail.odachargetypecode);
          this._CostingContract.controls['flatodabasedoncode'].setValue(resultJSON.customerContractDetail.flatodabasedoncode);

          this._RegionList = resultJSON.lstRegionContract;
          if (resultJSON.lstRegionContract != null) {
            for (var i = 0; i < resultJSON.lstRegionContract.length; i++) {
              this._RegionList[i].customersitecode = resultJSON.lstRegionContract[i].customersitecode;
              this._RegionList[i].frombranchcode = resultJSON.lstRegionContract[i].frombranchcode;
              this._RegionList[i].frombranch = resultJSON.lstRegionContract[i].frombranchname;
              this._RegionList[i].toregioncode = resultJSON.lstRegionContract[i].toregioncode;
              this._RegionList[i].toregion = resultJSON.lstRegionContract[i].toregionname;
              this._RegionList[i].articlecode = resultJSON.lstRegionContract[i].articlecode;
              this._RegionList[i].article = resultJSON.lstRegionContract[i].articlename;
              this._RegionList[i].ratetypecode = resultJSON.lstRegionContract[i].ratetypecode;
              this._RegionList[i].ratetype = resultJSON.lstRegionContract[i].ratetypename;
              this._RegionList[i].rate = resultJSON.lstRegionContract[i].rate;
              this._RegionList[i].dcratetypecode = resultJSON.lstRegionContract[i].dcratetypecode;
              this._RegionList[i].dcratetype = resultJSON.lstRegionContract[i].dcratetypename;
              this._RegionList[i].dcrate = resultJSON.lstRegionContract[i].dcrate;

              this._RegionList[i].ddratetypecode = resultJSON.lstRegionContract[i].ddratetypecode;
              this._RegionList[i].ddratetype = resultJSON.lstRegionContract[i].ddratetypename;
              this._RegionList[i].ddrate = resultJSON.lstRegionContract[i].ddrate;
              this._RegionList[i].acratetypecode = resultJSON.lstRegionContract[i].acratetypecode;
              this._RegionList[i].acratetype = resultJSON.lstRegionContract[i].acratetypename;
              this._RegionList[i].acrate = resultJSON.lstRegionContract[i].acrate;
              this._RegionList[i].dcinclusiveorexclusivecode = resultJSON.lstRegionContract[i].dcinclusiveorexclusivecode;
              this._RegionList[i].dcinclusiveorexclusive = resultJSON.lstRegionContract[i].dcinclusiveorexclusive;
              this._RegionList[i].ddinclusiveorexclusivecode = resultJSON.lstRegionContract[i].ddinclusiveorexclusivecode;
              this._RegionList[i].ddinclusiveorexclusive = resultJSON.lstRegionContract[i].ddinclusiveorexclusive;
              this._RegionList[i].inclusiveorexclusivecode = resultJSON.lstRegionContract[i].addonInclusiveorexclusivecode;
              this._RegionList[i].inclusiveorexclusive = resultJSON.lstRegionContract[i].addonInclusiveorexclusive;

              this._RegionList[i].effectivefrom = resultJSON.lstRegionContract[i].effectivefrom;
              this._RegionList[i].effectiveto = resultJSON.lstRegionContract[i].effectiveto;

              this._RegionList[i].isneedreversebooking = resultJSON.lstRegionContract[i].isneedreversebooking;
              this._RegionList[i].isneedreversebookingcode = resultJSON.lstRegionContract[i].isneedreversebookingcode;
              this._RegionList[i].lstDCDDACSlabs = resultJSON.lstRegionContract[i].lstDCDDACSlabs;
              if (resultJSON.lstRegionContract[i].lstDCDDACSlabs != null) {
                for (var j = 0; j < resultJSON.lstRegionContract[i].lstDCDDACSlabs.length; j++) {
                  this._RegionList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].customersitecode;
                  this._RegionList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].contracttypecode;
                  this._RegionList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].chargetypecode;
                  this._RegionList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabfrom;
                  this._RegionList[i].lstDCDDACSlabs.slabto = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabto;
                  this._RegionList[i].lstDCDDACSlabs.slabrate = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabrate;
                }
              }
            }
          }


          this._ArticleBasedList = resultJSON.lstArticleContract;
          if (resultJSON.lstArticleContract.length > 0) {
            this._Articleselectedrows = resultJSON.lstArticleContract;
          }
          if (resultJSON.lstArticleContract != null) {
            for (var i = 0; i < resultJSON.lstArticleContract.length; i++) {
              this._ArticleBasedList[i].customersitecode = resultJSON.lstArticleContract[i].customersitecode;
              this._ArticleBasedList[i].frombranchcode = resultJSON.lstArticleContract[i].frombranchcode;
              this._ArticleBasedList[i].frombranch = resultJSON.lstArticleContract[i].frombranchname;
              this._ArticleBasedList[i].tobranchcode = resultJSON.lstArticleContract[i].tobranchcode;
              this._ArticleBasedList[i].tobranch = resultJSON.lstArticleContract[i].tobranchname;
              this._ArticleBasedList[i].articlecode = resultJSON.lstArticleContract[i].articlecode;
              this._ArticleBasedList[i].article = resultJSON.lstArticleContract[i].articlename;
              this._ArticleBasedList[i].ratetypecode = resultJSON.lstArticleContract[i].ratetypecode;
              this._ArticleBasedList[i].ratetype = resultJSON.lstArticleContract[i].ratetypename;
              this._ArticleBasedList[i].rate = resultJSON.lstArticleContract[i].rate;
              // this._ArticleBasedList[i].discount = resultJSON.lstArticleContract[i].discount;
              // this._ArticleBasedList[i].finalrate = resultJSON.lstArticleContract[i].finalrate;
              this._ArticleBasedList[i].dcratetypecode = resultJSON.lstArticleContract[i].dcratetypecode;
              this._ArticleBasedList[i].dcratetype = resultJSON.lstArticleContract[i].dcratetypename;
              this._ArticleBasedList[i].dcrate = resultJSON.lstArticleContract[i].dcrate;
              this._ArticleBasedList[i].ddratetypecode = resultJSON.lstArticleContract[i].ddratetypecode;
              this._ArticleBasedList[i].ddratetype = resultJSON.lstArticleContract[i].ddratetypename;
              this._ArticleBasedList[i].ddrate = resultJSON.lstArticleContract[i].ddrate;
              this._ArticleBasedList[i].acratetypecode = resultJSON.lstArticleContract[i].acratetypecode;
              this._ArticleBasedList[i].acratetype = resultJSON.lstArticleContract[i].acratetypename;
              this._ArticleBasedList[i].acrate = resultJSON.lstArticleContract[i].acrate;
              this._ArticleBasedList[i].dcinclusiveorexclusivecode = resultJSON.lstArticleContract[i].dcinclusiveorexclusivecode;
              this._ArticleBasedList[i].dcinclusiveorexclusive = resultJSON.lstArticleContract[i].dcinclusiveorexclusive;
              this._ArticleBasedList[i].ddinclusiveorexclusivecode = resultJSON.lstArticleContract[i].ddinclusiveorexclusivecode;
              this._ArticleBasedList[i].ddinclusiveorexclusive = resultJSON.lstArticleContract[i].ddinclusiveorexclusive;
              this._ArticleBasedList[i].inclusiveorexclusivecode = resultJSON.lstArticleContract[i].addoninclusiveorexclusivecode;
              this._ArticleBasedList[i].inclusiveorexclusive = resultJSON.lstArticleContract[i].addoninclusiveorexclusive;

              this._ArticleBasedList[i].effectivefrom = resultJSON.lstArticleContract[i].effectivefrom;
              this._ArticleBasedList[i].effectiveto = resultJSON.lstArticleContract[i].effectiveto;

              this._ArticleBasedList[i].isneedreversebooking = resultJSON.lstArticleContract[i].isneedreversebooking;
              this._ArticleBasedList[i].isneedreversebookingcode = resultJSON.lstArticleContract[i].isneedreversebookingcode;
              this._ArticleBasedList[i].lstDCDDACSlabs = resultJSON.lstArticleContract[i].lstDCDDACSlabs;
              // this._ArticleBasedList[i].distance = resultJSON.lstArticleContract[i].distance;
              // this._ArticleBasedList[i].quintalRateperKM = resultJSON.lstArticleContract[i].quintalRateperKM;
              if (resultJSON.lstArticleContract[i].lstDCDDACSlabs != null) {
                for (var j = 0; j < resultJSON.lstArticleContract[i].lstDCDDACSlabs.length; j++) {
                  this._ArticleBasedList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].customersitecode;
                  this._ArticleBasedList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].contracttypecode;
                  this._ArticleBasedList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].chargetypecode;
                  this._ArticleBasedList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabfrom;
                  this._ArticleBasedList[i].lstDCDDACSlabs.slabto = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabto;
                  this._ArticleBasedList[i].lstDCDDACSlabs.slabrate = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabrate;
                }
              }
            }
          }
          if (resultJSON.lstSlabContract != null) {
            this._SlabFormList = resultJSON.lstSlabContract;
            for (var i = 0; i < resultJSON.lstSlabContract.length; i++) {
              this._SlabFormList[i].customersitecode = resultJSON.lstSlabContract[i].customersitecode;
              this._SlabFormList[i].frombranchcode = resultJSON.lstSlabContract[i].frombranchcode;
              this._SlabFormList[i].frombranch = resultJSON.lstSlabContract[i].frombranchname;
              this._SlabFormList[i].tobranchcode = resultJSON.lstSlabContract[i].tobranchcode;
              this._SlabFormList[i].tobranch = resultJSON.lstSlabContract[i].tobranchname;
              this._SlabFormList[i].articlecode = resultJSON.lstSlabContract[i].articlecode;
              this._SlabFormList[i].article = resultJSON.lstSlabContract[i].articlename;
              this._SlabFormList[i].ratetypecode = resultJSON.lstSlabContract[i].ratetypecode;
              this._SlabFormList[i].ratetype = resultJSON.lstSlabContract[i].ratetypename;
              this._SlabFormList[i].rate = resultJSON.lstSlabContract[i].rate;
              this._SlabFormList[i].dcratetypecode = resultJSON.lstSlabContract[i].dcratetypecode;
              this._SlabFormList[i].dcratetype = resultJSON.lstSlabContract[i].dcratetypename;
              this._SlabFormList[i].dcrate = resultJSON.lstSlabContract[i].dcrate;
              this._SlabFormList[i].ddratetypecode = resultJSON.lstSlabContract[i].ddratetypecode;
              this._SlabFormList[i].ddratetype = resultJSON.lstSlabContract[i].ddratetypename;
              this._SlabFormList[i].ddrate = resultJSON.lstSlabContract[i].ddrate;
              this._SlabFormList[i].acratetypecode = resultJSON.lstSlabContract[i].acratetypecode;
              this._SlabFormList[i].acratetype = resultJSON.lstSlabContract[i].acratetypename;
              this._SlabFormList[i].acrate = resultJSON.lstSlabContract[i].acrate;
              this._SlabFormList[i].dcinclusiveorexclusivecode = resultJSON.lstSlabContract[i].dcinclusiveorexclusivecode;
              this._SlabFormList[i].dcinclusiveorexclusive = resultJSON.lstSlabContract[i].dcinclusiveorexclusive;
              this._SlabFormList[i].ddinclusiveorexclusivecode = resultJSON.lstSlabContract[i].ddinclusiveorexclusivecode;
              this._SlabFormList[i].ddinclusiveorexclusive = resultJSON.lstSlabContract[i].ddinclusiveorexclusive;
              this._SlabFormList[i].inclusiveorexclusivecode = resultJSON.lstSlabContract[i].addoninclusiveorexclusivecode;
              this._SlabFormList[i].inclusiveorexclusive = resultJSON.lstSlabContract[i].addoninclusiveorexclusive;
              this._SlabFormList[i].isneedreversebooking = resultJSON.lstSlabContract[i].isneedreversebooking;
              this._SlabFormList[i].isneedreversebookingcode = resultJSON.lstSlabContract[i].isneedreversebookingcode;
              this._SlabFormList[i].lstDCDDACSlabs = resultJSON.lstSlabContract[i].lstDCDDACSlabs;
              this._SlabFormList[i].effectivefrom = resultJSON.lstSlabContract[i].effectivefrom;
              this._SlabFormList[i].effectiveto = resultJSON.lstSlabContract[i].effectiveto;
              if (resultJSON.lstSlabContract[i].lstDCDDACSlabs != null) {
                for (var j = 0; j < resultJSON.lstSlabContract[i].lstDCDDACSlabs.length; j++) {
                  this._SlabFormList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].customersitecode;
                  this._SlabFormList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].contracttypecode;
                  //this._SlabFormList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].chargetypecode;
                  this._SlabFormList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabfrom;
                  this._SlabFormList[i].lstDCDDACSlabs.slabto = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabto;
                  this._SlabFormList[i].lstDCDDACSlabs.slabrate = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabrate;
                }
              }
              if (resultJSON.lstSlabContract[i].lstRateSlabs != null) {
                for (var j = 0; j < resultJSON.lstSlabContract[i].lstRateSlabs.length; j++) {
                  this._SlabFormList[i].lstRateSlabs.customersitecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].customersitecode;
                  this._SlabFormList[i].lstRateSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                  //this._SlabFormList[i].lstRateSlabs.contracttype = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                  this._SlabFormList[i].lstRateSlabs.slabfrom = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabfrom;
                  this._SlabFormList[i].lstRateSlabs.slabto = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabto;
                  this._SlabFormList[i].lstRateSlabs.slabrate = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabrate;
                }
              }
            }
          }
          
          if (resultJSON.lstTwoDContract != null) {
            this._2DList = resultJSON.lstTwoDContract;
            for (var i = 0; i < resultJSON.lstTwoDContract.length; i++) {
              this._2DList[i].customersitecode = resultJSON.lstTwoDContract[i].customersitecode;
              this._2DList[i].frombranchcode = resultJSON.lstTwoDContract[i].frombranchcode;
              this._2DList[i].frombranch = resultJSON.lstTwoDContract[i].frombranchname;
              this._2DList[i].toKM = resultJSON.lstTwoDContract[i].tokm;
              this._2DList[i].articlecode = resultJSON.lstTwoDContract[i].articlecode;
              this._2DList[i].article = resultJSON.lstTwoDContract[i].articlename;
              this._2DList[i].ratetypecode = resultJSON.lstTwoDContract[i].ratetypecode;
              this._2DList[i].ratetype = resultJSON.lstTwoDContract[i].ratetypename;
              this._2DList[i].rate = resultJSON.lstTwoDContract[i].rate;
              this._2DList[i].dcratetypecode = resultJSON.lstTwoDContract[i].dcratetypecode;
              this._2DList[i].dcratetype = resultJSON.lstTwoDContract[i].dcratetypename;
              this._2DList[i].dcrate = resultJSON.lstTwoDContract[i].dcrate;
              this._2DList[i].ddratetypecode = resultJSON.lstTwoDContract[i].ddratetypecode;
              this._2DList[i].ddratetype = resultJSON.lstTwoDContract[i].ddratetypename;
              this._2DList[i].ddrate = resultJSON.lstTwoDContract[i].ddrate;
              this._2DList[i].acratetypecode = resultJSON.lstTwoDContract[i].acratetypecode;
              this._2DList[i].acratetype = resultJSON.lstTwoDContract[i].acratetypename;
              this._2DList[i].acrate = resultJSON.lstTwoDContract[i].acrate;
              this._2DList[i].dcinclusiveorexclusivecode = resultJSON.lstTwoDContract[i].dcinclusiveorexclusivecode;
              this._2DList[i].dcinclusiveorexclusive = resultJSON.lstTwoDContract[i].dcinclusiveorexclusive;
              this._2DList[i].ddinclusiveorexclusivecode = resultJSON.lstTwoDContract[i].ddinclusiveorexclusivecode;
              this._2DList[i].ddinclusiveorexclusive = resultJSON.lstTwoDContract[i].ddinclusiveorexclusive;
              this._2DList[i].inclusiveorexclusivecode = resultJSON.lstTwoDContract[i].addoninclusiveorexclusivecode;
              this._2DList[i].inclusiveorexclusive = resultJSON.lstTwoDContract[i].addoninclusiveorexclusive;
              this._2DList[i].isneedreversebooking = resultJSON.lstTwoDContract[i].isneedreversebooking;
              this._2DList[i].isneedreversebookingcode = resultJSON.lstTwoDContract[i].isneedreversebookingcode;
              this._2DList[i].lstDCDDACSlabs = resultJSON.lstTwoDContract[i].lstDCDDACSlabs;
              this._2DList[i].effectivefrom = resultJSON.lstTwoDContract[i].effectivefrom;
              this._2DList[i].effectiveto = resultJSON.lstTwoDContract[i].effectiveto;
              if (resultJSON.lstTwoDContract[i].lstDCDDACSlabs != null) {
                for (var j = 0; j < resultJSON.lstTwoDContract[i].lstDCDDACSlabs.length; j++) {
                  this._2DList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].customersitecode;
                  this._2DList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].contracttypecode;
                  this._2DList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].chargetypecode;
                  this._2DList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabfrom;
                  this._2DList[i].lstDCDDACSlabs.slabto = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabto;
                  this._2DList[i].lstDCDDACSlabs.slabrate = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabrate;
                }
              }
              if (resultJSON.lstTwoDContract[i].lstRateTwoDSlabs != null) {
                for (var j = 0; j < resultJSON.lstTwoDContract[i].lstRateTwoDSlabs.length; j++) {
                  this._2DList[i].lstRateTwoDSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstRateTwoDSlabs[j].customersitecode;
                  this._2DList[i].lstRateTwoDSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstRateTwoDSlabs[j].contracttypecode;
                  this._2DList[i].lstRateTwoDSlabs.slabtypecode = resultJSON.lstTwoDContract[i].lstRateTwoDSlabs[j].slabtypecode;
                  this._2DList[i].lstRateTwoDSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstRateTwoDSlabs[j].slabfrom;
                  this._2DList[i].lstRateTwoDSlabs.slabto = resultJSON.lstTwoDContract[i].lstRateTwoDSlabs[j].slabto;
                  this._2DList[i].lstRateTwoDSlabs.slabrate = resultJSON.lstTwoDContract[i].lstRateTwoDSlabs[j].slabrate;
                }
              }
            }
          }
          if (resultJSON.lstAddOnCharge != null) {
            this.WayBillList = resultJSON.lstAddOnCharge;
            for (var i = 0; i < resultJSON.lstAddOnCharge.length; i++) {
              this.WayBillList[i].customersitecode = resultJSON.lstAddOnCharge[i].customersitecode;
              this.WayBillList[i].chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargetypecode)[0].chargeName;
              this.WayBillList[i].chargetypecode = resultJSON.lstAddOnCharge[i].chargetypecode;
              this.WayBillList[i].chargeratetypecode = resultJSON.lstAddOnCharge[i].chargeratetypecode;
              this.WayBillList[i].chargeratetype = resultJSON.lstAddOnCharge[i].chargeratetypename;
              this.WayBillList[i].chargecodeid = resultJSON.lstAddOnCharge[i].addondetailcode;
              this.WayBillList[i].rate = resultJSON.lstAddOnCharge[i].rate;
              this.WayBillList[i].inclusiveorexclusivecode = resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode;
              this.WayBillList[i].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode)[0].metasubdescription;
              this.WayBillList[i].printinothercharge = resultJSON.lstAddOnCharge[i].printisincludeotherdesc;
              this.WayBillList[i].lstAddOnSlabs = resultJSON.lstAddOnCharge[i].lstAddOnSlabs;
              if (resultJSON.lstAddOnCharge[i].lstAddOnSlabs != null) {
                for (var j = 0; j < resultJSON.lstAddOnCharge[i].lstAddOnSlabs.length; j++) {
                  this.WayBillList[i].lstAddOnSlabs.customersitecode = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].customersitecode;
                  this.WayBillList[i].lstAddOnSlabs.slabfrom = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabfrom;
                  this.WayBillList[i].lstAddOnSlabs.slabto = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabto;
                  this.WayBillList[i].lstAddOnSlabs.slabrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabrate;
                  this.WayBillList[i].lstAddOnSlabs.slabaddrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].addrate;
                  this.WayBillList[i].lstAddOnSlabs.chargecodeid = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Chargecodeid;
                }
              }
            }
          }
          this._IsProgressSpinner = false;
        }
        else {
          this._IsProgressSpinner = false;
        }
      }, error => {
        this._IsProgressSpinner = false;
        this._CustomExceptionService.handleError(error);
      });

    }
  }



  filterCustomername(event: { query: string }) {
    var customername = event.query;

    this._CustomerContractService.GetPageInitializeDetails(customername).subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      this.listCustomername = resultJSON.lstCustomerDetails;

      this._BillingBranch = resultJSON.lstBranch;
      this._FlatOdaList = resultJSON.lstFlatODABasedOn;
      this._ContractType = resultJSON.lstContractType;
      this._InclusiveExclusive = resultJSON.lstODAInclusiveOrExclusive;
      this._State = resultJSON.lstState;
      this._Region = resultJSON.lstRegion;
      this._ODAChargesAgree = resultJSON.lstYesNo;
      this._ODACalculationMode = resultJSON.lstODACalculationMode;
      this._OdaList = resultJSON.lstODAChargeType
      this._ToBranch = resultJSON.lstBranch;
      this._ArticleName = resultJSON.lstArticle;
      this._RateType = resultJSON.lstRateType;
      this._DCRateType = resultJSON.lstDCRateType;
      this._DDRateType = resultJSON.lstDDRateType;
      this._ArticleChargeCode = resultJSON.lstACRateType;
      this._AddonCharges = resultJSON.lstChargeType;
      this._AddOnChargeType = resultJSON.lstAddOnChargeType;
      this._SlabType = resultJSON.lstSlabType;
      this._Quote = resultJSON.lstQuoteStatus
      this._RegionRateType = resultJSON.lstRegionRateType;
      this._SlabType2D = resultJSON.lstSlabType2D;

      //this._CostingContract.controls["odachargesagreedcode"].setValue("MSC00012");
      this._CustomerSiteContractGeneralForm.controls["odacalculationmodecode"].setValue("MSC00319");
      this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(0);
      //this._CostingContract.controls['quotestatus'].setValue('PQT00056');

    }, error => { this._CustomExceptionService.handleError(error); }
    );

  }

  onchangecosttocompanyDD() {
    if (this._CostingContract.get("costtocompanydd").value != "" && this._CostingContract.get("costtocompanydd").value != "") {
      if (this._CostingContract.get("costtocompanydd").value <= 100) {
        this._CostingContract.controls['costtoagentdd'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanydd").value));
      }
      else {
        this._CostingContract.controls['costtocompanydd'].setValue(0);
        this._CostingContract.controls['costtoagentdd'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentdd'].setValue(100);
    }
  }


  onchangecosttocompanyAC() {
    if (this._CostingContract.get("costtocompanyac").value != "" && this._CostingContract.get("costtocompanyac").value != "") {
      if (this._CostingContract.get("costtocompanyac").value <= 100) {
        this._CostingContract.controls['costtoagentac'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanyac").value));
      }
      else {
        this._CostingContract.controls['costtocompanyac'].setValue(0);
        this._CostingContract.controls['costtoagentac'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentac'].setValue(100);
    }
  }


  ChangeContractType(event) {
    this.HideGeneralRate = false
    this.HideArticleBased = false
    this.HideRegionLevel = false
    this.HideSlab = false
    this.Hide2DRate = false
    var selectedid = event.value;
    var contracttypescode = "";
    var contracttypes = "";
    for (var i = 0; i < selectedid.length; i++) {
      if (selectedid[i] == 'MSC00081') {
        this.HideGeneralRate = true
      }
      if (selectedid[i] == 'MSC00083') {
        this.HideArticleBased = true
      }
      if (selectedid[i] == 'MSC00082') {
        this.HideRegionLevel = true
      }
      if (selectedid[i] == 'MSC00084') {
        this.HideSlab = true
      }
      if (selectedid[i] == 'MSC00104') {
        this.Hide2DRate = true
      }

      if (contracttypescode == "") {
        contracttypescode = selectedid[i];
        contracttypes = (this._ContractType || []).filter(f => f.metasubcode == selectedid[i])[0].metasubdescription;
      }
      else {
        contracttypescode = contracttypescode + "," + selectedid[i];
        contracttypes = contracttypes + "," + (this._ContractType || []).filter(f => f.metasubcode == selectedid[i])[0].metasubdescription;
      }
    }

    this._contracttypescode = contracttypescode
    this._contracttypes_ = contracttypes
  }


  selectRegionLevelFile(event) {
    this.RegionLevelselectedFiles = event.target.files;
    this.ValidateRegion = false
  }

  RegionLevelupload() {
    this.currentFile = this.RegionLevelselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempRegionlevelList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempRegionlevelList_.length; i++) {
        var _FromBranch = this.TempRegionlevelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          var _ToBranch = this.TempRegionlevelList_[i].ToRegion
          var ToBranch = (this._Region).filter(f => f.regionname.toLowerCase() == _ToBranch.toLowerCase());
          if (ToBranch.length > 0) {
            var ToBranchCode_ = (this._Region).filter(f => f.regionname.toLowerCase() == _ToBranch.toLowerCase())[0].regioncode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ToRegion + "'" + " To Region Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _ArticleName = this.TempRegionlevelList_[i].Article
          var ArticleName = (this._ArticleName).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._ArticleName).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].Article + "'" + " Article Name Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _RateType = this.TempRegionlevelList_[i].RateType
          var RateType = (this._RegionRateType).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
          if (RateType.length > 0) {
            var RateTypeCode_ = (this._RegionRateType).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }
          var _DCRateType = this.TempRegionlevelList_[i].DCRateType
          var DCRateType = (this._DCRateType).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }
          var _DDRateType = this.TempRegionlevelList_[i].DDRateType
          var DDRateType = (this._DDRateType).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _ACRateType = this.TempRegionlevelList_[i].ArticleChargeCode
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ArticleChargeCode + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _AddonCharge = this.TempRegionlevelList_[i].AddonCharges
          var AddonCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _DCCharge = this.TempRegionlevelList_[i].DCCharge
          var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
          if (DCCharge.length > 0) {
            var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCCharges + "'" + " DC Charge Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _DDCharge = this.TempRegionlevelList_[i].DDCharge
          var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
          if (DDCharge.length > 0) {
            var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDCharges + "'" + " DD Charge Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarRegion.nativeElement.value = "";
          this.ValidateRegion = true
          return;
        }
      }

      for (var i = 0; i < this.TempRegionlevelList_.length; i++) {
        var RegionLevelTemp: any = {};

        var _FromBranch = this.TempRegionlevelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        // if (FromBranch.length > 0) {
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        var _ToRegion = this.TempRegionlevelList_[i].ToRegion
        var ToRegion = (this._Region).filter(f => f.regionname.toLowerCase() == _ToRegion.toLowerCase());
        // if (ToBranch.length > 0) {
        var ToRegionCode_ = (this._Region).filter(f => f.regionname.toLowerCase() == _ToRegion.toLowerCase())[0].regioncode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ToRegion + "'" + " To Region Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _ArticleName = this.TempRegionlevelList_[i].Article
        var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
        // if (ArticleName.length > 0) {
        var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].Article + "'" + " Article Name Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _RateType = this.TempRegionlevelList_[i].RateType
        var RateType = (this._RegionRateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
        //if (RateType.length > 0) {
        var RateTypeCode_ = (this._RegionRateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].RateType + "'" + " Rate Type Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DCRateType = this.TempRegionlevelList_[i].DCRateType
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        var DCRateTypeCode_;
        //if (DCRateType.length > 0) {
        DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DDRateType = this.TempRegionlevelList_[i].DDRateType
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        //if (DDRateType.length > 0) {
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;

        var _ACRateType = this.TempRegionlevelList_[i].ArticleChargeCode
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
        //if (DDRateType.length > 0) {
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _AddonCharge = this.TempRegionlevelList_[i].AddonCharges
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());

        var _DCCharge = this.TempRegionlevelList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempRegionlevelList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        //if (AddonCharge.length > 0) {
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
        //}
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].FromBranch + "'" + " From Branch Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var ReverseBookingcode;
        if (this.TempRegionlevelList_[i].ReverseBooking == "true") {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        RegionLevelTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        RegionLevelTemp.frombranch = _FromBranch;
        RegionLevelTemp.toregion = _ToRegion;
        RegionLevelTemp.frombranchcode = FromBranchCode_;
        RegionLevelTemp.toregioncode = ToRegionCode_;
        RegionLevelTemp.article = _ArticleName;
        RegionLevelTemp.articlecode = ArticleNameCode_;
        RegionLevelTemp.ratetype = _RateType
        RegionLevelTemp.ratetypecode = RateTypeCode_
        RegionLevelTemp.rate = this.TempRegionlevelList_[i].Rate
        RegionLevelTemp.dcratetype = _DCRateType
        RegionLevelTemp.ddratetype = _DDRateType
        RegionLevelTemp.dcratetypecode = DCRateTypeCode_
        RegionLevelTemp.ddratetypecode = DDRateTypeCode_
        RegionLevelTemp.acratetypecode = ACRateTypeCode_
        RegionLevelTemp.acratetype = _ACRateType
        RegionLevelTemp.acrate = ACRate
        RegionLevelTemp.dcinclusiveorexclusive = _DCCharge
        RegionLevelTemp.dcinclusiveorexclusivecode = DCChargeCode_
        RegionLevelTemp.ddinclusiveorexclusive = _DDCharge
        RegionLevelTemp.ddinclusiveorexclusivecode = DDChargeCode_
        RegionLevelTemp.inclusiveorexclusive = _AddonCharge
        RegionLevelTemp.inclusiveorexclusivecode = AddonChargeCode_
        RegionLevelTemp.isneedreversebooking = this.TempRegionlevelList_[i].ReverseBooking
        RegionLevelTemp.isneedreversebookingcode = ReverseBookingcode
        var _lstAddOnSlabsTemp = []
        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          RegionLevelTemp.dcrate = '';
        }
        else {
          RegionLevelTemp.dcrate = this.TempRegionlevelList_[i].DCRate
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          RegionLevelTemp.ddrate = '';
        }
        else {
          RegionLevelTemp.ddrate = this.TempRegionlevelList_[i].DDRate
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        RegionLevelTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        this._RegionList.push(RegionLevelTemp);
        this.InputVarRegion.nativeElement.value = "";
        this.ValidateRegion = true
      }
    }

  }


  onChangeDCRateType() {
  }

  showBasicDialogDCRate() {
    if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00098' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRate = true;
      if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRate = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRate = this._RegionLevelForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRate = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00099' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKG = true;
      if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRate = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRate = this._RegionLevelForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRate = true;
        this._TempPieceKG = 'MSC00099';
        this._DCKGAdditionalRate = '';
      }
    }

  }


  onChangeDDRateType() {
  }

  showBasicDialogDDRate() {
    if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00095' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRate = true;
      if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRate = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRate = this._RegionLevelForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRate = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00096' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKG = true;
      if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRate = false;
        this._TempPieceKG = 'MSC00630';
        this._DDKGAdditionalRate = this._RegionLevelForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRate = true;
        this._TempPieceKG = 'MSC00096';
        this._DDKGAdditionalRate = '';
      }
    }

  }
  showBasicDialogArticleChargeCode() {
    this.displayACRateType = true;
  }

  showBasicDialogACRate() {
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635') {
      this.displayACRate = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635') {
        this.HideACPieceAdditionalRate = false;
        this._TempPieceKG = 'MSC00635';
        this._ACPieceAdditionalRate = this._RegionLevelForm.get("acrate").value
      }
      else {
        this.HideACPieceAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634') {
      this.displayACRateKG = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRate = false;
        this._TempPieceKG = 'MSC00634';
        this._ACKGAdditionalRate = this._RegionLevelForm.get("acrate").value
      }
      else {
        this.HideACKGAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate = '';
      }
    }

  }

  updateRowRegion() {
    //var __RegionListTemp: any = {};
    if (this._RegionIndex != null) {
      this._RegionLevelFormsubmitted = true;
      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;
      var ii = this._RegionIndex;
      this._RegionList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._RegionList[ii].frombranchcode = this._RegionLevelForm.get("frombranchcode").value;
      this._RegionList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._RegionLevelForm.get("frombranchcode").value)[0].branchname;
      this._RegionList[ii].toregioncode = this._RegionLevelForm.get("toregioncode").value;
      this._RegionList[ii].toregion = (this._Region || []).filter(f => f.regioncode == this._RegionLevelForm.get("toregioncode").value)[0].regionname;
      this._RegionList[ii].articlecode = this._RegionLevelForm.get("articlecode").value;
      this._RegionList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._RegionLevelForm.get("articlecode").value)[0].articlename;
      this._RegionList[ii].ratetypecode = this._RegionLevelForm.get("ratetypecode").value;
      this._RegionList[ii].ratetype = (this._RegionRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].rate = this._RegionLevelForm.get("rate").value;
      this._RegionList[ii].dcratetypecode = this._RegionLevelForm.get("dcratetypecode").value;
      this._RegionList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("dcratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].dcrate = this._RegionLevelForm.get("dcrate").value;
      this._RegionList[ii].ddratetypecode = this._RegionLevelForm.get("ddratetypecode").value;
      this._RegionList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ddratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].ddrate = this._RegionLevelForm.get("ddrate").value;
      this._RegionList[ii].acratetypecode = this._RegionLevelForm.get("acratetypecode").value;
      this._RegionList[ii].acratetype = this._RegionLevelForm.get("acratetype").value;
      this._RegionList[ii].acrate = this._RegionLevelForm.get("acrate").value;
      this._RegionList[ii].addoninclusiveorexclusivecode = this._RegionLevelForm.get("inclusiveorexclusivecode").value;
      this._RegionList[ii].addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._RegionLevelForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._RegionList[ii].isneedreversebooking = this._RegionLevelForm.get("isneedreversebooking").value || false;
      this._RegionList[ii].isneedreversebookingcode = this._RegionLevelForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';
      this._RegionList[ii].dcinclusiveorexclusivecode = this._RegionLevelForm.get("dcinclusiveorexclusivecode").value;
      this._RegionList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._RegionLevelForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._RegionList[ii].ddinclusiveorexclusivecode = this._RegionLevelForm.get("ddinclusiveorexclusivecode").value;
      this._RegionList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;
      this._RegionList[ii].effectivefrom = _contractfromDate;
      this._RegionList[ii].effectiveto = _contracttoDate;
      //__RegionListTemp._DCKG = this._DCKG;
      //__RegionListTemp._DDKG = this._DDKG;
      //__RegionListTemp._DDPiece = this._DDPiece;
      //__RegionListTemp._DCPiece = this._DCPiece;

      var _lstDCDDACSlabsTemp = []
      var dcslabTypecode = this._RegionLevelForm.get("dcratetypecode").value;
      var ddslabTypecode = this._RegionLevelForm.get("ddratetypecode").value;
      var acslabTypecode = this._RegionLevelForm.get("acratetypecode").value;
      if (this._DCPiece.length > 0) {
        for (var i = 0; i < this._DCPiece.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabTypecode;
          _tempDCPiece.slabfrom = this._DCPiece[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG.length > 0) {
        for (var i = 0; i < this._DCKG.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00082";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabTypecode;
          _tempDCKG.slabfrom = this._DCKG[i].FromPiece;
          _tempDCKG.slabto = this._DCKG[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece.length > 0) {
        for (var i = 0; i < this._DDPiece.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00082";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabTypecode;
          _tempDDPiece.slabfrom = this._DDPiece[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG.length > 0) {
        for (var i = 0; i < this._DDKG.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00082";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabTypecode;
          _tempDDKG.slabfrom = this._DDKG[i].FromPiece;
          _tempDDKG.slabto = this._DDKG[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPiece.length > 0) {
        for (var i = 0; i < this._ACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabTypecode;
          _tempACPiece.slabfrom = this._ACPiece[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKG.length > 0) {
        for (var i = 0; i < this._ACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabTypecode;
          _tempACKG.slabfrom = this._ACKG[i].FromPiece;
          _tempACKG.slabto = this._ACKG[i].ToPiece;
          _tempACKG.slabrate = this._ACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      this._RegionList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;
      this._RegionIndex = null;
      this.ClearRowRegion();
      this._updateRowRegion = true;
      this._addRowRegion = false;
    }
  }

  addRowRegion() {
    this._RegionLevelFormsubmitted = true;
    if (this._RegionLevelForm.valid) {
      for (var i = 0; i < this._RegionList.length; i++) {
        if (this._RegionList[i].frombranchcode == this._RegionLevelForm.get("frombranchcode").value) {
          if (this._RegionList[i].toregioncode == this._RegionLevelForm.get("toregioncode").value) {
            if (this._RegionList[i].articlecode == this._RegionLevelForm.get("articlecode").value) {
              this._CustomExceptionService.handleWarning("The Record is Already Exists");
              return;
            }
          }
        }
      }
      var _contractfromDate = this._CostingContract.get("contractfromdate").value;//this.datepipe.transform(this._CostingContract.get("contractfromdate").value, 'dd-MM-yyyy');
      var _contracttoDate = this._CostingContract.get("contracttodate").value; //this.datepipe.transform(this._CostingContract.get("contracttodate").value, 'dd-MM-yyyy');;


      var __RegionListTemp: any = {};
      __RegionListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      __RegionListTemp.frombranchcode = this._RegionLevelForm.get("frombranchcode").value;
      __RegionListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == __RegionListTemp.frombranchcode)[0].branchname;
      __RegionListTemp.toregioncode = this._RegionLevelForm.get("toregioncode").value;
      __RegionListTemp.toregion = (this._Region || []).filter(f => f.regioncode == __RegionListTemp.toregioncode)[0].regionname;
      __RegionListTemp.articlecode = this._RegionLevelForm.get("articlecode").value;
      __RegionListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == __RegionListTemp.articlecode)[0].articlename;
      __RegionListTemp.ratetypecode = this._RegionLevelForm.get("ratetypecode").value;
      __RegionListTemp.ratetype = (this._RegionRateType || []).filter(f => f.metasubcode == __RegionListTemp.ratetypecode)[0].metasubdescription;
      __RegionListTemp.rate = this._RegionLevelForm.get("rate").value;
      __RegionListTemp.dcratetypecode = this._RegionLevelForm.get("dcratetypecode").value;
      __RegionListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == __RegionListTemp.dcratetypecode)[0].metasubdescription;
      __RegionListTemp.dcrate = this._RegionLevelForm.get("dcrate").value;
      __RegionListTemp.ddratetypecode = this._RegionLevelForm.get("ddratetypecode").value;
      __RegionListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == __RegionListTemp.ddratetypecode)[0].metasubdescription;
      __RegionListTemp.ddrate = this._RegionLevelForm.get("ddrate").value;
      __RegionListTemp.acratetypecode = this._RegionLevelForm.get("acratetypecode").value;
      __RegionListTemp.acratetype = this._RegionLevelForm.get("acratetype").value;
      __RegionListTemp.acrate = this._RegionLevelForm.get("acrate").value;
      __RegionListTemp.addoninclusiveorexclusivecode = this._RegionLevelForm.get("inclusiveorexclusivecode").value;
      __RegionListTemp.addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == __RegionListTemp.addoninclusiveorexclusivecode)[0].metasubdescription;
      __RegionListTemp.isneedreversebooking = this._RegionLevelForm.get("isneedreversebooking").value || false;
      __RegionListTemp.isneedreversebookingcode = this._RegionLevelForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';
      __RegionListTemp.dcinclusiveorexclusivecode = this._RegionLevelForm.get("dcinclusiveorexclusivecode").value;
      __RegionListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == __RegionListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      __RegionListTemp.ddinclusiveorexclusivecode = this._RegionLevelForm.get("ddinclusiveorexclusivecode").value;
      __RegionListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == __RegionListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;
      __RegionListTemp.effectivefrom = _contractfromDate;
      __RegionListTemp.effectiveto = _contracttoDate;
      //__RegionListTemp._DCKG = this._DCKG;
      //__RegionListTemp._DDKG = this._DDKG;
      //__RegionListTemp._DDPiece = this._DDPiece;
      //__RegionListTemp._DCPiece = this._DCPiece;

      var _lstDCDDACSlabsTemp = []
      var dcslabTypecode = this._RegionLevelForm.get("dcratetypecode").value;
      var ddslabTypecode = this._RegionLevelForm.get("ddratetypecode").value;
      var acslabTypecode = this._RegionLevelForm.get("acratetypecode").value;
      if (this._DCPiece.length > 0) {
        for (var i = 0; i < this._DCPiece.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabTypecode;
          _tempDCPiece.slabfrom = this._DCPiece[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG.length > 0) {
        for (var i = 0; i < this._DCKG.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00082";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabTypecode;
          _tempDCKG.slabfrom = this._DCKG[i].FromPiece;
          _tempDCKG.slabto = this._DCKG[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece.length > 0) {
        for (var i = 0; i < this._DDPiece.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00082";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabTypecode;
          _tempDDPiece.slabfrom = this._DDPiece[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG.length > 0) {
        for (var i = 0; i < this._DDKG.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00082";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabTypecode;
          _tempDDKG.slabfrom = this._DDKG[i].FromPiece;
          _tempDDKG.slabto = this._DDKG[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPiece.length > 0) {
        for (var i = 0; i < this._ACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabTypecode;
          _tempACPiece.slabfrom = this._ACPiece[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKG.length > 0) {
        for (var i = 0; i < this._ACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabTypecode;
          _tempACKG.slabfrom = this._ACKG[i].FromPiece;
          _tempACKG.slabto = this._ACKG[i].ToPiece;
          _tempACKG.slabrate = this._ACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      __RegionListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;
      this._RegionList.push(__RegionListTemp);
      this.ClearRowRegion();
    }
  }

  ClearRowRegion() {
    this._RegionLevelFormsubmitted = false;
    this._RegionLevelForm.reset();
    this._DCKG = [];
    this._DDKG = [];
    this._DDPiece = []
    this._DCPiece = [];
    this._ACKG = [];
    this._ACPiece = [];
    this._RegionIndex = null;
    this._updateRowRegion = true;
    this._addRowRegion = false;
  }

  addRowDCRate() {
    if (this._FromDCPiece != "" && this._ToDCPiece != "" && this._RateDCPiece != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPiece;
      _DCPieceTemp.ToPiece = this._ToDCPiece;
      _DCPieceTemp.Rate = this._RateDCPiece;
      this._DCPiece.push(_DCPieceTemp);
      this.ClearRowDCRate();
    }
  }
  ClearRowDCRate() {
    this._FromDCPiece = "";
    this._ToDCPiece = "";
    this._RateDCPiece = "";
  }

  Remove_DCPiece(RowIndex) {
    if (this._DCPiece.length > 1) {
      var index = this._DCPiece.indexOf(RowIndex);
      this._DCPiece.splice(index, 1)
    }
    else {
      var index = this._DCPiece.indexOf(RowIndex);
      this._DCPiece.splice(index, 1);
    }
  }

  ClearRowDCRateKG() {
    this._FromDCKG = "";
    this._ToDCKG = "";
    this._RateDCKG = "";
  }

  Remove_DCKG(RowIndex) {
    if (this._DCKG.length > 1) {
      var index = this._DCKG.indexOf(RowIndex);
      this._DCKG.splice(index, 1)
    }
    else {
      var index = this._DCKG.indexOf(RowIndex);
      this._DCKG.splice(index, 1);
    }
  }

  closeDCRate() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRate == '' || this._DCPieceAdditionalRate == null || this._DCPieceAdditionalRate == undefined) {
        this.displayDCRate = true;
        this.HideDCPieceAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['dcrate'].setValue(this._DCPieceAdditionalRate);
        this.HideDCPieceAdditionalRateMsg = true;
      }
    }
  }

  closeDCRateKG() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRate == '' || this._DCKGAdditionalRate == null || this._DCKGAdditionalRate == undefined) {
        this.displayDCRateKG = true;
        this.HideDCKGAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['dcrate'].setValue(this._DCKGAdditionalRate);
        this.HideDCKGAdditionalRateMsg = true;
      }
    }
  }

  closeDDRate() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRate == '' || this._DDPieceAdditionalRate == null || this._DDPieceAdditionalRate == undefined) {
        this.displayDDRate = true;
        this.HideDDPieceAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['ddrate'].setValue(this._DDPieceAdditionalRate);
        this.HideDDPieceAdditionalRateMsg = true;
      }
    }
  }
  closeDDRateKG() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRate == '' || this._DDKGAdditionalRate == null || this._DDKGAdditionalRate == undefined) {
        this.displayDDRateKG = true;
        this.HideDDKGAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['ddrate'].setValue(this._DDKGAdditionalRate);
        this.HideDDKGAdditionalRateMsg = true;
      }
    }
  }


  closeACRate() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate == '' || this._ACPieceAdditionalRate == null || this._ACPieceAdditionalRate == undefined) {
        this.displayDCRate = true;
        this.HideACPieceAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['acrate'].setValue(this._ACPieceAdditionalRate);
        this.HideACPieceAdditionalRateMsg = true;
      }
    }
  }
  closeACRateKG() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate == '' || this._ACKGAdditionalRate == null || this._ACKGAdditionalRate == undefined) {
        this.displayACRateKG = true;
        this.HideACKGAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['acrate'].setValue(this._ACKGAdditionalRate);
        this.HideACKGAdditionalRateMsg = true;
      }
    }
  }


  closeDCRateAB() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRateAB == '' || this._DCPieceAdditionalRateAB == null || this._DCPieceAdditionalRateAB == undefined) {
        this.displayDCRateAB = true;
        this.HideDCPieceAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['dcrate'].setValue(this._DCPieceAdditionalRateAB);
        this.HideDCPieceAdditionalRateMsgAB = true;
      }
    }
  }

  closeDCRateKGAB() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRateAB == '' || this._DCKGAdditionalRateAB == null || this._DCKGAdditionalRateAB == undefined) {
        this.displayDCRateKGAB = true;
        this.HideDCKGAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['dcrate'].setValue(this._DCKGAdditionalRateAB);
        this.HideDCKGAdditionalRateMsgAB = true;
      }
    }
  }

  closeDDRateAB() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRateAB == '' || this._DDPieceAdditionalRateAB == null || this._DDPieceAdditionalRateAB == undefined) {
        this.displayDDRateAB = true;
        this.HideDDPieceAdditionalRateMsg = false;
      }
      else {
        this._ArticleBasedForm.controls['ddrate'].setValue(this._DDPieceAdditionalRateAB);
        this.HideDDPieceAdditionalRateMsgAB = true;
      }
    }
  }
  closeDDRateKGAB() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRateAB == '' || this._DDKGAdditionalRateAB == null || this._DDKGAdditionalRateAB == undefined) {
        this.displayDDRateKGAB = true;
        this.HideDDKGAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['ddrate'].setValue(this._DDKGAdditionalRateAB);
        this.HideDDKGAdditionalRateMsgAB = true;
      }
    }
  }

  closeACRateAB() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateAB == '' || this._ACPieceAdditionalRateAB == null || this._ACPieceAdditionalRateAB == undefined) {
        this.displayDCRateAB = true;
        this.HideACPieceAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['acrate'].setValue(this._ACPieceAdditionalRateAB);
        this.HideACPieceAdditionalRateMsgAB = true;
      }
    }
  }
  closeACRateKGAB() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateAB == '' || this._ACKGAdditionalRateAB == null || this._ACKGAdditionalRateAB == undefined) {
        this.displayACRateKGAB = true;
        this.HideACKGAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['acrate'].setValue(this._ACKGAdditionalRateAB);
        this.HideACKGAdditionalRateMsgAB = true;
      }
    }
  }

  closeDCRateSP() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRateSP == '' || this._DCPieceAdditionalRateSP == null || this._DCPieceAdditionalRateSP == undefined) {
        this.displayDCRateSlab = true;
        this.HideDCPieceAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['dcrate'].setValue(this._DCPieceAdditionalRateSP);
        this.HideDCPieceAdditionalRateMsgSP = true;
      }
    }
  }

  closeDCRateKGSP() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRateSP == '' || this._DCKGAdditionalRateSP == null || this._DCKGAdditionalRateSP == undefined) {
        this.displayDCRateKGSlab = true;
        this.HideDCKGAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['dcrate'].setValue(this._DCKGAdditionalRateSP);
        this.HideDCKGAdditionalRateMsgSP = true;
      }
    }
  }

  closeDDRateSP() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRateSP == '' || this._DDPieceAdditionalRateSP == null || this._DDPieceAdditionalRateSP == undefined) {
        this.displayDDRateSlab = true;
        this.HideDDPieceAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['ddrate'].setValue(this._DDPieceAdditionalRateSP);
        this.HideDDPieceAdditionalRateMsgSP = true;
      }
    }
  }
  closeDDRateKGSP() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRateSP == '' || this._DDKGAdditionalRateSP == null || this._DDKGAdditionalRateSP == undefined) {
        this.displayDDRateKGSlab = true;
        this.HideDDKGAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['ddrate'].setValue(this._DDKGAdditionalRateSP);
        this.HideDDKGAdditionalRateMsgSP = true;
      }
    }
  }


  closeACRateSP() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateSP == '' || this._ACPieceAdditionalRateSP == null || this._ACPieceAdditionalRateSP == undefined) {
        this.displayDCRateSlab = true;
        this.HideACPieceAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['acrate'].setValue(this._ACPieceAdditionalRateSP);
        this.HideACPieceAdditionalRateMsgSP = true;
      }
    }
  }
  closeACRateKGSP() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateSP == '' || this._ACKGAdditionalRateSP == null || this._ACKGAdditionalRateSP == undefined) {
        this.displayACRateKGSlab = true;
        this.HideACKGAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['acrate'].setValue(this._ACKGAdditionalRateSP);
        this.HideACKGAdditionalRateMsgSP = true;
      }
    }
  }

  closeDCRate2D() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRate2D == '' || this._DCPieceAdditionalRate2D == null || this._DCPieceAdditionalRate2D == undefined) {
        this.displayDCRate2D = true;
        this.HideDCPieceAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['dcrate'].setValue(this._DCPieceAdditionalRate2D);
        this.HideDCPieceAdditionalRateMsg2D = true;
      }
    }
  }

  closeDCRateKG2D() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRate2D == '' || this._DCKGAdditionalRate2D == null || this._DCKGAdditionalRate2D == undefined) {
        this.displayDCRateKG2D = true;
        this.HideDCKGAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['dcrate'].setValue(this._DCKGAdditionalRate2D);
        this.HideDCKGAdditionalRateMsg2D = true;
      }
    }
  }

  closeDDRate2D() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRate2D == '' || this._DDPieceAdditionalRate2D == null || this._DDPieceAdditionalRate2D == undefined) {
        this.displayDDRate2D = true;
        this.HideDDPieceAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['ddrate'].setValue(this._DDPieceAdditionalRate2D);
        this.HideDDPieceAdditionalRateMsg2D = true;
      }
    }
  }
  closeDDRateKG2D() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRate2D == '' || this._DDKGAdditionalRate2D == null || this._DDKGAdditionalRate2D == undefined) {
        this.displayDDRateKG2D = true;
        this.HideDDKGAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['ddrate'].setValue(this._DDKGAdditionalRate2D);
        this.HideDDKGAdditionalRateMsg2D = true;
      }
    }
  }


  closeACRate2D() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate2D == '' || this._ACPieceAdditionalRate2D == null || this._ACPieceAdditionalRate2D == undefined) {
        this.displayDCRate2D = true;
        this.HideACPieceAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['acrate'].setValue(this._ACPieceAdditionalRate2D);
        this.HideACPieceAdditionalRateMsg2D = true;
      }
    }
  }
  closeACRateKG2D() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate2D == '' || this._ACKGAdditionalRate2D == null || this._ACKGAdditionalRate2D == undefined) {
        this.displayACRateKG2D = true;
        this.HideACKGAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['acrate'].setValue(this._ACKGAdditionalRate2D);
        this.HideACKGAdditionalRateMsg2D = true;
      }
    }
  }


  addRowDDRate() {
    if (this._FromDDPiece != "" && this._ToDDPiece != "" && this._RateDDPiece != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPiece;
      _DDPieceTemp.ToPiece = this._ToDDPiece;
      _DDPieceTemp.Rate = this._RateDDPiece;
      this._DDPiece.push(_DDPieceTemp);
      this.ClearRowDDRate();
    }
  }

  ClearRowDDRate() {
    this._FromDDPiece = "";
    this._ToDDPiece = "";
    this._RateDDPiece = "";
  }

  Remove_DDPiece(RowIndex) {
    if (this._DDPiece.length > 1) {
      var index = this._DDPiece.indexOf(RowIndex);
      this._DDPiece.splice(index, 1)
    }
    else {
      var index = this._DDPiece.indexOf(RowIndex);
      this._DDPiece.splice(index, 1);
    }
  }

  addRowDDRateKG() {
    if (this._FromDDKG != "" && this._ToDDKG != "" && this._RateDDKG != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKG;
      _DDPieceGKTemp.ToPiece = this._ToDDKG;
      _DDPieceGKTemp.Rate = this._RateDDKG;
      this._DDKG.push(_DDPieceGKTemp);
      this.ClearRowDDRateKG();
    }
  }
  ClearRowDDRateKG() {
    this._FromDDKG = "";
    this._ToDDKG = "";
    this._RateDDKG = "";
  }

  Remove_DDKG(RowIndex) {
    if (this._DDKG.length > 1) {
      var index = this._DDKG.indexOf(RowIndex);
      this._DDKG.splice(index, 1)
    }
    else {
      var index = this._DDKG.indexOf(RowIndex);
      this._DDKG.splice(index, 1);
    }
  }

  onRowSelectPopupArticleChargeCode(event: any) {
    var row = event.data;
    this._RegionLevelForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    this._RegionLevelForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateType = false;
  }

  addRowACRate() {
    if (this._FromACPiece != "" && this._ToACPiece != "" && this._RateACPiece != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece;
      _DCPieceTemp.ToPiece = this._ToACPiece;
      _DCPieceTemp.Rate = this._RateACPiece;
      this._ACPiece.push(_DCPieceTemp);
      this.ClearRowACRate();
    }
  }
  ClearRowACRate() {
    this._FromACPiece = "";
    this._ToACPiece = "";
    this._RateACPiece = "";
  }
  addRowACRateKG() {
    if (this._FromACKG != "" && this._ToACKG != "" && this._RateACKG != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG;
      _DCPieceGKTemp.ToPiece = this._ToACKG;
      _DCPieceGKTemp.Rate = this._RateACKG;
      this._ACKG.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG();
    }
  }
  ClearRowACRateKG() {
    this._FromACKG = "";
    this._ToACKG = "";
    this._RateACKG = "";
  }
  ArticleChargeCode(event) {

  }

  Remove_ACPiece(RowIndex) {
    if (this._ACPiece.length > 1) {
      var index = this._ACPiece.indexOf(RowIndex);
      this._ACPiece.splice(index, 1)
    }
    else {
      var index = this._ACPiece.indexOf(RowIndex);
      this._ACPiece.splice(index, 1);
    }
  }
  Remove_ACKG(RowIndex) {
    if (this._ACKG.length > 1) {
      var index = this._ACKG.indexOf(RowIndex);
      this._ACKG.splice(index, 1)
    }
    else {
      var index = this._ACKG.indexOf(RowIndex);
      this._ACKG.splice(index, 1);
    }
  }
  Remove_RegionList(RowIndex) {
    if (this._RegionList.length > 1) {
      var index = this._RegionList.indexOf(RowIndex);
      this._RegionList.splice(index, 1)
    }
    else {
      var index = this._RegionList.indexOf(RowIndex);
      this._RegionList.splice(index, 1);
    }
  }
  onRowSelect_RegionList(row: CustomerSiteContractRegion, index) {
    //debugger;
    this.ClearRowRegion();
    this._RegionIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    this._RegionLevelForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._RegionLevelForm.controls['toregioncode'].setValue(row.toregioncode);
    this._RegionLevelForm.controls['articlecode'].setValue(row.articlecode);
    this._RegionLevelForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._RegionLevelForm.controls['rate'].setValue(row.rate);
    this._RegionLevelForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._RegionLevelForm.controls['dcrate'].setValue(row.dcrate);
    this._RegionLevelForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._RegionLevelForm.controls['ddrate'].setValue(row.ddrate);
    this._RegionLevelForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._RegionLevelForm.controls['acratetype'].setValue(row.acratetype);
    this._RegionLevelForm.controls['acrate'].setValue(row.acrate);
    this._RegionLevelForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._RegionLevelForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._RegionLevelForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._RegionLevelForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);
    /////////this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPiece.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKG.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPiece.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKG.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635') {
            this._ACPiece.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634') {
            this._ACPiece.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowRegion = false;
    this._addRowRegion = true;

  }

  exportExcelRegionList() {
    let RegionList = this.GetExcelRegionList();
    this.exportUtility.exportExcel(RegionList, 'Region List', 'xlsx');
  }



  //---------------- Article Based -------------------//


  showBasicDialogDCRateAB() {
    if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRateAB = true;
      if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRateAB = this._ArticleBasedForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKGAB = true;
      if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRateAB = this._ArticleBasedForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00098';
        this._DCKGAdditionalRateAB = '';
      }
    }

  }
  addRowDCRateAB() {
    if (this._FromDCPieceAB != "" && this._ToDCPieceAB != "" && this._RateDCPieceAB != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPieceAB;
      _DCPieceTemp.ToPiece = this._ToDCPieceAB;
      _DCPieceTemp.Rate = this._RateDCPieceAB;
      this._DCPieceAB.push(_DCPieceTemp);
      this.ClearRowDCRateAB();
    }
  }
  ClearRowDCRateAB() {
    this._FromDCPieceAB = "";
    this._ToDCPieceAB = "";
    this._RateDCPieceAB = "";
  }
  addRowDCRateKGAB() {
    if (this._FromDCKGAB != "" && this._ToDCKGAB != "" && this._RateDCKGAB != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKGAB;
      _DCPieceGKTemp.ToPiece = this._ToDCKGAB;
      _DCPieceGKTemp.Rate = this._RateDCKGAB;
      this._DCKGAB.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGAB();
    }
  }
  ClearRowDCRateKGAB() {
    this._FromDCKGAB = "";
    this._ToDCKGAB = "";
    this._RateDCKGAB = "";
  }
  showBasicDialogDDRateAB() {
    if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00095' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRateAB = true;
      if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRateAB = this._ArticleBasedForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00096' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKGAB = true;
      if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00630';
        this._DDKGAdditionalRateAB = this._ArticleBasedForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00095';
        this._DDKGAdditionalRateAB = '';
      }
    }

  }
  addRowDDRateAB() {
    if (this._FromDDPieceAB != "" && this._ToDDPieceAB != "" && this._RateDDPieceAB != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPieceAB;
      _DDPieceTemp.ToPiece = this._ToDDPieceAB;
      _DDPieceTemp.Rate = this._RateDDPieceAB;
      this._DDPieceAB.push(_DDPieceTemp);
      this.ClearRowDDRateAB();
    }
  }
  ClearRowDDRateAB() {
    this._FromDDPieceAB = "";
    this._ToDDPieceAB = "";
    this._RateDDPieceAB = "";
  }
  addRowDDRateKGAB() {
    if (this._FromDDKGAB != "" && this._ToDDKGAB != "" && this._RateDDKGAB != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKGAB;
      _DDPieceGKTemp.ToPiece = this._ToDDKGAB;
      _DDPieceGKTemp.Rate = this._RateDDKGAB;
      this._DDKGAB.push(_DDPieceGKTemp);
      this.ClearRowDDRateKGAB();
    }
  }
  ClearRowDDRateKGAB() {
    this._FromDDKGAB = "";
    this._ToDDKGAB = "";
    this._RateDDKGAB = "";
  }
  showBasicDialogACRateAB() {
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00631') {
    //   this.displayACRateAB = true;
    // }
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00632') {
    //   this.displayACRateKGAB = true;
    // }

    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635') {
      this.displayACRateAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635') {
        this.HideACPieceAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00635';
        this._ACPieceAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
      }
      else {
        this.HideACPieceAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
      this.displayACRateKGAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00634';
        this._ACKGAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
      }
      else {
        this.HideACKGAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateAB = '';
      }
    }

  }
  addRowACRateAB() {
    if (this._FromACPieceAB != "" && this._ToACPieceAB != "" && this._RateACPieceAB != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceAB;
      _DCPieceTemp.ToPiece = this._ToACPieceAB;
      _DCPieceTemp.Rate = this._RateACPieceAB;
      this._ACPieceAB.push(_DCPieceTemp);
      this.ClearRowACRateAB();
    }
  }
  ClearRowACRateAB() {
    this._FromACPieceAB = "";
    this._ToACPieceAB = "";
    this._RateACPieceAB = "";
  }
  addRowACRateKGAB() {
    if (this._FromACKGAB != "" && this._ToACKGAB != "" && this._RateACKGAB != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGAB;
      _DCPieceGKTemp.ToPiece = this._ToACKGAB;
      _DCPieceGKTemp.Rate = this._RateACKGAB;
      this._ACKGAB.push(_DCPieceGKTemp);
      this.ClearRowACRateKGAB();
    }
  }
  ClearRowACRateKGAB() {
    this._FromDCKGAB = "";
    this._ToDCKGAB = "";
    this._RateDCKGAB = "";
  }
  ArticleChargeCodeAB(event) {

  }
  showBasicDialogArticleChargeCodeAB() {
    this.displayACRateTypeAB = true;
  }
  onRowSelectPopupArticleChargeCodeAB(event: any) {
    var row = event.data;
    this._ArticleBasedForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._ArticleBasedForm.controls['acrate'].setValue(row.rate);
    this._ArticleBasedForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateTypeAB = false;
  }
  ChangeVolumetric(event) {
    var VolumetricValue = event.value

    var CustCode = this._CustomerSiteCode || this.CustomersiteCode
    this._CustomerSUKService.GetById(CustCode).subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      if (resultJSON.tranStatus.result == true) {
        //this.SUKList = resultJSON.lstCustomerSiteSKU;
        this._SkuTypeList = resultJSON.lstCustomerSiteSKU;
        // if (VolumetricValue == 1) {
        //   this._SkuTypeList = this.SUKList.filter(f => f.SkuUomCode != null)
        //   console.log(this._SkuTypeList);
        //   this._ArticleBasedForm.controls['ratetypecode'].setValue("MSC00088")
        // } else {
        //   this._SkuTypeList = this.SUKList.filter(f => f.SkuUomCode == null || f.SkuUomCode == "")
        //   this._ArticleBasedForm.controls['ratetypecode'].setValue("MSC00089")

        // }
      }
    }, error => {
      this._CustomExceptionService.handleError(error);
    });

  }

  ChangeArticle(event) {
    // if (this._ArticleBasedForm.get("articlecode").value != null && this._ArticleBasedForm.get("articlecode").value != '' && this._ArticleBasedForm.get("articlecode").value != undefined) {
    //   let ArticleValue = (this._SkuTypeList).filter(f => f.skuId == this._ArticleBasedForm.get("articlecode").value);
    //   if (ArticleValue.length > 0) {
    //     if (event.value == 'MSC00089') {
    //       this._ArticleBasedForm.controls['kg'].setValue(1)
    //     }
    //     else {
    //       this._ArticleBasedForm.controls['kg'].setValue(ArticleValue[0].cftWeight)
    //     }
    //   }
    // }
  }
  ChangeDiscountPercentage(row: any, event) {
    // row.discount = 0;
    let FinalAmount = row.rate * row.discount / 100
    row.finalrate = row.rate - FinalAmount

  }
  addRowArticleBase() {
    this._ArticleBasedFormsubmitted = true;

    if (this._ArticleBasedForm.valid) {
    

      var _lstDCDDACSlabsTemp = []
      var dcslabTypecode = this._ArticleBasedForm.get("dcratetypecode").value;
      var ddslabTypecode = this._ArticleBasedForm.get("ddratetypecode").value;
      var acslabTypecode = this._ArticleBasedForm.get("acratetypecode").value;
      if (this._DCPieceAB.length > 0) {
        for (var i = 0; i < this._DCPieceAB.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabTypecode;
          _tempDCPiece.slabfrom = this._DCPieceAB[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceAB[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGAB.length > 0) {
        for (var i = 0; i < this._DCKGAB.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00083";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabTypecode;
          _tempDCKG.slabfrom = this._DCKGAB[i].FromPiece;
          _tempDCKG.slabto = this._DCKGAB[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceAB.length > 0) {
        for (var i = 0; i < this._DDPieceAB.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00083";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabTypecode;
          _tempDDPiece.slabfrom = this._DDPieceAB[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceAB[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGAB.length > 0) {
        for (var i = 0; i < this._DDKGAB.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00083";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabTypecode;
          _tempDDKG.slabfrom = this._DDKGAB[i].FromPiece;
          _tempDDKG.slabto = this._DDKGAB[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPieceAB.length > 0) {
        for (var i = 0; i < this._ACPieceAB.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00083";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabTypecode;
          _tempACPiece.slabfrom = this._ACPieceAB[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceAB[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKGAB.length > 0) {
        for (var i = 0; i < this._ACKGAB.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00083";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabTypecode;
          _tempACKG.slabfrom = this._ACKGAB[i].FromPiece;
          _tempACKG.slabto = this._ACKGAB[i].ToPiece;
          _tempACKG.slabrate = this._ACKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

        var _contractfromDate = this._CostingContract.get("contractfromdate").value;
        var _contracttoDate = this._CostingContract.get("contracttodate").value;

      var _ArticleBaseListTemp: any = {};
      _ArticleBaseListTemp.tobranchcode = this._ArticleBasedForm.get("tobranchcode").value;
      _ArticleBaseListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.tobranchcode)[0].branchname;
      _ArticleBaseListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _ArticleBaseListTemp.frombranchcode = this._ArticleBasedForm.get("frombranchcode").value;
      _ArticleBaseListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.frombranchcode)[0].branchname;
      _ArticleBaseListTemp.articlecode = this._ArticleBasedForm.get("articlecode").value;
      _ArticleBaseListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _ArticleBaseListTemp.articlecode)[0].articlename;
      _ArticleBaseListTemp.ratetypecode = this._ArticleBasedForm.get("ratetypecode").value;
      _ArticleBaseListTemp.ratetype = (this._RateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ratetypecode)[0].metasubdescription;
      
      _ArticleBaseListTemp.finalrate = this._ArticleBasedForm.get("rate").value;
      _ArticleBaseListTemp.rate = this._ArticleBasedForm.get("rate").value;
      _ArticleBaseListTemp.quintalRateperKM = this._ArticleBasedForm.get("rateperkm").value;

      _ArticleBaseListTemp.dcratetypecode = this._ArticleBasedForm.get("dcratetypecode").value;
      _ArticleBaseListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.dcratetypecode)[0].metasubdescription;
      _ArticleBaseListTemp.dcrate = this._ArticleBasedForm.get("dcrate").value;
      _ArticleBaseListTemp.ddratetypecode = this._ArticleBasedForm.get("ddratetypecode").value;
      _ArticleBaseListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ddratetypecode)[0].metasubdescription;
      _ArticleBaseListTemp.ddrate = this._ArticleBasedForm.get("ddrate").value;
      _ArticleBaseListTemp.acratetypecode = this._ArticleBasedForm.get("acratetypecode").value;
      _ArticleBaseListTemp.acratetype = this._ArticleBasedForm.get("acratetype").value;
      _ArticleBaseListTemp.acrate = this._ArticleBasedForm.get("acrate").value;
      _ArticleBaseListTemp.addoninclusiveorexclusivecode = this._ArticleBasedForm.get("inclusiveorexclusivecode").value;
      _ArticleBaseListTemp.addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _ArticleBaseListTemp.addoninclusiveorexclusivecode)[0].metasubdescription;
      _ArticleBaseListTemp.isneedreversebooking = this._ArticleBasedForm.get("isneedreversebooking").value || false;
      _ArticleBaseListTemp.isneedreversebookingcode = this._ArticleBasedForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';
      _ArticleBaseListTemp.dcinclusiveorexclusivecode = this._ArticleBasedForm.get("dcinclusiveorexclusivecode").value;
      _ArticleBaseListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _ArticleBaseListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      _ArticleBaseListTemp.ddinclusiveorexclusivecode = this._ArticleBasedForm.get("ddinclusiveorexclusivecode").value;
      _ArticleBaseListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;
      _ArticleBaseListTemp.effectivefrom =_contractfromDate;
      _ArticleBaseListTemp.effectiveto = _contracttoDate;

      _ArticleBaseListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;
      this._ArticleBasedList.push(_ArticleBaseListTemp);

      this.ClearRowArticleBase();
      

    }

  }
  ClearRowArticleBase() {
    this._ArticleBasedFormsubmitted = false;
    this._ArticleBasedForm.reset();
    this._DCKGAB = [];
    this._DDKGAB = [];
    this._DDPieceAB = []
    this._DCPieceAB = [];
    this._ACKGAB = [];
    this._ACPieceAB = [];
    this._ArticleBasedIndex = null;
    this._updateRowArticleBased = true;
    this._addRowArticleBased = false;
  }

  onChangeDCRateTypeAB() {


  }
  onChangeDDRateTypeAB() {

  }

  Remove_DCPieceAB(RowIndex) {
    if (this._DCPieceAB.length > 1) {
      var index = this._DCPieceAB.indexOf(RowIndex);
      this._DCPieceAB.splice(index, 1)
    }
    else {
      var index = this._DCPieceAB.indexOf(RowIndex);
      this._DCPieceAB.splice(index, 1);
    }
  }
  Remove_DCKGAB(RowIndex) {
    if (this._DCKGAB.length > 1) {
      var index = this._DCKGAB.indexOf(RowIndex);
      this._DCKGAB.splice(index, 1)
    }
    else {
      var index = this._DCKGAB.indexOf(RowIndex);
      this._DCKGAB.splice(index, 1);
    }
  }
  Remove_DDPieceAB(RowIndex) {
    if (this._DDPieceAB.length > 1) {
      var index = this._DDPieceAB.indexOf(RowIndex);
      this._DDPieceAB.splice(index, 1)
    }
    else {
      var index = this._DDPieceAB.indexOf(RowIndex);
      this._DDPieceAB.splice(index, 1);
    }
  }
  Remove_DDKGAB(RowIndex) {
    if (this._DDKGAB.length > 1) {
      var index = this._DDKGAB.indexOf(RowIndex);
      this._DDKGAB.splice(index, 1)
    }
    else {
      var index = this._DDKGAB.indexOf(RowIndex);
      this._DDKGAB.splice(index, 1);
    }
  }
  Remove_ACPieceAB(RowIndex) {
    if (this._ACPieceAB.length > 1) {
      var index = this._ACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1)
    }
    else {
      var index = this._ACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1);
    }
  }
  Remove_ACKGAB(RowIndex) {
    if (this._ACKGAB.length > 1) {
      var index = this._ACKGAB.indexOf(RowIndex);
      this._ACKGAB.splice(index, 1)
    }
    else {
      var index = this._ACKGAB.indexOf(RowIndex);
      this._ACKGAB.splice(index, 1);
    }
  }
  Remove_ArticleBasedList(RowIndex) {
    if (this._ArticleBasedList.length > 1) {
      var index = this._ArticleBasedList.indexOf(RowIndex);
      this._ArticleBasedList.splice(index, 1)
    }
    else {
      var index = this._ArticleBasedList.indexOf(RowIndex);
      this._ArticleBasedList.splice(index, 1);
    }
  }
  onRowSelect_ArticleBasedList(row: CustomerSiteContractArticle, index) {
    //debugger;
    this.ClearRowArticleBase();
    // console.log(row);
    this._ArticleBasedIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._ArticleBasedIndex);
    this._ArticleBasedForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._ArticleBasedForm.controls['tobranchcode'].setValue(row.tobranchcode);
    this._ArticleBasedForm.controls['articlecode'].setValue(row.articlecode);
    this._ArticleBasedForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._ArticleBasedForm.controls['rate'].setValue(row.rate);
    this._ArticleBasedForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._ArticleBasedForm.controls['dcrate'].setValue(row.dcrate);
    this._ArticleBasedForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._ArticleBasedForm.controls['ddrate'].setValue(row.ddrate);
    this._ArticleBasedForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._ArticleBasedForm.controls['acratetype'].setValue(row.acratetype);
    this._ArticleBasedForm.controls['acrate'].setValue(row.acrate);
    this._ArticleBasedForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._ArticleBasedForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._ArticleBasedForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._ArticleBasedForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);
    /////_ArticleBasedFormLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPieceAB.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKGAB.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPieceAB.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKGAB.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635') {
            this._ACPieceAB.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634') {
            this._ACPieceAB.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowArticleBased = false;
    this._addRowArticleBased = true;
  }
  updateRowArticleBase() {
    if (this._ArticleBasedIndex != null) {
      this._ArticleBasedFormsubmitted = true;

      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;

      var ii = this._ArticleBasedIndex;
      this._ArticleBasedList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._ArticleBasedList[ii].frombranchcode = this._ArticleBasedForm.get("frombranchcode").value;
      this._ArticleBasedList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._ArticleBasedForm.get("frombranchcode").value)[0].branchname;
      this._ArticleBasedList[ii].tobranchcode = this._ArticleBasedForm.get("tobranchcode").value;
      this._ArticleBasedList[ii].tobranch = (this._BillingBranch || []).filter(f => f.branchcode == this._ArticleBasedForm.get("tobranchcode").value)[0].branchname;
      this._ArticleBasedList[ii].articlecode = this._ArticleBasedForm.get("articlecode").value;
      this._ArticleBasedList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._ArticleBasedForm.get("articlecode").value)[0].articlename;
      this._ArticleBasedList[ii].ratetypecode = this._ArticleBasedForm.get("ratetypecode").value;
      this._ArticleBasedList[ii].ratetype = (this._RateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].rate = this._ArticleBasedForm.get("rate").value;
      this._ArticleBasedList[ii].dcratetypecode = this._ArticleBasedForm.get("dcratetypecode").value;
      this._ArticleBasedList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("dcratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].dcrate = this._ArticleBasedForm.get("dcrate").value;
      this._ArticleBasedList[ii].ddratetypecode = this._ArticleBasedForm.get("ddratetypecode").value;
      this._ArticleBasedList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ddratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].ddrate = this._ArticleBasedForm.get("ddrate").value;
      this._ArticleBasedList[ii].acratetypecode = this._ArticleBasedForm.get("acratetypecode").value;
      this._ArticleBasedList[ii].acratetype = this._ArticleBasedForm.get("acratetype").value;
      this._ArticleBasedList[ii].acrate = this._ArticleBasedForm.get("acrate").value;
      this._ArticleBasedList[ii].addoninclusiveorexclusivecode = this._ArticleBasedForm.get("inclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].isneedreversebooking = this._ArticleBasedForm.get("isneedreversebooking").value || false;
      this._ArticleBasedList[ii].isneedreversebookingcode = this._ArticleBasedForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      this._ArticleBasedList[ii].dcinclusiveorexclusivecode = this._ArticleBasedForm.get("dcinclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].ddinclusiveorexclusivecode = this._ArticleBasedForm.get("ddinclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].effectivefrom = _contractfromDate;
      this._ArticleBasedList[ii].effectiveto = _contracttoDate;

      var _lstDCDDACSlabsTemp = []
      var dcslabTypecode = this._ArticleBasedForm.get("dcratetypecode").value;
      var ddslabTypecode = this._ArticleBasedForm.get("ddratetypecode").value;
      var acslabTypecode = this._ArticleBasedForm.get("acratetypecode").value;
      if (this._DCPieceAB.length > 0) {
        for (var i = 0; i < this._DCPieceAB.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabTypecode;
          _tempDCPiece.slabfrom = this._DCPieceAB[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceAB[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGAB.length > 0) {
        for (var i = 0; i < this._DCKGAB.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00083";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabTypecode;
          _tempDCKG.slabfrom = this._DCKGAB[i].FromPiece;
          _tempDCKG.slabto = this._DCKGAB[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceAB.length > 0) {
        for (var i = 0; i < this._DDPieceAB.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00083";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabTypecode;
          _tempDDPiece.slabfrom = this._DDPieceAB[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceAB[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGAB.length > 0) {
        for (var i = 0; i < this._DDKGAB.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00083";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabTypecode;
          _tempDDKG.slabfrom = this._DDKGAB[i].FromPiece;
          _tempDDKG.slabto = this._DDKGAB[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPieceAB.length > 0) {
        for (var i = 0; i < this._ACPieceAB.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00083";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabTypecode;
          _tempACPiece.slabfrom = this._ACPieceAB[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceAB[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKGAB.length > 0) {
        for (var i = 0; i < this._ACKGAB.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00083";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabTypecode;
          _tempACKG.slabfrom = this._ACKGAB[i].FromPiece;
          _tempACKG.slabto = this._ACKGAB[i].ToPiece;
          _tempACKG.slabrate = this._ACKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }



      this._ArticleBasedList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;


      this._ArticleBasedIndex = null;
      this._updateRowArticleBased = true;
      this._addRowArticleBased = false;
      this.ClearRowArticleBase();

    }
  }

  exportExcelArticle() {
    let ArticleList = this.GetExcelArticleList();
    this.exportUtility.exportExcel(ArticleList, 'Article List', 'xlsx');
  }


  selectSlabFile(event) {
    this.SlabselectedFiles = event.target.files;
    this.ValidateSlab = false
  }

  Slabupload() {
    this.currentFile = this.SlabselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempSlabList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempSlabList_.length; i++) {

        var _FromBranch = this.TempSlabList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          var _ToBranch = this.TempSlabList_[i].ToBranch
          var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
          if (ToBranch.length > 0) {
            var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " To Branch Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }

          var _ArticleName = this.TempSlabList_[i].Article
          var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " Article Name Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }

          var _SlabType = this.TempSlabList_[i].RateType
          var SlabType = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
          if (SlabType.length > 0) {
            var SlabTypeCode_ = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }
          var _DCRateType = this.TempSlabList_[i].DCRateType
          var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }
          var _DDRateType = this.TempSlabList_[i].DDRateType
          var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }
          var _ACRateType = this.TempSlabList_[i].ArticleChargeCode
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ArticleChargeCode + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }
          var _AddonCharge = this.TempSlabList_[i].AddonCharges
          var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarSlab.nativeElement.value = "";
          this.ValidateSlab = true
          return;
        }

        var _DCCharge = this.TempSlabList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
        if (DCCharge.length > 0) {
          var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DCCharges + "'" + " DC Charge Invalid.");
          this.InputVarSlab.nativeElement.value = "";
          this.ValidateSlab = true
          return;
        }

        var _DDCharge = this.TempSlabList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        if (DDCharge.length > 0) {
          var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DDCharges + "'" + " DD Charge Invalid.");
          this.InputVarSlab.nativeElement.value = "";
          this.ValidateSlab = true
          return;
        }
      }
      for (var i = 0; i < this.TempSlabList_.length; i++) {
        var SlabTemp: any = {};
        this.InputVarSlab.nativeElement.value = "";
        this.ValidateSlab = true

        var _FromBranch = this.TempSlabList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        // if (FromBranch.length > 0) {
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        var _ToBranch = this.TempSlabList_[i].ToBranch
        var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
        // if (ToBranch.length > 0) {
        var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " To Branch Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _ArticleName = this.TempSlabList_[i].Article
        var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
        // if (ArticleName.length > 0) {
        var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " Article Name Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _SlabType = this.TempSlabList_[i].RateType
        var SlabType = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
        // if (SlabType.length > 0) {
        var SlabTypeCode_ = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].RateType + "'" + " Rate Type Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DCRateType = this.TempSlabList_[i].DCRateType
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        // if (DCRateType.length > 0) {
        var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].RateType + "'" + " DC Rate Type Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DDRateType = this.TempSlabList_[i].DDRateType
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        // if (DDRateType.length > 0) {
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _AddonCharge = this.TempSlabList_[i].AddonCharges
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
        // if (AddonCharge.length > 0) {
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;



        var _ACRateType = this.TempSlabList_[i].ArticleChargeCode
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());

        var _DCCharge = this.TempSlabList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempSlabList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        //if (DDRateType.length > 0) {
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].FromBranch + "'" + " From Branch Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var ReverseBookingcode;
        if (this.TempSlabList_[i].ReverseBooking == "true") {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        SlabTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        SlabTemp.frombranch = _FromBranch;
        SlabTemp.tobranch = _ToBranch;

        SlabTemp.frombranchcode = FromBranchCode_;
        SlabTemp.tobranchcode = ToBranchCode_;

        SlabTemp.article = _ArticleName;
        SlabTemp.articlecode = ArticleNameCode_;
        SlabTemp.ratetype = _SlabType
        SlabTemp.ratetypecode = SlabTypeCode_
        SlabTemp.rate = this.TempSlabList_[i].Rate
        SlabTemp.dcratetype = _DCRateType
        SlabTemp.ddratetype = _DDRateType
        SlabTemp.acratetype = _ACRateType
        SlabTemp.acratetypecode = ACRateTypeCode_
        SlabTemp.dcratetypecode = DCRateTypeCode_
        SlabTemp.ddratetypecode = DDRateTypeCode_
        SlabTemp.acrate = ACRate

        SlabTemp.dcinclusiveorexclusive = _DCCharge
        SlabTemp.dcinclusiveorexclusivecode = DCChargeCode_
        SlabTemp.ddinclusiveorexclusive = _DDCharge
        SlabTemp.ddinclusiveorexclusivecode = DDChargeCode_

        SlabTemp.inclusiveorexclusive = _AddonCharge
        SlabTemp.inclusiveorexclusivecode = AddonChargeCode_
        SlabTemp.isneedreversebooking = this.TempSlabList_[i].ReverseBooking
        SlabTemp.isneedreversebookingcode = ReverseBookingcode
        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        // this._SlabFormList.push(SlabTemp);
        var _lstRateSlabsTemp = []

        var _tempDCPie: any = {};
        _tempDCPie.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPie.slabfrom = 1;
        _tempDCPie.slabto = 1;
        _tempDCPie.slabrate = this.TempSlabList_[i].Rate;
        _tempDCPie.contracttypecode = 'MSC00084';
        _tempDCPie.contracttype = 'MSC00084';
        _lstRateSlabsTemp.push(_tempDCPie);

        SlabTemp.rate = '';
        SlabTemp.lstRateSlabs = _lstRateSlabsTemp;

        var _lstAddOnSlabsTemp = []
        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempSlabList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          SlabTemp.dcrate = '';
        }
        else {
          SlabTemp.dcrate = this.TempSlabList_[i].DCRate
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempSlabList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          SlabTemp.ddrate = '';
        }
        else {
          SlabTemp.ddrate = this.TempSlabList_[i].DDRate
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        SlabTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        this._SlabFormList.push(SlabTemp);

      }
    }
  }


  //---------------- Slab -------------------//

  showBasicDialogSlab() {
    if (this._SlabForm.get("ratetypecode").value == 'MSC00091' || this._SlabForm.get("ratetypecode").value == 'MSC00967') {
      this.displaySlab = true;
    }
    if (this._SlabForm.get("ratetypecode").value == 'MSC00092' || this._SlabForm.get("ratetypecode").value == 'MSC00968') {
      this.displayKGSlab = true;
    }

  }

  addRowRateSlab() {
    if (this._FromPieceSlab != "" && this._ToPieceSlab != "" && this._RatePieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPieceSlab;
      _DCPieceTemp.ToPiece = this._ToPieceSlab;
      _DCPieceTemp.Rate = this._RatePieceSlab;
      this._PieceSlab.push(_DCPieceTemp);
      this.ClearRowRateSlab();
    }
  }
  ClearRowRateSlab() {
    this._FromPieceSlab = "";
    this._ToPieceSlab = "";
    this._RatePieceSlab = "";
  }
  addRowRateKGSlab() {
    if (this._FromKGSlab != "" && this._ToKGSlab != "" && this._RateKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToKGSlab;
      _DCPieceGKTemp.Rate = this._RateKGSlab;
      this._KGSlab.push(_DCPieceGKTemp);
      this.ClearRowRateKGSlab();
    }
  }
  ClearRowRateKGSlab() {
    this._FromKGSlab = "";
    this._ToKGSlab = "";
    this._RateKGSlab = "";
  }

  addRowDCRateSlab() {
    if (this._FromDCPieceSlab != "" && this._ToDCPieceSlab != "" && this._RateDCPieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPieceSlab;
      _DCPieceTemp.ToPiece = this._ToDCPieceSlab;
      _DCPieceTemp.Rate = this._RateDCPieceSlab;
      this._DCPieceSlab.push(_DCPieceTemp);
      this.ClearRowDCRateSlab();
    }
  }
  ClearRowDCRateSlab() {
    this._FromDCPieceSlab = "";
    this._ToDCPieceSlab = "";
    this._RateDCPieceSlab = "";
  }
  addRowDCRateKGSlab() {
    if (this._FromDCKGSlab != "" && this._ToDCKGSlab != "" && this._RateDCKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToDCKGSlab;
      _DCPieceGKTemp.Rate = this._RateDCKGSlab;
      this._DCKGSlab.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGSlab();
    }
  }
  ClearRowDCRateKGSlab() {
    this._FromDCKGSlab = "";
    this._ToDCKGSlab = "";
    this._RateDCKGSlab = "";
  }

  addRowDDRateSlab() {
    if (this._FromDDPieceSlab != "" && this._ToDDPieceSlab != "" && this._RateDDPieceSlab != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPieceSlab;
      _DDPieceTemp.ToPiece = this._ToDDPieceSlab;
      _DDPieceTemp.Rate = this._RateDDPieceSlab;
      this._DDPieceSlab.push(_DDPieceTemp);
      this.ClearRowDDRateSlab();
    }
  }
  ClearRowDDRateSlab() {
    this._FromDDPieceSlab = "";
    this._ToDDPieceSlab = "";
    this._RateDDPieceSlab = "";
  }
  addRowDDRateKGSlab() {
    if (this._FromDDKGSlab != "" && this._ToDDKGSlab != "" && this._RateDDKGSlab != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKGSlab;
      _DDPieceGKTemp.ToPiece = this._ToDDKGSlab;
      _DDPieceGKTemp.Rate = this._RateDDKGSlab;
      this._DDKGSlab.push(_DDPieceGKTemp);
      this.ClearRowDDRateKGSlab();
    }
  }
  ClearRowDDRateKGSlab() {
    this._FromDDKGSlab = "";
    this._ToDDKGSlab = "";
    this._RateDDKGSlab = "";
  }

  addRowACRateSlab() {
    if (this._FromACPieceSlab != "" && this._ToACPieceSlab != "" && this._RateACPieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceSlab;
      _DCPieceTemp.ToPiece = this._ToACPieceSlab;
      _DCPieceTemp.Rate = this._RateACPieceSlab;
      this._ACPieceSlab.push(_DCPieceTemp);
      this.ClearRowACRateSlab();
    }
  }
  ClearRowACRateSlab() {
    this._FromACPieceSlab = "";
    this._ToACPieceSlab = "";
    this._RateACPieceSlab = "";
  }
  addRowACRateKGSlab() {
    if (this._FromACKGSlab != "" && this._ToACKGSlab != "" && this._RateACKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToACKGSlab;
      _DCPieceGKTemp.Rate = this._RateACKGSlab;
      this._ACKGSlab.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGSlab();
    }
  }
  ClearRowACRateKGSlab() {
    this._FromACKGSlab = "";
    this._ToACKGSlab = "";
    this._RateACKGSlab = "";
  }
  ArticleChargeCodeSlab(event) {

  }
  showBasicDialogArticleChargeCodeSlab() {
    this.displayACRateTypeSlab = true;
  }
  onRowSelectPopupArticleChargeCodeSlab(event: any) {
    var row = event.data;
    this._SlabForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._SlabForm.controls['acrate'].setValue(row.rate);
    this._SlabForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateTypeSlab = false;
  }


  ClearRowSlab() {
    this._SlabFormsubmitted = false;
    this._SlabForm.reset();
    this._DCKGSlab = [];
    this._DDKGSlab = [];
    this._DDPieceSlab = []
    this._DCPieceSlab = [];
    this._ACKGSlab = [];
    this._ACPieceSlab = [];
    this._KGSlab = [];
    this._PieceSlab = [];
    this._SlabIndex = null;
    this._updateRowSlab = true;
    this._addRowSlab = false;
  }




  Remove_PieceSlab(RowIndex) {
    if (this._PieceSlab.length > 1) {
      var index = this._PieceSlab.indexOf(RowIndex);
      this._PieceSlab.splice(index, 1)
    }
    else {
      var index = this._PieceSlab.indexOf(RowIndex);
      this._PieceSlab.splice(index, 1);
    }
  }

  Remove_KGSlab(RowIndex) {
    if (this._KGSlab.length > 1) {
      var index = this._KGSlab.indexOf(RowIndex);
      this._KGSlab.splice(index, 1)
    }
    else {
      var index = this._KGSlab.indexOf(RowIndex);
      this._KGSlab.splice(index, 1);
    }
  }
  Remove_DCPieceSlab(RowIndex) {
    if (this._DCPieceSlab.length > 1) {
      var index = this._DCPieceSlab.indexOf(RowIndex);
      this._DCPieceSlab.splice(index, 1)
    }
    else {
      var index = this._DCPieceSlab.indexOf(RowIndex);
      this._DCPieceSlab.splice(index, 1);
    }
  }

  Remove_DCKGSlab(RowIndex) {
    if (this._DCKGSlab.length > 1) {
      var index = this._DCKGSlab.indexOf(RowIndex);
      this._DCKGSlab.splice(index, 1)
    }
    else {
      var index = this._DCKGSlab.indexOf(RowIndex);
      this._DCKGSlab.splice(index, 1);
    }
  }
  Remove_DDPieceSlab(RowIndex) {
    if (this._DDPieceSlab.length > 1) {
      var index = this._DDPieceSlab.indexOf(RowIndex);
      this._DDPieceSlab.splice(index, 1)
    }
    else {
      var index = this._DDPieceSlab.indexOf(RowIndex);
      this._DDPieceSlab.splice(index, 1);
    }
  }
  Remove_DDKGSlab(RowIndex) {
    if (this._DDKGSlab.length > 1) {
      var index = this._DDKGSlab.indexOf(RowIndex);
      this._DDKGSlab.splice(index, 1)
    }
    else {
      var index = this._DDKGSlab.indexOf(RowIndex);
      this._DDKGSlab.splice(index, 1);
    }
  }
  Remove_ACPieceSlab(RowIndex) {
    if (this._ACPieceSlab.length > 1) {
      var index = this._ACPieceSlab.indexOf(RowIndex);
      this._ACPieceSlab.splice(index, 1)
    }
    else {
      var index = this._ACPieceSlab.indexOf(RowIndex);
      this._ACPieceSlab.splice(index, 1);
    }
  }

  Remove_ACKGSlab(RowIndex) {
    if (this._ACKGSlab.length > 1) {
      var index = this._ACKGSlab.indexOf(RowIndex);
      this._ACKGSlab.splice(index, 1)
    }
    else {
      var index = this._ACKGSlab.indexOf(RowIndex);
      this._ACKGSlab.splice(index, 1);
    }
  }

  onRowSelect_SlabFormList(row: CustomerSiteContractSlab, index) {
    //debugger;
    this.ClearRowSlab();
    // console.log(row);
    this._SlabIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._SlabIndex);/
    this._SlabForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._SlabForm.controls['tobranchcode'].setValue(row.tobranchcode);
    this._SlabForm.controls['articlecode'].setValue(row.articlecode);
    this._SlabForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._SlabForm.controls['rate'].setValue(row.rate);
    this._SlabForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._SlabForm.controls['dcrate'].setValue(row.dcrate);
    this._SlabForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._SlabForm.controls['ddrate'].setValue(row.ddrate);
    this._SlabForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._SlabForm.controls['acratetype'].setValue(row.acratetype);
    this._SlabForm.controls['acrate'].setValue(row.acrate);
    this._SlabForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._SlabForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._SlabForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._SlabForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);


    if (row.lstRateSlabs != null) {
      for (var i = 0; i < row.lstRateSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstRateSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstRateSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstRateSlabs[i].slabrate;
        if (row.ratetypecode == 'MSC00091') {
          this._PieceSlab.push(_tempDCPiece);
        }
        if (row.ratetypecode == 'MSC00092') {
          this._KGSlab.push(_tempDCPiece);
        }
      }
    }
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPieceSlab.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKGSlab.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPieceSlab.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKGSlab.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635') {
            this._ACPieceSlab.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634') {
            this._ACKGSlab.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowSlab = false;
    this._addRowSlab = true;

  }
  updateRowSlab() {
    if (this._SlabIndex != null) {
      this._SlabFormsubmitted = true;

      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;

      var ii = this._SlabIndex;
      this._SlabFormList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._SlabFormList[ii].frombranchcode = this._SlabForm.get("frombranchcode").value;
      this._SlabFormList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._SlabForm.get("frombranchcode").value)[0].branchname;
      this._SlabFormList[ii].tobranchcode = this._SlabForm.get("tobranchcode").value;
      this._SlabFormList[ii].tobranch = (this._BillingBranch || []).filter(f => f.branchcode == this._SlabForm.get("tobranchcode").value)[0].branchname;
      this._SlabFormList[ii].articlecode = this._SlabForm.get("articlecode").value;
      this._SlabFormList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._SlabForm.get("articlecode").value)[0].articlename;
      this._SlabFormList[ii].ratetypecode = this._SlabForm.get("ratetypecode").value;
      this._SlabFormList[ii].ratetype = (this._SlabType || []).filter(f => f.metasubcode == this._SlabForm.get("ratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].rate = this._SlabForm.get("rate").value;
      this._SlabFormList[ii].dcratetypecode = this._SlabForm.get("dcratetypecode").value;
      this._SlabFormList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._SlabForm.get("dcratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].dcrate = this._SlabForm.get("dcrate").value;
      this._SlabFormList[ii].ddratetypecode = this._SlabForm.get("ddratetypecode").value;
      this._SlabFormList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._SlabForm.get("ddratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].ddrate = this._SlabForm.get("ddrate").value;
      this._SlabFormList[ii].acratetypecode = this._SlabForm.get("acratetypecode").value;
      this._SlabFormList[ii].acratetype = this._SlabForm.get("acratetype").value;
      this._SlabFormList[ii].acrate = this._SlabForm.get("acrate").value;
      this._SlabFormList[ii].addoninclusiveorexclusivecode = this._SlabForm.get("inclusiveorexclusivecode").value;
      this._SlabFormList[ii].addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._SlabForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._SlabFormList[ii].isneedreversebooking = this._SlabForm.get("isneedreversebooking").value || false;
      this._SlabFormList[ii].isneedreversebookingcode = this._SlabForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      this._SlabFormList[ii].dcinclusiveorexclusivecode = this._SlabForm.get("dcinclusiveorexclusivecode").value;
      this._SlabFormList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._SlabForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._SlabFormList[ii].ddinclusiveorexclusivecode = this._SlabForm.get("ddinclusiveorexclusivecode").value;
      this._SlabFormList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._SlabForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;
      this._SlabFormList[ii].effectivefrom = _contractfromDate;
      this._SlabFormList[ii].effectiveto = _contracttoDate;

      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      var rateslabtypecode = this._SlabForm.get("ratetypecode").value;
      var dcslabtypecode = this._SlabForm.get("dcratetypecode").value;
      var ddslabtypecode = this._SlabForm.get("ddratetypecode").value;
      var acslabtypecode = this._SlabForm.get("acratetype").value;
      if (this._PieceSlab.length > 0) {
        for (var i = 0; i < this._PieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.slabaddrate = 0;
          _tempACPiece.contracttype = 'MSC00084';
          _tempACPiece.contracttypecode = 'MSC00084';
          _tempACPiece.slabtypecode = rateslabtypecode;
          _tempACPiece.slabfrom = this._PieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._PieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._PieceSlab[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KGSlab.length > 0) {
        for (var i = 0; i < this._KGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KGSlab[i].FromPiece;
          _tempACKG.slabto = this._KGSlab[i].ToPiece;
          _tempACKG.slabrate = this._KGSlab[i].Rate;
          _tempACKG.slabtypecode = rateslabtypecode;
          _tempACKG.contracttype = 'MSC00084';
          _tempACKG.contracttypecode = 'MSC00084';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      this._SlabFormList[ii].lstRateSlabs = _lstRateSlabsTemp;
      if (this._DCPieceSlab.length > 0) {
        for (var i = 0; i < this._DCPieceSlab.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabtypecode;
          _tempDCPiece.slabfrom = this._DCPieceSlab[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceSlab[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGSlab.length > 0) {
        for (var i = 0; i < this._DCKGSlab.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00084";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabtypecode;
          _tempDCKG.slabfrom = this._DCKGSlab[i].FromPiece;
          _tempDCKG.slabto = this._DCKGSlab[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceSlab.length > 0) {
        for (var i = 0; i < this._DDPieceSlab.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00084";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabtypecode;
          _tempDDPiece.slabfrom = this._DDPieceSlab[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceSlab[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGSlab.length > 0) {
        for (var i = 0; i < this._DDKGSlab.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00084";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabtypecode;
          _tempDDKG.slabfrom = this._DDKGSlab[i].FromPiece;
          _tempDDKG.slabto = this._DDKGSlab[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPieceSlab.length > 0) {
        for (var i = 0; i < this._ACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabtypecode;
          _tempACPiece.slabfrom = this._ACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKGSlab.length > 0) {
        for (var i = 0; i < this._ACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabtypecode;
          _tempACKG.slabfrom = this._ACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._ACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._ACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      // if (this._ACPieceSlab.length > 0) {
      //   for (var i = 0; i < this._ACPieceSlab.length; i++) {
      //     var _tempACPiece: any = {};
      //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACPiece.contracttypecode = "MSC00084";
      //     _tempACPiece.chargetypecode = "Piece";
      //     _tempACPiece.slabfrom = this._ACPieceSlab[i].FromPiece;
      //     _tempACPiece.slabto = this._ACPieceSlab[i].ToPiece;
      //     _tempACPiece.slabrate = this._ACPieceSlab[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACPiece);
      //   }
      // }
      // if (this._KGSlab.length > 0) {
      //   for (var i = 0; i < this._KGSlab.length; i++) {
      //     var _tempACKG: any = {};
      //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACKG.contracttypecode = "MSC00084";
      //     _tempACKG.chargetypecode = "KG";
      //     _tempACKG.slabfrom = this._KGSlab[i].FromPiece;
      //     _tempACKG.slabto = this._KGSlab[i].ToPiece;
      //     _tempACKG.slabrate = this._KGSlab[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACKG);
      //   }
      // }

      this._SlabFormList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;


      this._SlabIndex = null;
      this._updateRowSlab = true;
      this._addRowSlab = false;
      this.ClearRowSlab();

    }
  }



  //---------------- 2D -------------------//

  showBasicDialog2D() {
    if (this._2DForm.get("ratetypecode").value == '') {
      this.display2D = true;
    }
    if (this._2DForm.get("ratetypecode").value == '') {
      this.displayKG2D = true;
    }
  }
  addRowRate2D() {
    if (this._FromPiece2D != "" && this._ToPiece2D != "" && this._RatePiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPiece2D;
      _DCPieceTemp.ToPiece = this._ToPiece2D;
      _DCPieceTemp.Rate = this._RatePiece2D;
      this._Piece2D.push(_DCPieceTemp);
      this.ClearRowRate2D();
    }
  }
  ClearRowRate2D() {
    this._FromPiece2D = "";
    this._ToPiece2D = "";
    this._RatePiece2D = "";
  }
  addRowRateKG2D() {
    if (this._FromKG2D != "" && this._ToKG2D != "" && this._RateKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKG2D;
      _DCPieceGKTemp.ToPiece = this._ToKG2D;
      _DCPieceGKTemp.Rate = this._RateKG2D;
      this._KG2D.push(_DCPieceGKTemp);
      this.ClearRowRateKG2D();
    }
  }
  ClearRowRateKG2D() {
    this._FromKG2D = "";
    this._ToKG2D = "";
    this._RateKG2D = "";
  }

  showBasicDialogDCRate2D() {
    if (this._2DForm.get("dcratetypecode").value == 'MSC00098' || this._2DForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRate2D = true;
      if (this._2DForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("dcratetypecode").value == 'MSC00099' || this._2DForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKG2D = true;
      if (this._2DForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00099';
        this._DCKGAdditionalRate2D = '';
      }
    }

  }
  showBasicDialogSlabRate2D() {
    if (this._2DForm.get("ratetypecode").value == 'MSC00105' || this._2DForm.get("ratetypecode").value == 'MSC00970') {
      this.display2D = true;
    }
    if (this._2DForm.get("ratetypecode").value == 'MSC00106' || this._2DForm.get("ratetypecode").value == 'MSC00971') {
      this.displayKG2D = true;
    }

  }

  addRowDCRate2D() {
    if (this._FromDCPiece2D != "" && this._ToDCPiece2D != "" && this._RateDCPiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPiece2D;
      _DCPieceTemp.ToPiece = this._ToDCPiece2D;
      _DCPieceTemp.Rate = this._RateDCPiece2D;
      this._DCPiece2D.push(_DCPieceTemp);
      this.ClearRowDCRate2D();
    }
  }
  ClearRowDCRate2D() {
    this._FromDCPiece2D = "";
    this._ToDCPiece2D = "";
    this._RateDCPiece2D = "";
  }
  addRowDCRateKG2D() {
    if (this._FromDCKG2D != "" && this._ToDCKG2D != "" && this._RateDCKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKG2D;
      _DCPieceGKTemp.ToPiece = this._ToDCKG2D;
      _DCPieceGKTemp.Rate = this._RateDCKG2D;
      this._DCKG2D.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG2D();
    }
  }
  ClearRowDCRateKG2D() {
    this._FromDCKG2D = "";
    this._ToDCKG2D = "";
    this._RateDCKG2D = "";
  }
  showBasicDialogDDRate2D() {
    if (this._2DForm.get("ddratetypecode").value == 'MSC00095' || this._2DForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRate2D = true;
      if (this._2DForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRate2D = this._2DForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("ddratetypecode").value == 'MSC00096' || this._2DForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKG2D = true;
      if (this._2DForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00632';
        this._DDKGAdditionalRate2D = this._2DForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00096';
        this._DDKGAdditionalRate2D = '';
      }
    }

  }
  addRowDDRate2D() {
    if (this._FromDDPiece2D != "" && this._ToDDPiece2D != "" && this._RateDDPiece2D != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPiece2D;
      _DDPieceTemp.ToPiece = this._ToDDPiece2D;
      _DDPieceTemp.Rate = this._RateDDPiece2D;
      this._DDPiece2D.push(_DDPieceTemp);
      this.ClearRowDDRate2D();
    }
  }
  ClearRowDDRate2D() {
    this._FromDDPiece2D = "";
    this._ToDDPiece2D = "";
    this._RateDDPiece2D = "";
  }
  addRowDDRateKG2D() {
    if (this._FromDDKG2D != "" && this._ToDDKG2D != "" && this._RateDDKG2D != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKG2D;
      _DDPieceGKTemp.ToPiece = this._ToDDKG2D;
      _DDPieceGKTemp.Rate = this._RateDDKG2D;
      this._DDKG2D.push(_DDPieceGKTemp);
      this.ClearRowDDRateKG2D();
    }
  }
  ClearRowDDRateKG2D() {
    this._FromDDKG2D = "";
    this._ToDDKG2D = "";
    this._RateDDKG2D = "";
  }
  ArticleChargeCode2D(event) {

  }
  showBasicDialogArticleChargeCode2D() {
    this.displayACRateType2D = true;
  }
  onRowSelectPopupArticleChargeCode2D(event: any) {
    var row = event.data;
    this._2DForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._2DForm.controls['acrate'].setValue(row.rate);
    this._2DForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateType2D = false;
  }
  addRow2D() {
    this._2DFormsubmitted = true;
    if (this._2DForm.valid) {
      for (var i = 0; i < this._2DList.length; i++) {
        if (this._2DList[i].frombranchcode == this._2DForm.get("frombranchcode").value) {
          if (this._2DList[i].tobranchcode == this._2DForm.get("tobranchcode").value) {
            if (this._2DList[i].articlecode == this._2DForm.get("articlecode").value) {
              this._CustomExceptionService.handleWarning("The Record is Already Exists");
              return;
            }
          }
        }
      }
      var _2DListTemp: any = {};
      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;

      _2DListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _2DListTemp.frombranchcode = this._2DForm.get("frombranchcode").value;
      _2DListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _2DListTemp.frombranchcode)[0].branchname;
      _2DListTemp.toKM = this._2DForm.get("toKM").value;
      _2DListTemp.articlecode = this._2DForm.get("articlecode").value;
      _2DListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _2DListTemp.articlecode)[0].articlename;
      _2DListTemp.ratetypecode = this._2DForm.get("ratetypecode").value;
      _2DListTemp.ratetype = (this._SlabType2D || []).filter(f => f.metasubcode == _2DListTemp.ratetypecode)[0].metasubdescription;
      _2DListTemp.rate = this._2DForm.get("rate").value;
      _2DListTemp.dcratetypecode = this._2DForm.get("dcratetypecode").value;
      _2DListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _2DListTemp.dcratetypecode)[0].metasubdescription;
      _2DListTemp.dcrate = this._2DForm.get("dcrate").value;
      _2DListTemp.ddratetypecode = this._2DForm.get("ddratetypecode").value;
      _2DListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _2DListTemp.ddratetypecode)[0].metasubdescription;
      _2DListTemp.ddrate = this._2DForm.get("ddrate").value;
      _2DListTemp.acratetypecode = this._2DForm.get("acratetypecode").value;
      _2DListTemp.acratetype = this._2DForm.get("acratetype").value;
      _2DListTemp.acrate = this._2DForm.get("acrate").value;
      _2DListTemp.addoninclusiveorexclusivecode = this._2DForm.get("inclusiveorexclusivecode").value;
      _2DListTemp.addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _2DListTemp.addoninclusiveorexclusivecode)[0].metasubdescription;
      _2DListTemp.isneedreversebooking = this._2DForm.get("isneedreversebooking").value || false;
      _2DListTemp.isneedreversebookingcode = this._2DForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      _2DListTemp.dcinclusiveorexclusivecode = this._2DForm.get("dcinclusiveorexclusivecode").value;
      _2DListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _2DListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      _2DListTemp.ddinclusiveorexclusivecode = this._2DForm.get("ddinclusiveorexclusivecode").value;
      _2DListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _2DListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;
      _2DListTemp.effectivefrom = _contractfromDate;
      _2DListTemp.effectiveto = _contracttoDate;
      // var _rate = this._2DForm.get("rate").value;
      // var _ToKm = this._2DForm.get("toKM").value;

      // _2DListTemp.quintalRateperKM = ((Number(_rate) / Number(_ToKm)) * 100);

      /*_2DListTemp._DCKG = this._DCKG2D;
      _2DListTemp._DDKG = this._DDKG2D;
      _2DListTemp._DDPiece = this._DDPiece2D;
      _2DListTemp._DCPiece = this._DCPiece2D;
      _2DListTemp._ACKG = this._ACKG2D;    
      _2DListTemp._ACPiece = this._ACPiece2D;
      _2DListTemp._SlabKG = this._KG2D;    
      _2DListTemp._SlabPiece = this._Piece2D;*/


      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      var slabratetype = this._2DForm.get("ratetypecode").value
      var dcslabratetype = this._2DForm.get("dcratetypecode").value
      var ddslabratetype = this._2DForm.get("ddratetypecode").value
      var acslabratetype = this._2DForm.get("acratetypecode").value

      if (this._Piece2D.length > 0) {
        for (var i = 0; i < this._Piece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttype = 'MSC00104';
          _tempACPiece.contracttypecode = 'MSC00104';
          _tempACPiece.slabtypecode = slabratetype;
          _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
          _tempACPiece.slabto = this._Piece2D[i].ToPiece;
          _tempACPiece.slabrate = this._Piece2D[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KG2D.length > 0) {
        for (var i = 0; i < this._KG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KG2D[i].FromPiece;
          _tempACKG.slabto = this._KG2D[i].ToPiece;
          _tempACKG.slabrate = this._KG2D[i].Rate;
          _tempACKG.slabtypecode = slabratetype;
          _tempACKG.contracttype = 'MSC00104';
          _tempACKG.contracttypecode = 'MSC00104';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      _2DListTemp.lstRateSlabs = _lstRateSlabsTemp;

      if (this._DCPiece2D.length > 0) {
        for (var i = 0; i < this._DCPiece2D.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabratetype;
          _tempDCPiece.slabfrom = this._DCPiece2D[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece2D[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00104";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabratetype;
          _tempDCKG.slabfrom = this._DCKG2D[i].FromPiece;
          _tempDCKG.slabto = this._DCKG2D[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece2D.length > 0) {
        for (var i = 0; i < this._DDPiece2D.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00104";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabratetype;
          _tempDDPiece.slabfrom = this._DDPiece2D[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece2D[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG2D.length > 0) {
        for (var i = 0; i < this._DDKG2D.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00104";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabratetype;
          _tempDDKG.slabfrom = this._DDKG2D[i].FromPiece;
          _tempDDKG.slabto = this._DDKG2D[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPiece2D.length > 0) {
        for (var i = 0; i < this._ACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabratetype;
          _tempACPiece.slabfrom = this._ACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKG2D.length > 0) {
        for (var i = 0; i < this._ACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabratetype;
          _tempACKG.slabfrom = this._ACKG2D[i].FromPiece;
          _tempACKG.slabto = this._ACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._ACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      // if (this._Piece2D.length > 0) {
      //   for (var i = 0; i < this._Piece2D.length; i++) {
      //     var _tempACPiece: any = {};
      //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACPiece.contracttypecode = "MSC00104";
      //     _tempACPiece.chargetypecode = "MSC00421";
      //     _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
      //     _tempACPiece.slabto = this._Piece2D[i].ToPiece;
      //     _tempACPiece.slabrate = this._Piece2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACPiece);
      //   }
      // }
      // if (this._KG2D.length > 0) {
      //   for (var i = 0; i < this._KG2D.length; i++) {
      //     var _tempACKG: any = {};
      //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACKG.contracttypecode = "MSC00104";
      //     _tempACKG.chargetypecode = "MSC00421";
      //     _tempACKG.slabfrom = this._KG2D[i].FromPiece;
      //     _tempACKG.slabto = this._KG2D[i].ToPiece;
      //     _tempACKG.slabrate = this._KG2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACKG);
      //   }
      // }
      _2DListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      this._2DList.push(_2DListTemp);
      this.ClearRow2D();
    }
  }
  ClearRow2D() {
    this._2DFormsubmitted = false;
    this._2DForm.reset();
    this._DCKG2D = [];
    this._DDKG2D = [];
    this._DDPiece2D = []
    this._DCPiece2D = [];
    this._ACKG2D = [];
    this._ACPiece2D = [];
    this._KG2D = [];
    this._Piece2D = [];
    this._2DIndex = null;
    this._updateRow2D = true;
    this._addRow2D = false;
  }

  onChangeDCRateType2D() {


  }
  onChangeDDRateType2D() {

  }

  Remove_Piece2D(RowIndex) {
    if (this._Piece2D.length > 1) {
      var index = this._Piece2D.indexOf(RowIndex);
      this._Piece2D.splice(index, 1)
    }
    else {
      var index = this._Piece2D.indexOf(RowIndex);
      this._Piece2D.splice(index, 1);
    }
  }

  Remove_KG2D(RowIndex) {
    if (this._KG2D.length > 1) {
      var index = this._KG2D.indexOf(RowIndex);
      this._KG2D.splice(index, 1)
    }
    else {
      var index = this._KG2D.indexOf(RowIndex);
      this._KG2D.splice(index, 1);
    }
  }
  Remove_DCPiece2D(RowIndex) {
    if (this._DCPiece2D.length > 1) {
      var index = this._DCPiece2D.indexOf(RowIndex);
      this._DCPiece2D.splice(index, 1)
    }
    else {
      var index = this._DCPiece2D.indexOf(RowIndex);
      this._DCPiece2D.splice(index, 1);
    }
  }
  Remove_DCKG2D(RowIndex) {
    if (this._DCKG2D.length > 1) {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DCKG2D.splice(index, 1)
    }
    else {
      var index = this._DCKG2D.indexOf(RowIndex);
      this._DCKG2D.splice(index, 1);
    }
  }
  Remove_DDPiece2D(RowIndex) {
    if (this._DDPiece2D.length > 1) {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DDPiece2D.splice(index, 1)
    }
    else {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DDPiece2D.splice(index, 1);
    }
  }
  Remove_DDKG2D(RowIndex) {
    if (this._DDKG2D.length > 1) {
      var index = this._DDKG2D.indexOf(RowIndex);
      this._DDKG2D.splice(index, 1)
    }
    else {
      var index = this._DDKG2D.indexOf(RowIndex);
      this._DDKG2D.splice(index, 1);
    }
  }
  Remove_ACPiece2D(RowIndex) {
    if (this._ACPiece2D.length > 1) {
      var index = this._ACPiece2D.indexOf(RowIndex);
      this._ACPiece2D.splice(index, 1)
    }
    else {
      var index = this._ACPiece2D.indexOf(RowIndex);
      this._ACPiece2D.splice(index, 1);
    }
  }
  Remove_ACKG2D(RowIndex) {
    if (this._ACKG2D.length > 1) {
      var index = this._ACKG2D.indexOf(RowIndex);
      this._ACKG2D.splice(index, 1)
    }
    else {
      var index = this._ACKG2D.indexOf(RowIndex);
      this._ACKG2D.splice(index, 1);
    }
  }
  Remove_2DListGrid(RowIndex) {
    if (this._2DList.length > 1) {
      var index = this._2DList.indexOf(RowIndex);
      this._2DList.splice(index, 1)
    }
    else {
      var index = this._2DList.indexOf(RowIndex);
      this._2DList.splice(index, 1);
    }
  }
  onRowSelect_2DList(row: CustomerSiteContractTwoD, index) {
    //debugger;
    this.ClearRow2D();
    // console.log(row);
    this._2DIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._2DIndex);
    this._2DForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._2DForm.controls['toKM'].setValue(row.toKM);
    this._2DForm.controls['articlecode'].setValue(row.articlecode);
    this._2DForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._2DForm.controls['rate'].setValue(row.rate);
    this._2DForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._2DForm.controls['dcrate'].setValue(row.dcrate);
    this._2DForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._2DForm.controls['ddrate'].setValue(row.ddrate);
    this._2DForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._2DForm.controls['acratetype'].setValue(row.acratetype);
    this._2DForm.controls['acrate'].setValue(row.acrate);
    this._2DForm.controls['inclusiveorexclusivecode'].setValue(row.addoninclusiveorexclusivecode);
    this._2DForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._2DForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._2DForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);


    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPiece2D.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKG2D.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPiece2D.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKG2D.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635') {
            this._ACPiece2D.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634') {
            this._ACPiece2D.push(_tempDCPiece);
          }

        }
      }
    }

    if (row.lstRateTwoDSlabs != null) {
      for (var i = 0; i < row.lstRateTwoDSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstRateTwoDSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstRateTwoDSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstRateTwoDSlabs[i].slabrate;
        if (row.ratetypecode == 'MSC00105') {
          this._Piece2D.push(_tempDCPiece);
        }
        if (row.ratetypecode == 'MSC00106') {
          this._KG2D.push(_tempDCPiece);
        }
      }
    }

    this._updateRow2D = false;
    this._addRow2D = true;

  }

  updateRow2D() {

    if (this._2DIndex != null) {
      this._2DFormsubmitted = true;
      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;

      var ii = this._2DIndex;
      this._2DList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._2DList[ii].frombranchcode = this._2DForm.get("frombranchcode").value;
      this._2DList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._2DForm.get("frombranchcode").value)[0].branchname;
      this._2DList[ii].toKM = this._2DForm.get("toKM").value;
      this._2DList[ii].articlecode = this._2DForm.get("articlecode").value;
      this._2DList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._2DForm.get("articlecode").value)[0].articlename;
      this._2DList[ii].ratetypecode = this._2DForm.get("ratetypecode").value;
      this._2DList[ii].ratetype = (this._SlabType2D || []).filter(f => f.metasubcode == this._2DForm.get("ratetypecode").value)[0].metasubdescription;
      this._2DList[ii].rate = this._2DForm.get("rate").value;
      this._2DList[ii].dcratetypecode = this._2DForm.get("dcratetypecode").value;
      this._2DList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._2DForm.get("dcratetypecode").value)[0].metasubdescription;
      this._2DList[ii].dcrate = this._2DForm.get("dcrate").value;
      this._2DList[ii].ddratetypecode = this._2DForm.get("ddratetypecode").value;
      this._2DList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._2DForm.get("ddratetypecode").value)[0].metasubdescription;
      this._2DList[ii].ddrate = this._2DForm.get("ddrate").value;
      this._2DList[ii].acratetypecode = this._2DForm.get("acratetypecode").value;
      this._2DList[ii].acratetype = this._2DForm.get("acratetype").value;
      this._2DList[ii].acrate = this._2DForm.get("acrate").value;
      this._2DList[ii].addoninclusiveorexclusivecode = this._2DForm.get("inclusiveorexclusivecode").value;
      this._2DList[ii].addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._2DForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._2DList[ii].isneedreversebooking = this._2DForm.get("isneedreversebooking").value || false;
      this._2DList[ii].isneedreversebookingcode = this._2DForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      this._2DList[ii].dcinclusiveorexclusivecode = this._2DForm.get("dcinclusiveorexclusivecode").value;
      this._2DList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._2DForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._2DList[ii].ddinclusiveorexclusivecode = this._2DForm.get("ddinclusiveorexclusivecode").value;
      this._2DList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._2DForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;
      this._2DList[ii].effectivefrom = _contractfromDate;
      this._2DList[ii].effectiveto = _contracttoDate;




      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      var slabratetype = this._2DForm.get("ratetypecode").value
      var dcslabratetype = this._2DForm.get("dcratetypecode").value
      var ddslabratetype = this._2DForm.get("ddratetypecode").value
      var acslabratetype = this._2DForm.get("acratetypecode").value
      if (this._Piece2D.length > 0) {
        for (var i = 0; i < this._Piece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.slabaddrate = 0;
          _tempACPiece.contracttype = 'MSC00104';
          _tempACPiece.contracttypecode = 'MSC00104';
          _tempACPiece.slabtypecode = slabratetype;
          _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
          _tempACPiece.slabto = this._Piece2D[i].ToPiece;
          _tempACPiece.slabrate = this._Piece2D[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KG2D.length > 0) {
        for (var i = 0; i < this._KG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KG2D[i].FromPiece;
          _tempACKG.slabto = this._KG2D[i].ToPiece;
          _tempACKG.slabrate = this._KG2D[i].Rate;
          _tempACKG.slabtypecode = slabratetype;
          _tempACKG.contracttype = 'MSC00104';
          _tempACKG.contracttypecode = 'MSC00104';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      this._2DList[ii].lstRateSlabs = _lstRateSlabsTemp;
      if (this._DCPiece2D.length > 0) {
        for (var i = 0; i < this._DCPiece2D.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabratetype;
          _tempDCPiece.slabfrom = this._DCPiece2D[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece2D[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00104";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabratetype;
          _tempDCKG.slabfrom = this._DCKG2D[i].FromPiece;
          _tempDCKG.slabto = this._DCKG2D[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece2D.length > 0) {
        for (var i = 0; i < this._DDPiece2D.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00104";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabratetype;
          _tempDDPiece.slabfrom = this._DDPiece2D[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece2D[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG2D.length > 0) {
        for (var i = 0; i < this._DDKG2D.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00104";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabratetype;
          _tempDDKG.slabfrom = this._DDKG2D[i].FromPiece;
          _tempDDKG.slabto = this._DDKG2D[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPiece2D.length > 0) {
        for (var i = 0; i < this._ACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabratetype;
          _tempACPiece.slabfrom = this._ACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKG2D.length > 0) {
        for (var i = 0; i < this._ACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabratetype;
          _tempACKG.slabfrom = this._ACKG2D[i].FromPiece;
          _tempACKG.slabto = this._ACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._ACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      // if (this._Piece2D.length > 0) {
      //   for (var i = 0; i < this._Piece2D.length; i++) {
      //     var _tempACPiece: any = {};
      //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACPiece.contracttypecode = "MSC00104";
      //     _tempACPiece.chargetypecode = "MSC00421";
      //     _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
      //     _tempACPiece.slabto = this._Piece2D[i].ToPiece;
      //     _tempACPiece.slabrate = this._Piece2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACPiece);
      //   }
      // }
      // if (this._KG2D.length > 0) {
      //   for (var i = 0; i < this._KG2D.length; i++) {
      //     var _tempACKG: any = {};
      //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACKG.contracttypecode = "MSC00104";
      //     _tempACKG.chargetypecode = "MSC00421";
      //     _tempACKG.slabfrom = this._KG2D[i].FromPiece;
      //     _tempACKG.slabto = this._KG2D[i].ToPiece;
      //     _tempACKG.slabrate = this._KG2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACKG);
      //   }
      // }
      this._2DList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      this._2DIndex = null;
      this._updateRow2D = true;
      this._addRow2D = false;
      this.ClearRow2D();
    }
  }
  ///////--------------Way Bill-------------//////////////
  showBasicDialogRateTypeWayBill() {
    this.displayRateTypeWayBill = true;
    //debugger;
  }

  showBasicDialogValue() {
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00635') {
      this.displayPieceWayBill = true;
    }
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00634') {
      this.displayKGWayBill = true;
    }

    //this.displayKGWayBill = true;
    //this.displayPieceKGWayBill = true;
  }
  onChangechargeratetypecode() {
    //this.displayPieceWayBill = true;
    //var this._TempWaybillList;
    //debugger;
  }

  onRowSelectPopupArticleChargeCodeWayBill(event: any) {
    debugger;
    this.displayRateTypeWayBill = false;
    var row = event.data;
    this._WaybillForm.controls['chargecodeid'].setValue(row.charge_Code);
    this._WaybillForm.controls['chargeratetypecode'].setValue(row.rate_Type);
    this._WaybillForm.controls['rate'].setValue(row.rate);
    //this.displayACRateType2D = false;
  }
  showBasicDialogRateType() {
    this.displayRateTypeWayBill = true;
  }
  addRowRateWayBill() {
    if (this._FromPieceWayBill != "" && this._ToPieceWayBill != "" && this._RatePieceWayBill != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPieceWayBill;
      _DCPieceTemp.ToPiece = this._ToPieceWayBill;
      _DCPieceTemp.Rate = this._RatePieceWayBill;
      this._PieceWayBill.push(_DCPieceTemp);
      this.ClearRowRateWayBill();
    }
  }
  ClearRowRateWayBill() {
    this._FromPieceWayBill = "";
    this._ToPieceWayBill = "";
    this._RatePieceWayBill = "";
  }
  addRowRateKGWayBill() {
    if (this._FromKGWayBill != "" && this._ToKGWayBill != "" && this._RateKGWayBill != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKGWayBill;
      _DCPieceGKTemp.ToPiece = this._ToKGWayBill;
      _DCPieceGKTemp.Rate = this._RateKGWayBill;
      this._KGWayBill.push(_DCPieceGKTemp);
      this.ClearRowRateKGWayBill();
    }
  }
  ClearRowRateKGWayBill() {
    this._FromKGWayBill = "";
    this._ToKGWayBill = "";
    this._RateKGWayBill = "";
  }
  addRowRatePieceKGWayBill() {
    if (this._FromPieceKGWayBill != "" && this._ToPieceKGWayBill != "" && this._RatePieceKGWayBill != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromPieceKGWayBill;
      _DCPieceGKTemp.ToPiece = this._ToPieceKGWayBill;
      _DCPieceGKTemp.Rate = this._RatePieceKGWayBill;
      this._PieceKGWayBill.push(_DCPieceGKTemp);
      this.ClearRowRatePieceKGWayBill();
    }
  }
  ClearRowRatePieceKGWayBill() {
    this._FromPieceKGWayBill = "";
    this._ToPieceKGWayBill = "";
    this._RatePieceKGWayBill = "";
  }
  addRowWaybill() {
    this._WaybillFormsubmitted = true;
    if (this._WaybillForm.valid) {
      var error = "";
      for (var i = 0; i < this.WayBillList.length; i++) {
        if (this.WayBillList[i].chargetypecode == this._WaybillForm.get("chargetypecode").value) {
          error = "This charge name already added";
        }
      }

      if (error == "") {
        //console.log(this._AddonCharges);
        var _WaybillListTemp: any = {};

        _WaybillListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _WaybillListTemp.chargetypecode = this._WaybillForm.get("chargetypecode").value;
        _WaybillListTemp.chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == _WaybillListTemp.chargetypecode)[0].chargeName;
        _WaybillListTemp.chargeratetypecode = this._WaybillForm.get("chargeratetypecode").value;
        _WaybillListTemp.chargeratetype = (this._AddonCharges || []).filter(f => f.metasubcode == this._WaybillForm.get("chargeratetypecode").value)[0].metasubdescription;

        _WaybillListTemp.chargecodeid = this._WaybillForm.get("chargecodeid").value;
        _WaybillListTemp.rate = this._WaybillForm.get("rate").value;
        _WaybillListTemp.inclusiveorexclusivecode = this._WaybillForm.get("inclusiveorexclusivecode").value;
        _WaybillListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _WaybillListTemp.inclusiveorexclusivecode)[0].metasubdescription;
        _WaybillListTemp.printinothercharge = this._WaybillForm.get("printinothercharge").value || false;
        /*_2DListTemp._PieceWayBill = this._PieceWayBill;
        _2DListTemp._KGWayBill = this._KGWayBill;
       */


        var _lstAddOnSlabsTemp = []
        if (this._PieceWayBill.length > 0) {
          for (var i = 0; i < this._PieceWayBill.length; i++) {
            var _tempDCPiece: any = {};
            _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDCPiece.slabfrom = this._PieceWayBill[i].FromPiece;
            _tempDCPiece.slabto = this._PieceWayBill[i].ToPiece;
            _tempDCPiece.slabrate = this._PieceWayBill[i].Rate;
            _tempDCPiece.slabaddrate = _WaybillListTemp.adrate;
            _tempDCPiece.chargecodeid = _WaybillListTemp.chargecodeid;
            _lstAddOnSlabsTemp.push(_tempDCPiece);
          }
        }
        if (this._DCKG2D.length > 0) {
          for (var i = 0; i < this._DCKG2D.length; i++) {
            var _tempDCKG: any = {};
            _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDCKG.slabfrom = this._KGWayBill[i].FromPiece;
            _tempDCKG.slabto = this._KGWayBill[i].ToPiece;
            _tempDCKG.slabrate = this._KGWayBill[i].Rate;
            _tempDCKG.slabaddrate = _WaybillListTemp.adrate;
            _tempDCKG.chargecodeid = _WaybillListTemp.chargecodeid;
            _lstAddOnSlabsTemp.push(_tempDCKG);
          }
        }


        _WaybillListTemp.lstAddOnSlabs = _lstAddOnSlabsTemp;

        this.WayBillList.push(_WaybillListTemp);
        this.ClearRowWaybill();
      }
    }
    else {
      this._CustomExceptionService.handleError(error)
    }

  }
  ClearRowWaybill() {
    this._WaybillFormsubmitted = false;
    this._WaybillForm.reset();
    this._PieceWayBill = [];
    this._KGWayBill = [];
    this._WayBillIndex = null;
    this._updateRowWayBill = true;
    this._addRowWayBill = false;
  }
  RemoveWayBillList(RowIndex) {
    if (this.WayBillList.length > 1) {
      var index = this.WayBillList.indexOf(RowIndex);
      this.WayBillList.splice(index, 1)
    }
    else {
      var index = this.WayBillList.indexOf(RowIndex);
      this.WayBillList.splice(index, 1);
    }
  }
  Remove_PieceWayBill(RowIndex) {
    if (this._PieceWayBill.length > 1) {
      var index = this._PieceWayBill.indexOf(RowIndex);
      this._PieceWayBill.splice(index, 1)
    }
    else {
      var index = this._PieceWayBill.indexOf(RowIndex);
      this._PieceWayBill.splice(index, 1);
    }
  }
  Remove_KGWayBill(RowIndex) {
    if (this._KGWayBill.length > 1) {
      var index = this._KGWayBill.indexOf(RowIndex);
      this._KGWayBill.splice(index, 1)
    }
    else {
      var index = this._KGWayBill.indexOf(RowIndex);
      this._KGWayBill.splice(index, 1);
    }
  }
  Remove_PieceKGWayBill(RowIndex) {
    if (this._PieceKGWayBill.length > 1) {
      var index = this._PieceKGWayBill.indexOf(RowIndex);
      this._PieceKGWayBill.splice(index, 1)
    }
    else {
      var index = this._PieceKGWayBill.indexOf(RowIndex);
      this._PieceKGWayBill.splice(index, 1);
    }
  }
  onRowSelectWayBill(row: CustomerSiteContractAddOnCharge, index) {
    this._WayBillIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._WayBillIndex);
    this._WaybillForm.controls['chargecodeid'].setValue(row.chargecodeid);
    this._WaybillForm.controls['chargetypecode'].setValue(row.chargetypecode);
    this._WaybillForm.controls['chargeratetypecode'].setValue(row.chargeratetypecode);
    this._WaybillForm.controls['rate'].setValue(row.rate);
    this._WaybillForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._WaybillForm.controls['printinothercharge'].setValue(row.printinothercharge);
    /////////this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstAddOnSlabs != null) {
      for (var i = 0; i < row.lstAddOnSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstAddOnSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstAddOnSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstAddOnSlabs[i].slabrate;

        if (row.chargeratetypecode == 'MSC00635') {
          this._PieceWayBill.push(_tempDCPiece);
        }
        if (row.chargeratetypecode == 'MSC00634') {
          this._KGWayBill.push(_tempDCPiece);
        }


      }
    }

    this._updateRowWayBill = false;
    this._addRowWayBill = true;
  }
  updateRowWaybill() {
    if (this._WayBillIndex != null) {
      this._WaybillFormsubmitted = true;
      var ii = this._WayBillIndex;
      this.WayBillList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this.WayBillList[ii].chargetypecode = this._WaybillForm.get("chargetypecode").value;
      this.WayBillList[ii].chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == this.WayBillList[ii].chargetypecode)[0].chargeName;
      this.WayBillList[ii].chargeratetypecode = this._WaybillForm.get("chargeratetypecode").value;
      this.WayBillList[ii].chargeratetype = (this._ArticleChargeCode || []).filter(f => f.rate_Type == this.WayBillList[ii].chargeratetypecode)[0].charge_Code;
      this.WayBillList[ii].chargecodeid = this._WaybillForm.get("chargecodeid").value;
      //this.WayBillList[ii].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == this.WayBillList[ii].chargecodeid)[0].chargeName;
      this.WayBillList[ii].rate = this._WaybillForm.get("rate").value;
      this.WayBillList[ii].inclusiveorexclusivecode = this._WaybillForm.get("inclusiveorexclusivecode").value;
      //this.WayBillList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this.WayBillList[ii].inclusiveorexclusivecode)[0].metasubdescription;
      this.WayBillList[ii].printinothercharge = this._WaybillForm.get("printinothercharge").value || false;
      /*_2DListTemp._PieceWayBill = this._PieceWayBill;
      _2DListTemp._KGWayBill = this._KGWayBill;
     */


      var _lstAddOnSlabsTemp = []
      if (this._PieceWayBill.length > 0) {
        for (var i = 0; i < this._PieceWayBill.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.slabfrom = this._PieceWayBill[i].FromPiece;
          _tempDCPiece.slabto = this._PieceWayBill[i].ToPiece;
          _tempDCPiece.slabrate = this._PieceWayBill[i].Rate;
          _tempDCPiece.slabaddrate = this.WayBillList[ii].adrate;
          _tempDCPiece.chargecodeid = this.WayBillList[ii].chargecodeid;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.slabfrom = this._KGWayBill[i].FromPiece;
          _tempDCKG.slabto = this._KGWayBill[i].ToPiece;
          _tempDCKG.slabrate = this._KGWayBill[i].Rate;
          _tempDCKG.slabaddrate = this.WayBillList[ii].adrate;
          _tempDCKG.chargecodeid = this.WayBillList[ii].chargecodeid;
          _lstAddOnSlabsTemp.push(_tempDCKG);
        }
      }


      this.WayBillList[ii].lstAddOnSlabs = _lstAddOnSlabsTemp;
      this._WayBillIndex = null;
      this._updateRowWayBill = true;
      this._addRowWayBill = false;

      this.ClearRowWaybill();
    }

  }
  addRowArticle() {
    if (this._ArticleFrom != "" && this._ArticleTo != "" && this._ArticleCharges != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _DCPieceGKTemp.flatodachargefrom = this._ArticleFrom;
      _DCPieceGKTemp.flatodachargeto = this._ArticleTo;
      _DCPieceGKTemp.flatodacharges = this._ArticleCharges;
      this._ArticleList.push(_DCPieceGKTemp);
      this.clearRowArticle();
    }
  }
  clearRowArticle() {
    this._ArticleFrom = "";
    this._ArticleTo = "";
    this._ArticleCharges = "";
  }

  addRowKG() {
    if (this._KGFrom != "" && this._KGTo != "" && this._KGCharges != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _DCPieceGKTemp.flatodachargefrom = this._KGFrom;
      _DCPieceGKTemp.flatodachargeto = this._KGTo;
      _DCPieceGKTemp.flatodacharges = this._KGCharges;
      this._KGList.push(_DCPieceGKTemp);
      this.clearRowKG();
    }
  }
  clearRowKG() {
    this._KGFrom = "";
    this._KGTo = "";
    this._KGCharges = "";
  }


  ExportVendor() {
    let DashboardList = this.GetVendorList();
    this.exportUtility.exportExcel(DashboardList, 'Existing Vendor', 'xlsx');
  }
  GetVendorList() {
    let DashboardList = [];
    this.ExistingVendorList.forEach(element => {
      let Dashboard: any = {};
      Dashboard["Vendor Name"] = element.vendorName;
      Dashboard["Rates Detail ( basic , DDC , LR FOV Etc..)"] = element.vendorRates;
      Dashboard["What are the Strength as perCustomer"] = element.vendorStrength;
      Dashboard["What is Customer Pain Point for this Vendor "] = element.vendorPainPoint;
      DashboardList.push(Dashboard);
    });
    return DashboardList;
  }


  addRowACRate2D() {
    if (this._FromACPiece2D != "" && this._ToACPiece2D != "" && this._RateACPiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece2D;
      _DCPieceTemp.ToPiece = this._ToACPiece2D;
      _DCPieceTemp.Rate = this._RateACPiece2D;
      this._ACPiece2D.push(_DCPieceTemp);
      this.ClearRowACRate2D();
    }
  }
  ClearRowACRate2D() {
    this._FromACPiece2D = "";
    this._ToACPiece2D = "";
    this._RateACPiece2D = "";
  }
  addRowACRateKG2D() {
    if (this._FromACKG2D != "" && this._ToACKG2D != "" && this._RateACKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG2D;
      _DCPieceGKTemp.ToPiece = this._ToACKG2D;
      _DCPieceGKTemp.Rate = this._RateACKG2D;
      this._ACKG2D.push(_DCPieceGKTemp);
      this.ClearRowACRateKG2D();
    }
  }
  ClearRowACRateKG2D() {
    this._FromACKG2D = "";
    this._ToACKG2D = "";
    this._RateACKG2D = "";
  }
  onDocumentClearMail() {
    this.currentFileContract = null;
  }
  CancelPreQuote() {
    this.router.navigate(['/vprequote']);
  }
  OnInTimeDateSelect(event) {
    this.minDate = event;
  }



  Remove_ArticleWayBill(RowIndex) {
    if (this._ArticleList.length > 1) {
      var index = this._ArticleList.indexOf(RowIndex);
      this._ArticleList.splice(index, 1)
    }
    else {
      var index = this._ArticleList.indexOf(RowIndex);
      this._ArticleList.splice(index, 1);
    }
  }
  Remove_KGListWayBil(RowIndex) {
    if (this._KGList.length > 1) {
      var index = this._KGList.indexOf(RowIndex);
      this._KGList.splice(index, 1)
    }
    else {
      var index = this._KGList.indexOf(RowIndex);
      this._KGList.splice(index, 1);
    }
  }
  OpenTemplate() {

  }

  ChangeAccuired(event) {
    var AccuireCode = event.value
    // alert(AccuireCode)
    if (AccuireCode == "MSC00039") {
      this.hideAgent = false
    }
    else {
      this.hideAgent = true
    }
  }

  GetPODRequirements(event) {
    var PODCode = "";
    var PODName = "";
    //var ServiceLocationsName = "";
    var selectedPOD = event.value
    for (var i = 0; i < selectedPOD.length; i++) {
      if (PODCode == "") {
        PODCode = selectedPOD[i];
        // TierName = selectedTier[i].metasubdescription;
        //ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        PODCode = PODCode + "," + selectedPOD[i]
        // TierName = TierName + "," + selectedTier[i].metasubdescription;
        //ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempPODCode = PODCode
    // this._TempTierName = TierCode
  }
  onBasicUploadAuto(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
  }

  exportExcelTradeInside() {
    let CompanyList = this.GetTradeReferenceInsideList();
    this.exportUtility.exportExcel(CompanyList, 'Trade Reference - With in The Company', 'xlsx');
  }
  GetTradeReferenceInsideList() {
    let CompanyList = [];
    this.WithinCompanyList.forEach(element => {
      let volumelist: any = {};
      volumelist["Name"] = element.personName;
      volumelist["Designation"] = element.designation;
      volumelist["Email"] = element.emailId;
      volumelist["Phone Number"] = element.phoneNo;
      volumelist["Previouse Experience"] = element.experience;
      volumelist["Comment of the company"] = element.remarks;

      CompanyList.push(volumelist);
    });
    return CompanyList;
  }

  exportExcelTradeOutside() {
    let CompanyList = this.GetTradeReferenceOutsideList();
    this.exportUtility.exportExcel(CompanyList, 'Trade Reference - Outside The Company', 'xlsx');
  }
  GetTradeReferenceOutsideList() {
    let CompanyList = [];
    this.outsideCompanyList.forEach(element => {
      let volumelist: any = {};
      volumelist["Name"] = element.personName;
      volumelist["Designation"] = element.designation;
      volumelist["Email"] = element.emailId;
      volumelist["Phone Number"] = element.phoneNo;
      volumelist["Previouse Experience"] = element.experience;
      volumelist["Comment of the company"] = element.remarks;

      CompanyList.push(volumelist);
    });
    return CompanyList;
  }
  exportExcelVolume() {
    let VolumeList = this.GetVolimeList();
    this.exportUtility.exportExcel(VolumeList, 'Volume Distribution', 'xlsx');
  }
  GetVolimeList() {
    let VolumeDistrubutionList = [];
    this.SUKVolumeDistrubutionList.forEach(element => {
      let DistrubutionList: any = {};
      DistrubutionList["Hub"] = element.Hub;
      DistrubutionList["% of Qty"] = element.VolumeDistributionPercentage;
      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      VolumeDistrubutionList.push(DistrubutionList);
    });
    return VolumeDistrubutionList;
  }
  exportExcelSKU() {
    let SKU = this.GetExcelSKUList();
    this.exportUtility.exportExcel(SKU, 'SKU', 'xlsx');
  }
  GetExcelSKUList() {
    let SKUDistrubutionList = [];
    this.SUKList.forEach(element => {
      let SKUGridList: any = {};
      SKUGridList["Type"] = element.SkuType;
      SKUGridList["UOM"] = element.SkuUom;
      SKUGridList["L"] = element.SkuLength;
      SKUGridList["B"] = element.SkuBreadth;
      SKUGridList["H"] = element.SkuHeight;
      SKUGridList["Weight Based On"] = element.CftBasedOn;
      SKUGridList["Weight"] = element.CftWeight;
      SKUGridList["% Of Contributions"] = element.ContributionPercentage;

      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      SKUDistrubutionList.push(SKUGridList);
    });
    return SKUDistrubutionList;
  }
  exportExcelSpecial() {
    let SpecialList = this.GetExcelSpecialList();
    this.exportUtility.exportExcel(SpecialList, 'Special Delivery', 'xlsx');
  }
  GetExcelSpecialList() {
    let SpecialList = [];
    this.SpecialDeliveryList.forEach(element => {
      let DeliveryList: any = {};
      DeliveryList["Special Delivery"] = element.SpecialDeliverytype;
      DeliveryList["Consignee Name"] = element.contactPerson;
      DeliveryList["Mobile No"] = element.MobileNo;
      DeliveryList["Email ID"] = element.EmailID;
      DeliveryList["Address"] = element.Address;
      DeliveryList["Floor"] = element.Floortype;
      DeliveryList["PinCode"] = element.pincode;
      DeliveryList["Pincode Location"] = element.PincodeLocation;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      SpecialList.push(DeliveryList);
    });
    return SpecialList;
  }
  ExportExcelWaybill() {
    let WayBillList = this.GetExcelWaybillList();
    this.exportUtility.exportExcel(WayBillList, 'Waybill & Other Charges', 'xlsx');
  }
  GetExcelWaybillList() {
    let WaybillList = [];
    this.WayBillList.forEach(element => {
      let WaybillHeadList: any = {};
      WaybillHeadList["Charges type"] = element.chargecodeName;
      WaybillHeadList["Charges Code"] = element.chargeratetype;
      WaybillHeadList["Charge Rate Type"] = element.chargeratetype;
      WaybillHeadList["Value"] = element.adrate;
      WaybillHeadList["Inclusive / exclusive"] = element.inclusiveorexclusive;
      WaybillHeadList["Print in Other Charges"] = element.printinothercharge;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      WaybillList.push(WaybillHeadList);
    });
    return WaybillList;
  }

  GetExcelRegionList() {
    let RegionList = [];
    this._RegionList.forEach(element => {
      let RegionGridList: any = {};
      RegionGridList["From Branch"] = element.frombranch;
      RegionGridList["To Region"] = element.toregion;
      RegionGridList["Article"] = element.article;
      RegionGridList["Rate Type"] = element.ratetype;
      RegionGridList["Rate"] = element.rate;
      RegionGridList["DC Rate Type"] = element.dcratetype;
      RegionGridList["DC Rate"] = element.dcrate;
      RegionGridList["DD Rate"] = element.ddratetype;
      RegionGridList["Article Charge Code"] = element.acratetype;
      RegionGridList["AC Rate"] = element.acrate;
      RegionGridList["Add on Charges"] = element.inclusiveorexclusive;
      RegionGridList["Reverse Booking"] = element.isneedreversebooking;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      RegionList.push(RegionGridList);
    });
    return RegionList;
  }

  GetExcelArticleList() {
    let ArticleList = [];
    this._ArticleBasedList.forEach(element => {
      let ArticleBased: any = {};
      ArticleBased["From Branch"] = element.frombranch;
      ArticleBased["To Region"] = element.tobranch;
      ArticleBased["Article"] = element.article;
      ArticleBased["Rate Type"] = element.ratetype;
      ArticleBased["Rate"] = element.rate;
      ArticleBased["DC Rate Type"] = element.dcratetype;
      ArticleBased["DC Rate"] = element.dcrate;
      ArticleBased["DD Rate Type"] = element.ddratetype;
      ArticleBased["DD Rate"] = element.ddrate;
      ArticleBased["Article Charge Code"] = element.acratetype;
      ArticleBased["AC Rate"] = element.acrate;
      ArticleBased["Add on Charges"] = element.inclusiveorexclusive;
      ArticleBased["Reverse Booking"] = element.isneedreversebooking;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      ArticleList.push(ArticleBased);
    });
    return ArticleList;
  }

  exportExcelSlab() {
    let ArticleList = this.GetExcelSlabList();
    this.exportUtility.exportExcel(ArticleList, 'Slab', 'xlsx');
  }
  GetExcelSlabList() {
    let SlabList = [];
    this._SlabFormList.forEach(element => {
      let SlabBased: any = {};
      SlabBased["From Branch"] = element.frombranch;
      SlabBased["To Branch"] = element.tobranch;
      SlabBased["Article"] = element.article;
      SlabBased["Rate Type"] = element.ratetype;
      SlabBased["Rate"] = element.rate;
      SlabBased["DC Rate Type"] = element.dcratetype;
      SlabBased["DC Rate"] = element.dcrate;
      SlabBased["DD Rate Type"] = element.ddratetype;
      SlabBased["DD Rate"] = element.ddrate;
      SlabBased["Article Charge Code"] = element.acratetype;
      SlabBased["AC Rate"] = element.acrate;
      SlabBased["Add on Charges"] = element.inclusiveorexclusive;
      SlabBased["Reverse Booking"] = element.isneedreversebooking;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      SlabList.push(SlabBased);
    });
    return SlabList;
  }
  exportExcel2DList() {
    let TwoDList = this.Get2DList();
    this.exportUtility.exportExcel(TwoDList, '2D List', 'xlsx');
  }
  Get2DList() {
    let TwoDimensionList = [];
    this._2DList.forEach(element => {
      let TwoDBased: any = {};
      TwoDBased["From Branch"] = element.frombranch;
      TwoDBased["To KM"] = element.toregion;
      TwoDBased["Article"] = element.article;
      TwoDBased["Rate Type"] = element.ratetype;
      TwoDBased["Rate"] = element.rate;
      TwoDBased["DC Rate Type"] = element.dcratetype;
      TwoDBased["DC Rate"] = element.dcrate;
      TwoDBased["DD Rate Type"] = element.ddratetype;
      TwoDBased["DD Rate"] = element.ddrate;
      TwoDBased["Article Charge Code"] = element.acratetype;
      TwoDBased["AC Rate"] = element.acrate;
      TwoDBased["Add on Charges"] = element.inclusiveorexclusive;
      TwoDBased["Reverse Booking"] = element.isneedreversebooking;
      TwoDimensionList.push(TwoDBased);
    });
    return TwoDimensionList;
  }

  onChangeDCRateTypeSlab() {

  }

  showBasicDialogDCRateSlab() {
    if (this._SlabForm.get("dcratetypecode").value == 'MSC00098' || this._SlabForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRateSlab = true;
      if (this._SlabForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRateSP = this._SlabForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("dcratetypecode").value == 'MSC00099' || this._SlabForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKGSlab = true;
      if (this._SlabForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRateSP = this._SlabForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00099';
        this._DCKGAdditionalRateSP = '';
      }
    }

  }

  onChangeDDRateTypeSlab() {

  }
  showBasicDialogDDRateSlab() {
    if (this._SlabForm.get("ddratetypecode").value == 'MSC00095' || this._SlabForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRateSlab = true;
      if (this._SlabForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRateSP = this._SlabForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("ddratetypecode").value == 'MSC00096' || this._SlabForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKGSlab = true;
      if (this._SlabForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00630';
        this._DDKGAdditionalRateSP = this._SlabForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00096';
        this._DDKGAdditionalRateSP = '';
      }
    }

  }

  showBasicDialogACRateSlab() {

    //this.displayACRateKGSlab=true;
    if (this._SlabForm.get("acratetypecode").value == 'MSC00635') {
      this.displayACRateSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00635') {
        this.HideACPieceAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00635';
        this._ACPieceAdditionalRateSP = this._SlabForm.get("acrate").value
      }
      else {
        this.HideACPieceAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("acratetypecode").value == 'MSC00634') {
      this.displayACRateKGSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00634';
        this._ACKGAdditionalRateSP = this._SlabForm.get("acrate").value
      }
      else {
        this.HideACKGAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateSP = '';
      }
    }
  }

  addRowSlab() {
    this._SlabFormsubmitted = true;
    if (this._SlabForm.valid) {
      for (var i = 0; i < this._SlabFormList.length; i++) {
        if (this._SlabFormList[i].frombranchcode == this._SlabForm.get("frombranchcode").value) {
          if (this._SlabFormList[i].tobranchcode == this._SlabForm.get("tobranchcode").value) {
            if (this._SlabFormList[i].articlecode == this._SlabForm.get("articlecode").value) {
              this._CustomExceptionService.handleWarning("The Record is Already Exists");
              return;
            }
          }
        }
      }

      var _SlabFormListTemp: any = {};
      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;
      _SlabFormListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _SlabFormListTemp.frombranchcode = this._SlabForm.get("frombranchcode").value;
      _SlabFormListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _SlabFormListTemp.frombranchcode)[0].branchname;
      _SlabFormListTemp.tobranchcode = this._SlabForm.get("tobranchcode").value;
      _SlabFormListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _SlabFormListTemp.tobranchcode)[0].branchname;
      _SlabFormListTemp.articlecode = this._SlabForm.get("articlecode").value;
      _SlabFormListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _SlabFormListTemp.articlecode)[0].articlename;
      _SlabFormListTemp.ratetypecode = this._SlabForm.get("ratetypecode").value;
      _SlabFormListTemp.ratetype = (this._SlabType || []).filter(f => f.metasubcode == _SlabFormListTemp.ratetypecode)[0].metasubdescription;
      _SlabFormListTemp.rate = this._SlabForm.get("rate").value;
      _SlabFormListTemp.dcratetypecode = this._SlabForm.get("dcratetypecode").value;
      _SlabFormListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _SlabFormListTemp.dcratetypecode)[0].metasubdescription;
      _SlabFormListTemp.dcrate = this._SlabForm.get("dcrate").value;
      _SlabFormListTemp.ddratetypecode = this._SlabForm.get("ddratetypecode").value;
      _SlabFormListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _SlabFormListTemp.ddratetypecode)[0].metasubdescription;
      _SlabFormListTemp.ddrate = this._SlabForm.get("ddrate").value;
      _SlabFormListTemp.acratetypecode = this._SlabForm.get("acratetypecode").value;
      _SlabFormListTemp.acratetype = this._SlabForm.get("acratetype").value;
      _SlabFormListTemp.acrate = this._SlabForm.get("acrate").value;
      _SlabFormListTemp.addoninclusiveorexclusivecode = this._SlabForm.get("inclusiveorexclusivecode").value;
      _SlabFormListTemp.addoninclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _SlabFormListTemp.addoninclusiveorexclusivecode)[0].metasubdescription;
      _SlabFormListTemp.isneedreversebooking = this._SlabForm.get("isneedreversebooking").value || false;
      _SlabFormListTemp.isneedreversebookingcode = this._SlabForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      _SlabFormListTemp.dcinclusiveorexclusivecode = this._SlabForm.get("dcinclusiveorexclusivecode").value;
      _SlabFormListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _SlabFormListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      _SlabFormListTemp.ddinclusiveorexclusivecode = this._SlabForm.get("ddinclusiveorexclusivecode").value;
      _SlabFormListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _SlabFormListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;
      _SlabFormListTemp.effectivefrom = _contractfromDate;
      _SlabFormListTemp.effectiveto = _contracttoDate;

      /* _SlabFormListTemp._DCKG = this._DCKGSlab;
       _SlabFormListTemp._DDKG = this._DDKGSlab;
       _SlabFormListTemp._DDPiece = this._DDPieceSlab;
       _SlabFormListTemp._DCPiece = this._DCPieceSlab;
       _SlabFormListTemp._ACKG = this._ACKGSlab;    
       _SlabFormListTemp._ACPiece = this._ACPieceSlab;
       _SlabFormListTemp._SlabKG = this._KGSlab;    
       _SlabFormListTemp._SlabPiece = this._PieceSlab;*/

      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []

      var rateslabtypecode = this._SlabForm.get("ratetypecode").value;
      var dcslabtypecode = this._SlabForm.get("dcratetypecode").value;
      var ddslabtypecode = this._SlabForm.get("ddratetypecode").value;
      var acslabtypecode = this._SlabForm.get("acratetype").value;
      if (this._DCPieceSlab.length > 0) {
        for (var i = 0; i < this._DCPieceSlab.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabtypecode = dcslabtypecode;
          _tempDCPiece.slabfrom = this._DCPieceSlab[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceSlab[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGSlab.length > 0) {
        for (var i = 0; i < this._DCKGSlab.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00084";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabtypecode = dcslabtypecode;
          _tempDCKG.slabfrom = this._DCKGSlab[i].FromPiece;
          _tempDCKG.slabto = this._DCKGSlab[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceSlab.length > 0) {
        for (var i = 0; i < this._DDPieceSlab.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00084";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabtypecode = ddslabtypecode;
          _tempDDPiece.slabfrom = this._DDPieceSlab[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceSlab[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGSlab.length > 0) {
        for (var i = 0; i < this._DDKGSlab.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00084";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabtypecode = ddslabtypecode;
          _tempDDKG.slabfrom = this._DDKGSlab[i].FromPiece;
          _tempDDKG.slabto = this._DDKGSlab[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPieceSlab.length > 0) {
        for (var i = 0; i < this._ACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabtypecode = acslabtypecode;
          _tempACPiece.slabfrom = this._ACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKGSlab.length > 0) {
        for (var i = 0; i < this._ACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabtypecode = acslabtypecode;
          _tempACKG.slabfrom = this._ACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._ACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._ACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      if (this._PieceSlab.length > 0) {
        for (var i = 0; i < this._PieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttype = 'MSC00084';
          _tempACPiece.contracttypecode = 'MSC00084';
          _tempACPiece.slabtypecode = rateslabtypecode;
          _tempACPiece.slabfrom = this._PieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._PieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._PieceSlab[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KGSlab.length > 0) {
        for (var i = 0; i < this._KGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KGSlab[i].FromPiece;
          _tempACKG.slabto = this._KGSlab[i].ToPiece;
          _tempACKG.slabrate = this._KGSlab[i].Rate;
          _tempACKG.slabtypecode = rateslabtypecode;
          _tempACKG.contracttype = 'MSC00084';
          _tempACKG.contracttypecode = 'MSC00084';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      _SlabFormListTemp.lstRateSlabs = _lstRateSlabsTemp;
      _SlabFormListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      this._SlabFormList.push(_SlabFormListTemp);
      this.ClearRowSlab();
    }
  }


  selectArticleBasedFile(event) {
    this.ArticleselectedFiles = event.target.files;
    this.ValidateArticle = false
  }
  ArticleBasedupload() {
    this.currentFile = this.ArticleselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempArticlelList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempArticlelList_.length; i++) {
        var _FromBranch = this.TempArticlelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          var _ToBranch = this.TempArticlelList_[i].ToBranch
          var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
          if (ToBranch.length > 0) {
            var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].ToBranch + "'" + " To Branch Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }

          var _ArticleName = this.TempArticlelList_[i].Article
          var ArticleName = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase())[0].skuId;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].Article + "'" + " Article Name Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }

          var _RatePerQuintal = this.TempArticlelList_[i].RatePerQuintal
          if (_RatePerQuintal >= 0) {
            var RatePerQuintalCode_ = _RatePerQuintal;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].RatePerQuintal + "'" + " RatePerQuintal is Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }

          var _Distance = this.TempArticlelList_[i].Distance
          if (_Distance >= 0) {
            var DistanceCode_ = _Distance;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].Distance + "'" + " Distance is Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }




          var _ACRateType = this.TempArticlelList_[i].ArticleChargeCode
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].ArticleChargeCode + "'" + " AC Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }

          var _RateType = this.TempArticlelList_[i].RateType
          var RateType = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
          if (RateType.length > 0) {
            var RateTypeCode_ = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }
          var _DCRateType = this.TempArticlelList_[i].DCRateType
          var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }
          var _DDRateType = this.TempArticlelList_[i].DDRateType
          var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }
          var _AddonCharge = this.TempArticlelList_[i].AddonCharges
          var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarArticle.nativeElement.value = "";
          this.ValidateArticle = true
          return;
        }

        var _DCCharge = this.TempArticlelList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
        if (DCCharge.length > 0) {
          var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DCCharges + "'" + " DC Charge Invalid.");
          this.InputVarArticle.nativeElement.value = "";
          this.ValidateArticle = true
          return;
        }

        var _DDCharge = this.TempArticlelList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        if (DDCharge.length > 0) {
          var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DDCharges + "'" + " DD Charge Invalid.");
          this.InputVarArticle.nativeElement.value = "";
          this.ValidateArticle = true
          return;
        }

      }
      for (var i = 0; i < this.TempArticlelList_.length; i++) {
        var ArticleTemp: any = {};
        var _FromBranch = this.TempArticlelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        var _ToBranch = this.TempArticlelList_[i].ToBranch
        var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
        var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;


        var _ArticleName = this.TempArticlelList_[i].Article
        var ArticleName = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase());
        var ArticleNameCode_ = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase())[0].skuId;

        var _RatePerQuintal = this.TempArticlelList_[i].RatePerQuintal
        var RatePerQuintalCode_ = _RatePerQuintal;

        var _Distance = this.TempArticlelList_[i].Distance
        var DistanceCode_ = _Distance;


        var _ACRateType = this.TempArticlelList_[i].ArticleChargeCode
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;

        var _RateType = this.TempArticlelList_[i].RateType
        var RateType = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
        var RateTypeCode_ = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;

        var _DCRateType = this.TempArticlelList_[i].DCRateType
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;

        var _DDRateType = this.TempArticlelList_[i].DDRateType
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;

        var _AddonCharge = this.TempArticlelList_[i].AddonCharges
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());

        var _DCCharge = this.TempArticlelList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempArticlelList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;

        var ReverseBookingcode;
        if (this.TempArticlelList_[i].ReverseBooking == "true") {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        ArticleTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        ArticleTemp.frombranch = _FromBranch;
        ArticleTemp.tobranch = _ToBranch;
        ArticleTemp.frombranchcode = FromBranchCode_;
        ArticleTemp.tobranchcode = ToBranchCode_;
        ArticleTemp.article = _ArticleName;
        ArticleTemp.articlecode = ArticleNameCode_;
        ArticleTemp.ratetype = _RateType
        ArticleTemp.ratetypecode = RateTypeCode_
        ArticleTemp.rate = this.TempArticlelList_[i].Rate
        ArticleTemp.finalrate = this.TempArticlelList_[i].Rate
        ArticleTemp.dcratetype = _DCRateType
        ArticleTemp.ddratetype = _DDRateType
        ArticleTemp.dcratetypecode = DCRateTypeCode_
        ArticleTemp.ddratetypecode = DDRateTypeCode_
        ArticleTemp.acratetypecode = ACRateTypeCode_
        ArticleTemp.acratetype = _ACRateType
        ArticleTemp.acrate = ACRate
        ArticleTemp.dcinclusiveorexclusive = _DCCharge
        ArticleTemp.dcinclusiveorexclusivecode = DCChargeCode_
        ArticleTemp.ddinclusiveorexclusive = _DDCharge
        ArticleTemp.ddinclusiveorexclusivecode = DDChargeCode_
        ArticleTemp.inclusiveorexclusive = _AddonCharge
        ArticleTemp.inclusiveorexclusivecode = AddonChargeCode_
        ArticleTemp.isneedreversebooking = this.TempArticlelList_[i].ReverseBooking
        ArticleTemp.isneedreversebookingcode = ReverseBookingcode;
        ArticleTemp.quintalRateperKM = RatePerQuintalCode_;
        ArticleTemp.distance = DistanceCode_;

        var _lstAddOnSlabsTemp = []
        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          ArticleTemp.dcrate = '';
        }
        else {
          ArticleTemp.dcrate = this.TempArticlelList_[i].DCRate
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          ArticleTemp.ddrate = '';
        }
        else {
          ArticleTemp.ddrate = this.TempArticlelList_[i].DDRate
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        ArticleTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        this._ArticleBasedList.push(ArticleTemp);
      }
    }


  }



  select2DRateFile(event) {
    this.DDselectedFiles = event.target.files;
    this.ValidateDD = false;
  }
  TwoDRateupload() {
    this.currentFile = this.DDselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempDDList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempDDList_.length; i++) {
        var _FromBranch = this.TempDDList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          // var _ToBranch = this.TempDDList_[i].ToBranch
          // var ToBranch = (this._BillingBranch).filter(f => f.branchname == _ToBranch);
          // if (ToBranch.length > 0) {
          //   var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname == _ToBranch)[0].branchcode;
          // }

          var _ArticleName = this.TempDDList_[i].Article
          var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].Article + "'" + " Article Name Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true
            return;
          }

          var _SlabType = this.TempDDList_[i].RateType
          var SlabType = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
          if (SlabType.length > 0) {
            var SlabTypeCode_ = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true
            return;
          }
          var _DCRateType = this.TempDDList_[i].DCRateType
          var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true
            return;
          }
          var _DDRateType = this.TempDDList_[i].DDRateType
          var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true
            return;
          }
          var _ACRateType = this.TempDDList_[i].ArticleChargeCode
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].ArticleChargeCode + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateDD = true
            return;
          }
          var _AddonCharge = this.TempDDList_[i].AddonCharges
          var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarDDRate.nativeElement.value = "";
          this.ValidateDD = true
          return;
        }

        var _DCCharge = this.TempDDList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
        if (DCCharge.length > 0) {
          var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DCCharges + "'" + " DC Charge Invalid.");
          this.InputVarDDRate.nativeElement.value = "";
          this.ValidateDD = true
          return;
        }

        var _DDCharge = this.TempDDList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        if (DDCharge.length > 0) {
          var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DDCharges + "'" + " DD Charge Invalid.");
          this.InputVarDDRate.nativeElement.value = "";
          this.ValidateDD = true
          return;
        }

      }

      for (var i = 0; i < this.TempDDList_.length; i++) {

        var DDListTemp: any = {};

        var _FromBranch = this.TempDDList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        // if (FromBranch.length > 0) {
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        // var _ToBranch = this.TempDDList_[i].ToBranch
        // var ToBranch = (this._BillingBranch).filter(f => f.branchname == _ToBranch);
        // if (ToBranch.length > 0) {
        //   var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname == _ToBranch)[0].branchcode;
        // }

        var _ArticleName = this.TempDDList_[i].Article
        var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
        // if (ArticleName.length > 0) {
        var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].Article + "'" + " Article Name Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _SlabType = this.TempDDList_[i].RateType
        var SlabType = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
        // if (SlabType.length > 0) {
        var SlabTypeCode_ = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].RateType + "'" + " Rate Type Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DCRateType = this.TempDDList_[i].DCRateType
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        // if (DCRateType.length > 0) {
        var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DDRateType = this.TempDDList_[i].DDRateType
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        // if (DDRateType.length > 0) {
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _ACRateType = this.TempDDList_[i].ArticleChargeCode
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
        //if (DDRateType.length > 0) {
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;

        var _AddonCharge = this.TempDDList_[i].AddonCharges
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());

        var _DCCharge = this.TempDDList_[i].DCCharge
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempDDList_[i].DDCharge
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        // if (AddonCharge.length > 0) {
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].FromBranch + "'" + " From Branch Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var ReverseBookingcode;
        if (this.TempDDList_[i].ReverseBooking == "true") {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        DDListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        DDListTemp.frombranch = _FromBranch;
        DDListTemp.toKM = this.TempDDList_[i].ToKM

        DDListTemp.frombranchcode = FromBranchCode_;

        DDListTemp.article = _ArticleName;
        DDListTemp.articlecode = ArticleNameCode_;
        DDListTemp.ratetype = _SlabType
        DDListTemp.ratetypecode = SlabTypeCode_
        DDListTemp.rate = this.TempDDList_[i].Rate
        DDListTemp.dcratetype = _DCRateType
        DDListTemp.ddratetype = _DDRateType

        DDListTemp.dcratetypecode = DCRateTypeCode_
        DDListTemp.ddratetypecode = DDRateTypeCode_
        DDListTemp.acratetypecode = ACRateTypeCode_
        DDListTemp.acratetype = _ACRateType
        DDListTemp.acrate = ACRate

        DDListTemp.dcinclusiveorexclusive = _DCCharge
        DDListTemp.dcinclusiveorexclusivecode = DCChargeCode_
        DDListTemp.ddinclusiveorexclusive = _DDCharge
        DDListTemp.ddinclusiveorexclusivecode = DDChargeCode_

        DDListTemp.inclusiveorexclusive = _AddonCharge
        DDListTemp.inclusiveorexclusivecode = AddonChargeCode_
        DDListTemp.isneedreversebooking = this.TempDDList_[i].ReverseBooking
        DDListTemp.isneedreversebooking = ReverseBookingcode
        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        // this._2DList.push(DDListTemp);
        var _lstAddOnSlabsTemp = []
        var _lstRateSlabsTemp = []
        var _tempDCPie: any = {};
        _tempDCPie.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPie.slabfrom = 1;
        _tempDCPie.slabto = 1;
        _tempDCPie.slabrate = this.TempDDList_[i].Rate;
        _tempDCPie.contracttypecode = 'MSC00104';
        _tempDCPie.contracttype = 'MSC00104';
        _lstRateSlabsTemp.push(_tempDCPie);
        DDListTemp.rate = '';

        DDListTemp.lstRateSlabs = _lstRateSlabsTemp;

        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          DDListTemp.dcrate = '';
        }
        else {
          DDListTemp.dcrate = this.TempDDList_[i].DCRate
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          DDListTemp.ddrate = '';
        }
        else {
          DDListTemp.ddrate = this.TempDDList_[i].DDRate
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        DDListTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        this._2DList.push(DDListTemp);
        this.InputVarDDRate.nativeElement.value = "";
        this.ValidateDD = true
      }
    }



  }
  showBasicDialogACRate2D() {
    if (this._2DForm.get("acratetypecode").value == 'MSC00635') {
      this.displayACRate2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00635') {
        this.HideACPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00635';
        this._ACPieceAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideACPieceAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("acratetypecode").value == 'MSC00634') {
      this.displayACRateKG2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00634';
        this._ACKGAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideACKGAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate2D = '';
      }
    }

  }


  onDocumentSelectContract(event, documentcontract) {
    this._TempcurrentFileContract = event.currentFiles[0]
    if (this._TempcurrentFileContract.size > 3000000) {
      this._CustomExceptionService.handleWarning("Your File size does not exceed 3 MB")
      this._submittedimage = true
      documentcontract.clear()
      return
    }
    this.currentFileContract = event.currentFiles[0];
    this._submittedimage = false
    documentcontract.clear()
    //document.clear();
  }

  onchangecosttocompanyoda() {
    if (this._CostingContract.get("costtocompanyoda").value != "" && this._CostingContract.get("costtocompanyoda").value != "") {
      if (this._CostingContract.get("costtocompanyoda").value <= 100) {
        this._CostingContract.controls['costtoagentoda'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanyoda").value));
      }
      else {
        this._CostingContract.controls['costtocompanyoda'].setValue(0);
        this._CostingContract.controls['costtoagentoda'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentoda'].setValue(100);
    }
  }

  onchangecosttocompanyDC() {
    if (this._CostingContract.get("costtocompanydc").value != "" && this._CostingContract.get("costtocompanydc").value != "") {
      if (this._CostingContract.get("costtocompanydc").value <= 100) {
        this._CostingContract.controls['costtoagentdc'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanydc").value));
      }
      else {
        this._CostingContract.controls['costtocompanydc'].setValue(0);
        this._CostingContract.controls['costtoagentdc'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentdc'].setValue(100);
    }
  }

  goBack(event) {
    this.router.navigate(['/vprequote']);
  }

  addRowDCRateKG() {
    if (this._FromDCKG != "" && this._ToDCKG != "" && this._RateDCKG != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKG;
      _DCPieceGKTemp.ToPiece = this._ToDCKG;
      _DCPieceGKTemp.Rate = this._RateDCKG;
      this._DCKG.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG();
    }
  }

  formconverstionContract(documents: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:

    var _ContractOBJ = {
      "CustomerContract": this.CustomerSiteContractList,
    };
    this._ContractOBJ = {
      "CustomerContract": this.CustomerSiteContractList,
    };
    var _ContractFD = JSON.stringify(_ContractOBJ);
    formData.append('strCustomerContract', _ContractFD);
    return (formData);
  }

  CustomerContractSubmit() {
    
      this.CustomerSiteContractList = this._CostingContract.value;

      var _contractfromDate = this._CostingContract.get("contractfromdate").value;
      var _contracttoDate = this._CostingContract.get("contracttodate").value;


      if (this.currentFileContract != null) {
        this.CustomerSiteContractList.communicationmaildocumentURL = this.currentFileContract.name;
      }
      var lstGeneralContract: any = [];
      var TemplstGeneralContract: any = {};

      /*General Contract Save*/
      if (this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value != null && this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value != null) {
        TemplstGeneralContract.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        TemplstGeneralContract.rateperqtlperkm = this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value;
        TemplstGeneralContract.odacalculationmodecode = this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value;
        TemplstGeneralContract.odacalculationmode = (this._ODACalculationMode || []).filter(f => f.metasubcode == TemplstGeneralContract.odacalculationmodecode)[0].metasubdescription;
        lstGeneralContract.push(TemplstGeneralContract);
        this.CustomerSiteContractList.lstGeneralContract = lstGeneralContract;
      }
      /*Regional Contract Save*/
      this.CustomerSiteContractList.lstRegionContract = this._RegionList;

      /* Article Contract Save*/
      if (this._Articleselectedrows.length == 0) {

      }
      else {
        this._TEMPArticleBasedList = []
        if (this._Articleselectedrows.length > 0) {
          Object.keys(this._Articleselectedrows).map((Index) => {
            var currentRow = this._Articleselectedrows[Index];

            var _ArticleBaseListTemp: any = {};
            _ArticleBaseListTemp.tobranchcode = currentRow.tobranchcode
            _ArticleBaseListTemp.tobranch = currentRow.tobranch
            _ArticleBaseListTemp.customersitecode = currentRow.customersitecode
            _ArticleBaseListTemp.frombranchcode = currentRow.frombranchcode
            _ArticleBaseListTemp.frombranch = currentRow.frombranch
            _ArticleBaseListTemp.articlecode = currentRow.articlecode
            _ArticleBaseListTemp.article = currentRow.article
            _ArticleBaseListTemp.ratetypecode = currentRow.ratetypecode
            _ArticleBaseListTemp.ratetype = currentRow.ratetype
            _ArticleBaseListTemp.dcratetypecode = currentRow.dcratetypecode
            _ArticleBaseListTemp.dcratetype = currentRow.dcratetype
            _ArticleBaseListTemp.dcrate = currentRow.dcrate
            _ArticleBaseListTemp.ddratetypecode = currentRow.ddratetypecode
            _ArticleBaseListTemp.ddratetype = currentRow.ddratetype
            _ArticleBaseListTemp.ddrate = currentRow.ddrate
            _ArticleBaseListTemp.acratetypecode = currentRow.acratetypecode
            _ArticleBaseListTemp.acratetype = currentRow.acratetype
            _ArticleBaseListTemp.acrate = currentRow.acrate
            _ArticleBaseListTemp.addoninclusiveorexclusivecode = currentRow.addoninclusiveorexclusivecode
            _ArticleBaseListTemp.addoninclusiveorexclusive = currentRow.addoninclusiveorexclusive
            _ArticleBaseListTemp.dcinclusiveorexclusivecode = currentRow.dcinclusiveorexclusivecode
            _ArticleBaseListTemp.dcinclusiveorexclusive = currentRow.dcinclusiveorexclusive
            _ArticleBaseListTemp.ddinclusiveorexclusivecode = currentRow.ddinclusiveorexclusivecode
            _ArticleBaseListTemp.ddinclusiveorexclusive = currentRow.ddinclusiveorexclusive
            _ArticleBaseListTemp.isneedreversebooking = currentRow.isneedreversebooking
            _ArticleBaseListTemp.isneedreversebookingcode = currentRow.isneedreversebookingcode
            _ArticleBaseListTemp.rate = currentRow.rate
            _ArticleBaseListTemp.finalrate = currentRow.finalrate
            _ArticleBaseListTemp.discount = currentRow.discount

            _ArticleBaseListTemp.distance = currentRow.distance
            _ArticleBaseListTemp.quintalRateperKM = currentRow.quintalRateperKM
            _ArticleBaseListTemp.effectivefrom = currentRow.effectivefrom
            _ArticleBaseListTemp.effectiveto = currentRow.effectiveto
            _ArticleBaseListTemp.lstDCDDACSlabs = currentRow.lstDCDDACSlabs;
            this._TEMPArticleBasedList.push(_ArticleBaseListTemp);

          })
        }
      }

      this.CustomerSiteContractList.lstArticleContract = this._TEMPArticleBasedList;

      /* Slab Contract Save*/
      this.CustomerSiteContractList.lstSlabContract = this._SlabFormList;
      /* 2D Contract Save*/
      this.CustomerSiteContractList.lstTwoDContract = this._2DList;
      /* Waybill Heads/ AddOn Contract Save*/
      this.CustomerSiteContractList.lstAddOnCharge = this.WayBillList;


      if (this.currentFileContract != null) {
        this._selectedDocumentsContract.push(this.currentFileContract);
      }
      this._selectedDocumentsContract = null;
      var CustomerContract = this.formconverstionContract(this._selectedDocumentsContract);
      var _errorflag = 0;
      if (this.CustomerSiteContractList.billingbranchcode == null || this.IsNullOrEmpty(this.CustomerSiteContractList.billingbranchcode)) {
        this._CustomExceptionService.handleError("Please Select Billing Branch");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.costtoagentac == null || this.IsNullOrEmpty((this.CustomerSiteContractList.costtoagentac).toString())) {
        this._CustomExceptionService.handleError("Please Enter AC Cost to Agent");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.costtoagentdc == null || this.IsNullOrEmpty((this.CustomerSiteContractList.costtoagentdc).toString())) {
        this._CustomExceptionService.handleError("Please Enter DC Cost to Agent");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.costtoagentdd == null || this.IsNullOrEmpty((this.CustomerSiteContractList.costtoagentdd).toString())) {
        this._CustomExceptionService.handleError("Please Enter DD Cost to Agent");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.costtocompanyac == null || this.IsNullOrEmpty((this.CustomerSiteContractList.costtocompanyac).toString())) {
        this._CustomExceptionService.handleError("Please Enter AC Cost to Company");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.costtocompanydd == null || this.IsNullOrEmpty((this.CustomerSiteContractList.costtocompanydd).toString())) {
        this._CustomExceptionService.handleError("Please Enter DD Cost to Company");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.fuelpriceperltr == null || this.IsNullOrEmpty((this.CustomerSiteContractList.fuelpriceperltr).toString())) {
        this._CustomExceptionService.handleError("Please Enter Fuel Price Per Ltr");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minarticledd == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minarticledd).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum Article DD");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minimumac == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minimumac).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum AC");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minimumchargeableweight == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minimumchargeableweight).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum Chargable Weight");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minimumdc == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minimumdc).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum DC");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minimumdd == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minimumdd).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum DD");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minimumfreight == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minimumfreight).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum Freight Charges");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.minimumvsc == null || this.IsNullOrEmpty((this.CustomerSiteContractList.minimumvsc).toString())) {
        this._CustomExceptionService.handleError("Please Enter Minimum VSC");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.quotedrateperqtlperkm == null || this.IsNullOrEmpty((this.CustomerSiteContractList.quotedrateperqtlperkm).toString())) {
        this._CustomExceptionService.handleError("Please Enter Quoted Qtl Per KM");
        _errorflag = 1;
      }
      if (this.CustomerSiteContractList.lstAddOnCharge.length == 0) {
        this._CustomExceptionService.handleError("Please add atleast one Waybill Heads / Other Charges");
        _errorflag = 1;
      }

    if (_errorflag == 0) {

      this._IsProgressSpinner = true;
      this._CustomerContractService.create(CustomerContract).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Customer Contract Sent To Approval");
          this.SubmitClear();
        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }
    
  }







  IsNullOrEmpty(value: string) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
  }


  SubmitClear(){
    this.PageInitalize()
    this._RegionList = []
    this._ArticleBasedList = []
    this._SlabFormList = []
    this._2DList = []
    this.WayBillList = []
  }

  GoToCreate(){
      this.router.navigate(['/ccustomercontract']);
  }
}
